/* eslint-disable */
// This file was automatically generated and should not be edited.
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  OneToOneHundredInt: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type ActivateTaxpayerBankAccountInput = {
  activatedAt?: InputMaybe<Scalars['Date']['input']>;
  autoRenewedContract?: InputMaybe<Scalars['Boolean']['input']>;
  contractExpiredAt?: InputMaybe<Scalars['Date']['input']>;
  contractNo?: InputMaybe<Scalars['String']['input']>;
  fictionlogEarningsRatio?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pintoAppEarningsRatio?: InputMaybe<Scalars['Float']['input']>;
  pintoEarningsRatio?: InputMaybe<Scalars['Float']['input']>;
};

export enum ActiveContentReportType {
  Book = 'book',
  Chapter = 'chapter',
  Ebook = 'ebook'
}

export type AppPriceTier = {
  __typename?: 'AppPriceTier';
  _id: Scalars['ID']['output'];
  platform: AppPriceTierPlatform;
  productId?: Maybe<Scalars['String']['output']>;
  thb: Scalars['Float']['output'];
  usd: Scalars['Float']['output'];
};

export enum AppPriceTierPlatform {
  Apple = 'apple',
  Google = 'google'
}

export type ApproveBankTransferInput = {
  invoiceFile?: InputMaybe<Scalars['String']['input']>;
};

export type ApproveEditEbookInput = {
  optimizedMainPdfFileUrl?: InputMaybe<Scalars['String']['input']>;
  optimizedSamplePdfFileUrl?: InputMaybe<Scalars['String']['input']>;
};

export type Bank = {
  __typename?: 'Bank';
  brand: Scalars['String']['output'];
  code: Scalars['String']['output'];
  iconImageUrl: Scalars['String']['output'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  _id: Scalars['ID']['output'];
  bankBranch?: Maybe<Scalars['String']['output']>;
  bankBranchCode?: Maybe<Scalars['String']['output']>;
  bankBrand: Scalars['String']['output'];
  bankCode: Scalars['String']['output'];
  bankIconImageUrl: Scalars['String']['output'];
  bookPageFileUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  name?: Maybe<Scalars['String']['output']>;
  no?: Maybe<Scalars['String']['output']>;
  omiseRecipientId?: Maybe<Scalars['String']['output']>;
  rejectNote?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type BankTransfer = {
  __typename?: 'BankTransfer';
  _id: Scalars['ID']['output'];
  additionalEarningsThb?: Maybe<Scalars['Float']['output']>;
  additionalGoldCoin?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  earningsThb: Scalars['Float']['output'];
  fee?: Maybe<Scalars['Float']['output']>;
  goldCoin: Scalars['Int']['output'];
  invoiceFileUrl?: Maybe<Scalars['String']['output']>;
  isPremium: Scalars['Boolean']['output'];
  monthlyBankTransfer?: Maybe<MonthlyBankTransfer>;
  monthlyBankTransferId?: Maybe<Scalars['ID']['output']>;
  netThb: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  originalThb: Scalars['Float']['output'];
  paidAt?: Maybe<Scalars['Date']['output']>;
  receiptFileUrl?: Maybe<Scalars['String']['output']>;
  salesReport?: Maybe<SalesReport>;
  slipFileUrl?: Maybe<Scalars['String']['output']>;
  status: BankTransferStatus;
  taxpayerBankAccount?: Maybe<TaxpayerBankAccount>;
  totalEarningsThb: Scalars['Float']['output'];
  type: BankTransferType;
  updatedAt: Scalars['Date']['output'];
  user: User;
  vat?: Maybe<Scalars['Float']['output']>;
  wht?: Maybe<Scalars['Float']['output']>;
  whtCertificateFileUrl?: Maybe<Scalars['String']['output']>;
  whtCertificateId?: Maybe<Scalars['String']['output']>;
};

export type BankTransferConnection = {
  __typename?: 'BankTransferConnection';
  edges: Array<BankTransferEdge>;
  pageInfo: PageInfo;
};

export type BankTransferEdge = {
  __typename?: 'BankTransferEdge';
  cursor: Scalars['String']['output'];
  node: BankTransfer;
};

export enum BankTransferSortBy {
  Created = 'created',
  Paid = 'paid',
  Updated = 'updated'
}

export enum BankTransferStatus {
  Cancelled = 'cancelled',
  Failed = 'failed',
  Pending = 'pending',
  PendingApproval = 'pendingApproval',
  Success = 'success'
}

export enum BankTransferType {
  Auto = 'auto',
  Manual = 'manual'
}

export type BankTransfersFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  isPremiumTaxpayerBankAccount?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  receiptId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<BankTransferSortBy>;
  status?: InputMaybe<BankTransferStatus>;
  type?: InputMaybe<BankTransferType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type BestSeller = {
  __typename?: 'BestSeller';
  _id?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<ContentType>;
  coverImage?: Maybe<Scalars['String']['output']>;
  goldCoinAmount?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BestSellerFilter = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type Book = {
  __typename?: 'Book';
  _id?: Maybe<Scalars['ID']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  bundlePriceTier?: Maybe<Scalars['Int']['output']>;
  bundlePriceTierDetail?: Maybe<Scalars['JSON']['output']>;
  bundlePurchased?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use field categoryTag instead */
  categories?: Maybe<Array<Maybe<Category>>>;
  categoryTag?: Maybe<Tag>;
  chapterCommentsCount?: Maybe<Scalars['Int']['output']>;
  chaptersCount?: Maybe<ChapterCount>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  contentRating?: Maybe<ContentRating>;
  contentRawState?: Maybe<Scalars['JSON']['output']>;
  contentType?: Maybe<ContentType>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  earningsRatio?: Maybe<Scalars['Float']['output']>;
  hasMatureContent?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use field tags instead */
  hashtags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  inLibrariesCount?: Maybe<Scalars['Int']['output']>;
  isTranslated: Scalars['Boolean']['output'];
  latestChapterPublishedAt?: Maybe<Scalars['Date']['output']>;
  placeholderBackgroundColor?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<BookStatus>;
  tags: Array<Tag>;
  title?: Maybe<Scalars['String']['output']>;
  totalPrice?: Maybe<Price>;
  /** @deprecated Use field totalSales instead */
  totalSale?: Maybe<Price>;
  totalSales?: Maybe<Scalars['Int']['output']>;
  translatorName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
  userReviewsCount?: Maybe<UserReviewsCount>;
  viewsCount?: Maybe<Scalars['Int']['output']>;
};

export type BookCategoryInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type BookConnection = {
  __typename?: 'BookConnection';
  edges: Array<BookEdge>;
  pageInfo: PageInfo;
};

export type BookEdge = {
  __typename?: 'BookEdge';
  cursor: Scalars['String']['output'];
  node: Book;
};

export type BookImageInput = {
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type BookPageAd = {
  __typename?: 'BookPageAd';
  _id: Scalars['ID']['output'];
  bookId: Scalars['ID']['output'];
  chapterPageAds: Array<ChapterPageAd>;
  createdAt: Scalars['Date']['output'];
  destinationUrl: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type BookPageAdConnection = {
  __typename?: 'BookPageAdConnection';
  edges: Array<BookPageAdEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BookPageAdEdge = {
  __typename?: 'BookPageAdEdge';
  cursor: Scalars['String']['output'];
  node: BookPageAd;
};

export type BookPageAdsFilter = {
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export enum BookStatus {
  Draft = 'draft',
  Public = 'public',
  Removed = 'removed',
  Suspended = 'suspended'
}

export type BooksFilter = {
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  contentType?: InputMaybe<ContentType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<BooksSortType>;
  status?: InputMaybe<BookStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum BooksSortType {
  Created = 'created',
  LatestChapterPublished = 'latestChapterPublished',
  Popular = 'popular',
  Trending = 'trending',
  Updated = 'updated',
  ViewsCount = 'viewsCount'
}

export type CategoriesFilter = {
  contentType?: InputMaybe<ContentType>;
};

export type Category = {
  __typename?: 'Category';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  gradientColors?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CategoryPickedTag = {
  __typename?: 'CategoryPickedTag';
  categoryTagId?: Maybe<Scalars['Int']['output']>;
  categoryTagName?: Maybe<Scalars['String']['output']>;
  pickedTags?: Maybe<Array<Maybe<PickedTag>>>;
};

export type Chapter = {
  __typename?: 'Chapter';
  _id?: Maybe<Scalars['ID']['output']>;
  book?: Maybe<Book>;
  bookId?: Maybe<Scalars['ID']['output']>;
  chapterCommentsCount?: Maybe<Scalars['Int']['output']>;
  chapterNumber?: Maybe<Scalars['Int']['output']>;
  contentRawState?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  nextChapter?: Maybe<Chapter>;
  price?: Maybe<Price>;
  priceId?: Maybe<Scalars['ID']['output']>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  purchaseStatistic?: Maybe<Scalars['JSON']['output']>;
  purchased?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<ChapterStatus>;
  thumbnailImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
  viewsCount?: Maybe<Scalars['Int']['output']>;
};

export type ChapterCount = {
  __typename?: 'ChapterCount';
  draft?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Int']['output']>;
  scheduled?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ChapterPageAd = {
  __typename?: 'ChapterPageAd';
  bookPageAdId: Scalars['ID']['output'];
  chapterId: Scalars['ID']['output'];
  contentRawState: Scalars['JSON']['output'];
  seq: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export enum ChapterStatus {
  Draft = 'draft',
  Public = 'public',
  Removed = 'removed',
  Scheduled = 'scheduled',
  Unpublic = 'unpublic'
}

export enum ClientPlatform {
  Apple = 'apple',
  Google = 'google',
  Web = 'web'
}

export type Contact = {
  __typename?: 'Contact';
  address?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameTitle?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  subDistrict?: Maybe<Scalars['String']['output']>;
  tel?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
};

export type ContentRating = {
  __typename?: 'ContentRating';
  _id?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  iconImageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type ContentRatingsFilter = {
  contentType?: InputMaybe<ContentType>;
};

export enum ContentType {
  Comic = 'comic',
  Fiction = 'fiction',
  Nonfiction = 'nonfiction'
}

export type Contract = {
  __typename?: 'Contract';
  autoRenewed: Scalars['Boolean']['output'];
  expiredAt: Scalars['Date']['output'];
  fictionlogEarningsRatio: Scalars['Float']['output'];
  no: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  pintoAppEarningsRatio: Scalars['Float']['output'];
  pintoEarningsRatio: Scalars['Float']['output'];
};

export type CorrectionEbook = {
  __typename?: 'CorrectionEbook';
  _id: Scalars['ID']['output'];
  category?: Maybe<PintoCategory>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  correctionEbookFiles: Array<CorrectionEbookFile>;
  createdAt: Scalars['Date']['output'];
  rejectNotes?: Maybe<Array<Scalars['String']['output']>>;
  status: CorrectionEbookStatus;
  updatedAt: Scalars['Date']['output'];
  userNote?: Maybe<Scalars['String']['output']>;
};

export type CorrectionEbookFile = {
  __typename?: 'CorrectionEbookFile';
  lastSampleChapterName?: Maybe<Scalars['String']['output']>;
  lastSampleChapterNumber?: Maybe<Scalars['Int']['output']>;
  mainFileUrl?: Maybe<Scalars['String']['output']>;
  mainFilename?: Maybe<Scalars['String']['output']>;
  requestedFileName?: Maybe<Scalars['String']['output']>;
  requestedFileUrl?: Maybe<Scalars['String']['output']>;
  requestedSampleFileType?: Maybe<CorrectionEbookRequestedSampleFileType>;
  sampleFileUrl?: Maybe<Scalars['String']['output']>;
  sampleFilename?: Maybe<Scalars['String']['output']>;
  status: CorrectionEbookFileStatus;
  type: EbookFileType;
};

export enum CorrectionEbookFileStatus {
  AdminUploaded = 'adminUploaded',
  Pending = 'pending',
  Rejected = 'rejected',
  WriterUploaded = 'writerUploaded'
}

export enum CorrectionEbookRequestedSampleFileType {
  Specific = 'specific',
  Standard = 'standard'
}

export enum CorrectionEbookStatus {
  Draft = 'draft',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type CreateAndSubmitReviewEbookInput = {
  appleOriginalPriceTierId?: InputMaybe<Scalars['ID']['input']>;
  authorNames: Array<Scalars['String']['input']>;
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['ID']['input'];
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  coverPriceThb?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  discount?: InputMaybe<EbookDiscountInput>;
  ebookFiles: Array<SubmitReviewEbookEbookFileInput>;
  googleOriginalPriceTierId?: InputMaybe<Scalars['ID']['input']>;
  isRTL?: InputMaybe<Scalars['Boolean']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  originalLanguageCode?: InputMaybe<Scalars['String']['input']>;
  originalPriceThb: Scalars['Float']['input'];
  productSetId?: InputMaybe<Scalars['ID']['input']>;
  productSetVol?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['Date']['input']>;
  readingType?: InputMaybe<ReadingType>;
  subscriptionTitleId?: InputMaybe<Scalars['ID']['input']>;
  synopsis: Scalars['JSON']['input'];
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  translatorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['ID']['input'];
  writingType?: InputMaybe<EbookWritingType>;
};

export type CreateBookPageAdInput = {
  bookId: Scalars['ID']['input'];
  chapterSeqList: Array<Scalars['Int']['input']>;
  destinationUrl: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDraftEbookEbookFileInput = {
  mainFileUrl?: InputMaybe<Scalars['String']['input']>;
  mainFilename?: InputMaybe<Scalars['String']['input']>;
  sampleFileUrl?: InputMaybe<Scalars['String']['input']>;
  sampleFilename?: InputMaybe<Scalars['String']['input']>;
  type: EbookFileType;
};

export type CreateDraftEbookInput = {
  appleOriginalPriceTierId?: InputMaybe<Scalars['ID']['input']>;
  authorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  coverPriceThb?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<EbookDiscountInput>;
  ebookFiles?: InputMaybe<Array<CreateDraftEbookEbookFileInput>>;
  googleOriginalPriceTierId?: InputMaybe<Scalars['ID']['input']>;
  isRTL?: InputMaybe<Scalars['Boolean']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  originalLanguageCode?: InputMaybe<Scalars['String']['input']>;
  originalPriceThb?: InputMaybe<Scalars['Float']['input']>;
  productSetId?: InputMaybe<Scalars['ID']['input']>;
  productSetVol?: InputMaybe<Scalars['Int']['input']>;
  readingType?: InputMaybe<ReadingType>;
  subscriptionTitleId?: InputMaybe<Scalars['ID']['input']>;
  synopsis?: InputMaybe<Scalars['JSON']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  translatorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['ID']['input'];
  writingType?: InputMaybe<EbookWritingType>;
};

export type CreateEbookDiscountCampaignInput = {
  endedAt?: InputMaybe<Scalars['Date']['input']>;
  file: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  startedAt: Scalars['Date']['input'];
  title: Scalars['String']['input'];
};

export type CreateFeedInput = {
  categoryTagId?: InputMaybe<Scalars['ID']['input']>;
  contentType?: InputMaybe<ContentType>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  pref: FeedPref;
  productType?: InputMaybe<ProductType>;
  sections?: InputMaybe<Array<FeedSectionInput>>;
  slug: Scalars['String']['input'];
};

export type CreatePintoAnnouncementNotificationInput = {
  clickActionData?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  notifiedAt?: InputMaybe<Scalars['Date']['input']>;
  platforms?: InputMaybe<Array<ClientPlatform>>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: PintoAnnouncementNotificationType;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userListFileData?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePintoEbookCollectionInput = {
  darkModeHexColorCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  emoji: Scalars['String']['input'];
  hexColorCode: Scalars['String']['input'];
  title: Scalars['String']['input'];
  upsertedItems?: InputMaybe<Array<CreatePintoEbookCollectionItemInput>>;
  userId: Scalars['ID']['input'];
};

export type CreatePintoEbookCollectionItemInput = {
  ebookId: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type CreatePintoProductCampaignInput = {
  bannerImageUrl: Scalars['String']['input'];
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  conditions?: InputMaybe<Array<Scalars['String']['input']>>;
  endedAt: Scalars['Date']['input'];
  exampleProductPromoteImageUrl: Scalars['String']['input'];
  exceptCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  minimumDiscountRatio?: InputMaybe<Scalars['Float']['input']>;
  productTypes: Array<PintoProductCampaignProductType>;
  registrationEndedAt: Scalars['Date']['input'];
  registrationStartedAt: Scalars['Date']['input'];
  slug: Scalars['ID']['input'];
  specificWriterUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startedAt: Scalars['Date']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateOgImageUrl: Scalars['String']['input'];
  title: Scalars['String']['input'];
  userType: PintoProductCampaignUserType;
};

export type CreatePintoSubscriptionTitleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CreatePopupInput = {
  pref: FeedPref;
  slug?: InputMaybe<Scalars['String']['input']>;
  type: PopupType;
};

export type CreatePresignedUploadEbookFileInput = {
  fileType: EbookFileType;
};

export type CreateTagInput = {
  bookIds?: InputMaybe<Array<Scalars['String']['input']>>;
  contentTypes: Array<ContentType>;
  ebookIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isProhibited?: InputMaybe<Scalars['Boolean']['input']>;
  isReserved?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type: TagType;
};

export type CreateTemplateInput = {
  categoryTagId?: InputMaybe<Scalars['ID']['input']>;
  contentType?: InputMaybe<ContentType>;
  meta?: InputMaybe<TemplateMetaInput>;
  placement: TemplatePlacement;
  pref?: InputMaybe<FeedPref>;
  productType?: InputMaybe<ProductType>;
  sectionIds: Array<Scalars['Int']['input']>;
};

export type DateRangeFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultType = {
  __typename?: 'DefaultType';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Ebook = {
  __typename?: 'Ebook';
  _id: Scalars['ID']['output'];
  activatedAt: Scalars['Date']['output'];
  appleDiscountRatio?: Maybe<Scalars['Float']['output']>;
  appleOriginalPriceTier?: Maybe<AppPriceTier>;
  applePriceTier?: Maybe<AppPriceTier>;
  /** @deprecated Use field authorNames instead */
  authorName?: Maybe<Scalars['String']['output']>;
  authorNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated No longer supported */
  bannerImage?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use field category instead */
  categories?: Maybe<Array<Maybe<Category>>>;
  category?: Maybe<PintoCategory>;
  /** @deprecated Use field category instead */
  categoryTag?: Maybe<Tag>;
  /** @deprecated No longer supported */
  contentRating?: Maybe<ContentRating>;
  /** @deprecated Use field synopsis instead */
  contentRawState?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated No longer supported */
  contentType?: Maybe<ContentType>;
  correction?: Maybe<CorrectionEbook>;
  correctionEbookStatus?: Maybe<CorrectionEbookStatus>;
  /** @deprecated Use field coverImageUrl instead */
  coverImage?: Maybe<Scalars['String']['output']>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  coverPriceThb?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<EbookDiscount>;
  /** @deprecated Use field originalPriceThb instead */
  discountPrice?: Maybe<Price>;
  /** @deprecated No longer supported */
  discountPriceTierDetail?: Maybe<Scalars['JSON']['output']>;
  discountRatio?: Maybe<Scalars['Float']['output']>;
  earningsRatio: Scalars['Float']['output'];
  ebookFiles: Array<EbookFile>;
  fileUpdatedAt?: Maybe<Scalars['Date']['output']>;
  googleDiscountRatio?: Maybe<Scalars['Float']['output']>;
  googleOriginalPriceTier?: Maybe<AppPriceTier>;
  googlePriceTier?: Maybe<AppPriceTier>;
  /** @deprecated No longer supported */
  hasMatureContent?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use field tags instead */
  hashtags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isBlocked: Scalars['Boolean']['output'];
  isFree: Scalars['Boolean']['output'];
  /** @deprecated Use field readingType instead */
  isRTL: Scalars['Boolean']['output'];
  isTranslated: Scalars['Boolean']['output'];
  isbn?: Maybe<Scalars['String']['output']>;
  language: Language;
  librariesCount?: Maybe<Scalars['Int']['output']>;
  ogImageUrl?: Maybe<Scalars['String']['output']>;
  originalLanguage: Language;
  originalPriceThb?: Maybe<Scalars['Float']['output']>;
  pagesCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated No longer supported */
  placeholderBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use field priceThb instead */
  price?: Maybe<Price>;
  priceThb?: Maybe<Scalars['Float']['output']>;
  productSet?: Maybe<PintoProductSet>;
  productSetId?: Maybe<Scalars['String']['output']>;
  productSetOrder?: Maybe<Scalars['Int']['output']>;
  productSetVol?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  purchasesCount: Scalars['Int']['output'];
  readingType: ReadingType;
  status: EbookStatus;
  subscriptionTitle?: Maybe<SubscriptionTitle>;
  subscriptionTitleId?: Maybe<Scalars['ID']['output']>;
  summaryEbookLog?: Maybe<SummaryEbookLog>;
  synopsis?: Maybe<Scalars['JSON']['output']>;
  tags: Array<Tag>;
  title?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  totalSale?: Maybe<Price>;
  totalSales: Scalars['Float']['output'];
  /** @deprecated Use field translatorNames instead */
  translatorName?: Maybe<Scalars['String']['output']>;
  translatorNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  userReviewsCount?: Maybe<UserReviewsCount>;
  viewsCount?: Maybe<Scalars['Int']['output']>;
  writingType: EbookWritingType;
};

export type EbookBundle = {
  __typename?: 'EbookBundle';
  _id: Scalars['ID']['output'];
  appleDiscountRatio?: Maybe<Scalars['Float']['output']>;
  appleOriginalPriceThb?: Maybe<Scalars['Float']['output']>;
  applePriceTierId?: Maybe<Scalars['ID']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountRatio?: Maybe<Scalars['Float']['output']>;
  ebookCount: Scalars['Int']['output'];
  endedAt?: Maybe<Scalars['Date']['output']>;
  googleDiscountRatio?: Maybe<Scalars['Float']['output']>;
  googleOriginalPriceThb?: Maybe<Scalars['Float']['output']>;
  googlePriceTierId?: Maybe<Scalars['ID']['output']>;
  originalPriceThb?: Maybe<Scalars['Float']['output']>;
  priceThb?: Maybe<Scalars['Float']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: EbookBundleStatus;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['ID']['output'];
};

export enum EbookBundleStatus {
  Draft = 'draft',
  Hidden = 'hidden',
  Public = 'public',
  Removed = 'removed',
  Scheduled = 'scheduled'
}

export type EbookBundleSubmission = {
  __typename?: 'EbookBundleSubmission';
  _id: Scalars['ID']['output'];
  adminNote: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  ebookBundleCount: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
};

export type EbookCategoryInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type EbookConnection = {
  __typename?: 'EbookConnection';
  edges: Array<EbookEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EbookDiscount = {
  __typename?: 'EbookDiscount';
  _id: Scalars['ID']['output'];
  activated: Scalars['Boolean']['output'];
  applePriceTier?: Maybe<AppPriceTier>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  googlePriceTier?: Maybe<AppPriceTier>;
  ratio?: Maybe<Scalars['Float']['output']>;
  startedAt: Scalars['Date']['output'];
  thb?: Maybe<Scalars['Int']['output']>;
};

export type EbookDiscountCampaign = {
  __typename?: 'EbookDiscountCampaign';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  endedAt?: Maybe<Scalars['Date']['output']>;
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  startedAt: Scalars['Date']['output'];
  status: EbookDiscountCampaignStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type EbookDiscountCampaignConnection = {
  __typename?: 'EbookDiscountCampaignConnection';
  edges: Array<EbookDiscountCampaignEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EbookDiscountCampaignEdge = {
  __typename?: 'EbookDiscountCampaignEdge';
  cursor: Scalars['String']['output'];
  node: EbookDiscountCampaign;
};

export enum EbookDiscountCampaignStatus {
  Cancelled = 'cancelled',
  Complete = 'complete',
  Pending = 'pending',
  Processing = 'processing'
}

export type EbookDiscountCampaignsFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EbookDiscountCampaignStatus>;
};

export type EbookDiscountInput = {
  applePriceTierId?: InputMaybe<Scalars['ID']['input']>;
  endedAt?: InputMaybe<Scalars['Date']['input']>;
  googlePriceTierId?: InputMaybe<Scalars['ID']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
  startedAt?: InputMaybe<Scalars['Date']['input']>;
  thb?: InputMaybe<Scalars['Float']['input']>;
};

export type EbookEdge = {
  __typename?: 'EbookEdge';
  cursor: Scalars['String']['output'];
  node: Ebook;
};

export type EbookFile = {
  __typename?: 'EbookFile';
  mainFileUrl?: Maybe<Scalars['String']['output']>;
  mainFilename?: Maybe<Scalars['String']['output']>;
  pagesCount: Scalars['Int']['output'];
  rawMainFileUrl?: Maybe<Scalars['String']['output']>;
  sampleFileUrl?: Maybe<Scalars['String']['output']>;
  sampleFilename?: Maybe<Scalars['String']['output']>;
  sizeInKB: Scalars['Float']['output'];
  type: EbookFileType;
};

export enum EbookFileType {
  Epub = 'epub',
  Pdf = 'pdf'
}

export type EbookImageInput = {
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type EbookLog = {
  __typename?: 'EbookLog';
  _id: Scalars['ID']['output'];
  action: EbookLogType;
  actor: User;
  createdAt: Scalars['Date']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum EbookLogType {
  Create = 'create',
  Update = 'update'
}

export type EbookOptionFilter = {
  platform?: InputMaybe<AppPriceTierPlatform>;
};

export type EbookOptions = {
  __typename?: 'EbookOptions';
  languages: Array<Language>;
  priceTiers: Array<AppPriceTier>;
};

export enum EbookPriceType {
  Free = 'free',
  OnSale = 'onSale'
}

export enum EbookStatus {
  Draft = 'draft',
  Hidden = 'hidden',
  Public = 'public',
  Removed = 'removed',
  Scheduled = 'scheduled'
}

export enum EbookType {
  Thai = 'thai',
  TranslatedThai = 'translatedThai'
}

export enum EbookWritingType {
  Bundle = 'bundle',
  Chapter = 'chapter'
}

export type EbooksFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  publisherType?: InputMaybe<PublisherType>;
  sortBy?: InputMaybe<EbooksSortType>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptionTitleId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum EbooksSortType {
  Created = 'created',
  Popular = 'popular',
  Published = 'published',
  PurchasesCount = 'purchasesCount',
  Trending = 'trending',
  Updated = 'updated'
}

export type EditBookInput = {
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  /** [Deprecated] Use field categoryTagId instead */
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoryTagId?: InputMaybe<Scalars['ID']['input']>;
  contentRatingId?: InputMaybe<Scalars['ID']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  /** [Deprecated] Use field tagNames instead */
  hashtags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isTranslated?: InputMaybe<Scalars['Boolean']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EditChapter = {
  __typename?: 'EditChapter';
  _id?: Maybe<Scalars['ID']['output']>;
  chapter?: Maybe<Chapter>;
  chapterId?: Maybe<Scalars['ID']['output']>;
  contentRawState?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  rejectNote?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userNote?: Maybe<Scalars['String']['output']>;
};

export type EditChapterFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EditChapterStatus>;
};

export type EditChapterInput = {
  chapterId: Scalars['ID']['input'];
  contentRawState: Scalars['JSON']['input'];
  title: Scalars['String']['input'];
};

export enum EditChapterStatus {
  Pending = 'pending',
  Rejected = 'rejected'
}

export type EditDraftEbookInput = {
  appleOriginalPriceTierId?: InputMaybe<Scalars['ID']['input']>;
  authorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  coverPriceThb?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<EbookDiscountInput>;
  ebookFiles?: InputMaybe<Array<CreateDraftEbookEbookFileInput>>;
  googleOriginalPriceTierId?: InputMaybe<Scalars['ID']['input']>;
  isRTL?: InputMaybe<Scalars['Boolean']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  originalLanguageCode?: InputMaybe<Scalars['String']['input']>;
  originalPriceThb?: InputMaybe<Scalars['Float']['input']>;
  productSetId?: InputMaybe<Scalars['ID']['input']>;
  productSetVol?: InputMaybe<Scalars['Int']['input']>;
  readingType?: InputMaybe<ReadingType>;
  synopsis?: InputMaybe<Scalars['JSON']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  translatorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  writingType?: InputMaybe<EbookWritingType>;
};

export type EditEbook = {
  __typename?: 'EditEbook';
  _id: Scalars['ID']['output'];
  activatedAt?: Maybe<Scalars['Date']['output']>;
  category?: Maybe<PintoCategory>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  correctionEbookFiles: Array<EditEbookFile>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  ebook?: Maybe<Ebook>;
  ebookId?: Maybe<Scalars['ID']['output']>;
  rejectNotes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<EditEbookStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userNote?: Maybe<Scalars['String']['output']>;
};

export type EditEbookConnection = {
  __typename?: 'EditEbookConnection';
  edges?: Maybe<Array<Maybe<EditEbookEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EditEbookEdge = {
  __typename?: 'EditEbookEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<EditEbook>;
};

export type EditEbookFile = {
  __typename?: 'EditEbookFile';
  isAutoGenerateSampleFile?: Maybe<Scalars['Boolean']['output']>;
  lastSampleChapterName?: Maybe<Scalars['String']['output']>;
  lastSampleChapterNumber?: Maybe<Scalars['Int']['output']>;
  mainFileUrl?: Maybe<Scalars['String']['output']>;
  mainFilename?: Maybe<Scalars['String']['output']>;
  requestedFileName?: Maybe<Scalars['String']['output']>;
  requestedFileType?: Maybe<Scalars['String']['output']>;
  requestedFileUrl?: Maybe<Scalars['String']['output']>;
  requestedSampleFileType?: Maybe<CorrectionEbookRequestedSampleFileType>;
  sampleFileUrl?: Maybe<Scalars['String']['output']>;
  sampleFilename?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CorrectionEbookFileStatus>;
  type: EbookFileType;
};

export type EditEbookFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  /** [Deprecated] Unused in Pinto */
  contentType?: InputMaybe<ContentType>;
  correctionEbookFileStatuses?: InputMaybe<Array<InputMaybe<CorrectionEbookFileStatus>>>;
  ebookStatus?: InputMaybe<EbookStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<EditEbookSortBy>;
  sortType?: InputMaybe<SortType>;
  status?: InputMaybe<EditEbookStatus>;
};

export type EditEbookInput = {
  appleOriginalPriceTierId?: InputMaybe<Scalars['ID']['input']>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  /** [Deprecated] Use field categoryTagId instead */
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoryTagId?: InputMaybe<Scalars['ID']['input']>;
  contentRatingId?: InputMaybe<Scalars['ID']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  googleOriginalPriceTierId?: InputMaybe<Scalars['ID']['input']>;
  /** [Deprecated] Use field tagNames instead */
  hashtags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  userCorrectionNote?: InputMaybe<Scalars['String']['input']>;
  writingType?: InputMaybe<EbookWritingType>;
};

export enum EditEbookSortBy {
  Created = 'created',
  Updated = 'updated'
}

export enum EditEbookStatus {
  Draft = 'draft',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type EditGeneralTaxpayerBankAccountBankAccountInput = {
  bankBranch?: InputMaybe<Scalars['String']['input']>;
  bankBranchCode?: InputMaybe<Scalars['String']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bookPageFile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  no?: InputMaybe<Scalars['String']['input']>;
};

export type EditGeneralTaxpayerBankAccountInput = {
  bankAccount?: InputMaybe<EditGeneralTaxpayerBankAccountBankAccountInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  taxpayer?: InputMaybe<EditGeneralTaxpayerBankAccountTaxpayerInput>;
};

export type EditGeneralTaxpayerBankAccountTaxpayerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  deductedTaxType?: InputMaybe<TaxpayerDeductedTaxType>;
  district?: InputMaybe<Scalars['String']['input']>;
  idCardFile?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameTitle?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  subDistrict?: InputMaybe<Scalars['String']['input']>;
  taxForm?: InputMaybe<TaxpayerTaxForm>;
};

export type EditPintoSubscriptionTitleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditPremiumTaxpayerBankAccountBankAccountInput = {
  bankBranch?: InputMaybe<Scalars['String']['input']>;
  bankBranchCode?: InputMaybe<Scalars['String']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  no?: InputMaybe<Scalars['String']['input']>;
};

export type EditPremiumTaxpayerBankAccountContractInput = {
  autoRenewed?: InputMaybe<Scalars['Boolean']['input']>;
  expiredAt?: InputMaybe<Scalars['Date']['input']>;
  no?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type EditPremiumTaxpayerBankAccountInput = {
  bankAccount?: InputMaybe<EditPremiumTaxpayerBankAccountBankAccountInput>;
  contract?: InputMaybe<EditPremiumTaxpayerBankAccountContractInput>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  taxpayer?: InputMaybe<EditPremiumTaxpayerBankAccountTaxpayerInput>;
  type?: InputMaybe<TaxpayerBankAccountType>;
};

export type EditPremiumTaxpayerBankAccountTaxpayerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  calculateVat?: InputMaybe<Scalars['Boolean']['input']>;
  deductedTaxType?: InputMaybe<TaxpayerDeductedTaxType>;
  district?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameTitle?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  subDistrict?: InputMaybe<Scalars['String']['input']>;
  taxForm?: InputMaybe<TaxpayerTaxForm>;
};

export type EditProductSetInput = {
  coverImage?: InputMaybe<Scalars['String']['input']>;
};

export type EditTagInput = {
  bookIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ebookIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isProhibited?: InputMaybe<Scalars['Boolean']['input']>;
  isReserved?: InputMaybe<Scalars['Boolean']['input']>;
  newContentTypes?: InputMaybe<Array<ContentType>>;
  type?: InputMaybe<TagType>;
};

export type Explore = {
  __typename?: 'Explore';
  anyFileTypes?: Maybe<Array<FileType>>;
  anyPriceTypes?: Maybe<Array<EbookPriceType>>;
  anyTypes?: Maybe<Array<EbookType>>;
  anyWritingTypes?: Maybe<Array<EbookWritingType>>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  categoryTagId?: Maybe<Scalars['ID']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  contentRatingIds?: Maybe<Array<Scalars['ID']['output']>>;
  contentType?: Maybe<ContentType>;
  coverImage?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exploreType?: Maybe<ExploreType>;
  gteRating?: Maybe<Scalars['Int']['output']>;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  isTranslated?: Maybe<Scalars['Boolean']['output']>;
  placeholderBackgroundColor?: Maybe<Scalars['String']['output']>;
  sortBy?: Maybe<Scalars['String']['output']>;
  sortType?: Maybe<SortType>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum ExploreBookSortBy {
  LatestChapterPublished = 'latestChapterPublished',
  Popular = 'popular',
  Popular7Days = 'popular7Days',
  Popular30Days = 'popular30Days',
  Trending = 'trending'
}

export enum ExploreEbookSortBy {
  Popular = 'popular',
  Popular7Days = 'popular7Days',
  Popular30Days = 'popular30Days',
  Published = 'published',
  Trending = 'trending'
}

export type ExploreProductSet = {
  __typename?: 'ExploreProductSet';
  categoryId?: Maybe<Scalars['ID']['output']>;
  sortBy?: Maybe<Scalars['String']['output']>;
  sortType?: Maybe<SortType>;
};

export enum ExploreType {
  All = 'all',
  Bestseller = 'bestseller',
  Book = 'book',
  Ebook = 'ebook',
  Free = 'free',
  NewArrival = 'newArrival',
  Trending = 'trending'
}

export type ExportRaw = {
  __typename?: 'ExportRaw';
  _id?: Maybe<Scalars['ID']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ExportStatus>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ExportRawInput = {
  database: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  table: Scalars['String']['input'];
};

export enum ExportStatus {
  Failed = 'failed',
  Pending = 'pending',
  Successful = 'successful'
}

export type Feed = {
  __typename?: 'Feed';
  _id?: Maybe<Scalars['ID']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<ContentType>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  pref?: Maybe<FeedPref>;
  productType?: Maybe<ProductType>;
  sections?: Maybe<Array<Maybe<Section>>>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type FeedConnection = {
  __typename?: 'FeedConnection';
  edges: Array<FeedEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FeedEdge = {
  __typename?: 'FeedEdge';
  cursor: Scalars['String']['output'];
  node: Feed;
};

export type FeedInput = {
  categoryTagId?: InputMaybe<Scalars['ID']['input']>;
  contentType?: InputMaybe<ContentType>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  pref?: InputMaybe<FeedPref>;
  productType?: InputMaybe<ProductType>;
  sections?: InputMaybe<Array<FeedSectionInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type FeedSectionInput = {
  _id: Scalars['ID']['input'];
  endedAt?: InputMaybe<Scalars['Date']['input']>;
  startedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum FeedPref {
  Default = 'default',
  Female = 'female',
  Male = 'male',
  Y = 'y'
}

export type FeedsFilter = {
  contentType?: InputMaybe<ContentType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pref?: InputMaybe<FeedPref>;
  productType?: InputMaybe<ProductType>;
};

export enum FeedsFilterSortBy {
  Created = 'created',
  Updated = 'updated'
}

export type FeedsFilterV2 = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  categoryTagId?: InputMaybe<Scalars['ID']['input']>;
  contentType?: InputMaybe<ContentType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pref?: InputMaybe<FeedPref>;
  productType?: InputMaybe<ProductType>;
  sortBy?: InputMaybe<FeedsFilterSortBy>;
  sortType?: InputMaybe<SortType>;
};

export enum FileType {
  Epub = 'epub',
  Pdf = 'pdf'
}

export enum Gender {
  Female = 'female',
  Male = 'male',
  Other = 'other'
}

export type GenerateActiveContentByCategoryReportFilter = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentType: ContentType;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  type?: InputMaybe<ActiveContentReportType>;
};

export type GenerateActiveContentReportFilter = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentType?: InputMaybe<ContentType>;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  type?: InputMaybe<ActiveContentReportType>;
};

export type GenerateActiveStakeholderByCategoryReportFilter = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentType: ContentType;
  endDate: Scalars['String']['input'];
  productType?: InputMaybe<ProductType>;
  startDate: Scalars['String']['input'];
  userType?: InputMaybe<UserType>;
};

export type GenerateActiveStakeholderByContentReportFilter = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentType?: InputMaybe<ContentType>;
  endDate: Scalars['String']['input'];
  productType?: InputMaybe<ProductType>;
  startDate: Scalars['String']['input'];
  userType?: InputMaybe<UserType>;
};

export type GenerateMonthlyActiveStakeholderReportFilter = {
  date: Scalars['String']['input'];
};

export type GenerateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type IPopupItemConfig = {
  popupImageUrl: Scalars['String']['output'];
};

export type ItemResult = Book | Ebook;

export type Language = {
  __typename?: 'Language';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Link = {
  __typename?: 'Link';
  bannerImage?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  placeholderBackgroundColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LoginInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type MarkAsPaidBankTransferInput = {
  paidAt: Scalars['Date']['input'];
};

export type Metric = {
  __typename?: 'Metric';
  endDate?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Scalars['JSON']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type MetricFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<MetricScope>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export enum MetricScope {
  BookPurchase = 'book_purchase',
  EbookPurchase = 'ebook_purchase',
  Refill = 'refill',
  Register = 'register',
  View = 'view'
}

export type MonthlyBankTransfer = {
  __typename?: 'MonthlyBankTransfer';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  isPremium: Scalars['Boolean']['output'];
  itemsCount: MonthlyBankTransferItemsCount;
  month: Scalars['Int']['output'];
  monthlyBankTransferErrors: Array<MonthlyBankTransferError>;
  monthlyBankTransferLogs: Array<MonthlyBankTransferLog>;
  status: MonthlyBankTransferStatus;
  updatedAt: Scalars['Date']['output'];
  year: Scalars['Int']['output'];
};

export type MonthlyBankTransferConnection = {
  __typename?: 'MonthlyBankTransferConnection';
  edges: Array<MonthlyBankTransferEdge>;
  pageInfo: PageInfo;
};

export type MonthlyBankTransferEdge = {
  __typename?: 'MonthlyBankTransferEdge';
  cursor: Scalars['String']['output'];
  node: MonthlyBankTransfer;
};

export type MonthlyBankTransferError = {
  __typename?: 'MonthlyBankTransferError';
  _id: Scalars['ID']['output'];
  activatedAt: Scalars['Date']['output'];
  bankAccountBrand: Scalars['String']['output'];
  bankAccountName: Scalars['String']['output'];
  bankAccountNo: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  monthlyBankTransferId: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['String']['output'];
  thb: Scalars['Float']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type MonthlyBankTransferItemsCount = {
  __typename?: 'MonthlyBankTransferItemsCount';
  cancelled: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  pendingApproval: Scalars['Int']['output'];
  success: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MonthlyBankTransferLog = {
  __typename?: 'MonthlyBankTransferLog';
  _id: Scalars['ID']['output'];
  action: MonthlyBankTransferLogType;
  actor: User;
  actorId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  fileUrl: Scalars['String']['output'];
  monthlyBankTransferId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum MonthlyBankTransferLogType {
  Download = 'download',
  Upload = 'upload'
}

export enum MonthlyBankTransferStatus {
  Generating = 'generating',
  Pending = 'pending',
  Uploaded = 'uploaded'
}

export type MonthlyBankTransfersFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<MonthlyBankTransfersSortBy>;
};

export enum MonthlyBankTransfersSortBy {
  Created = 'created'
}

export type Notification = {
  __typename?: 'Notification';
  action?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  item?: Maybe<ItemResult>;
  notificationKey?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Overview = {
  __typename?: 'Overview';
  active_books?: Maybe<Scalars['Int']['output']>;
  active_users?: Maybe<Scalars['Int']['output']>;
  active_writers?: Maybe<Scalars['Int']['output']>;
  new_books?: Maybe<Scalars['Int']['output']>;
  new_chapters?: Maybe<Scalars['Int']['output']>;
  paying_users?: Maybe<Scalars['Int']['output']>;
  purchases?: Maybe<Scalars['Float']['output']>;
  refills?: Maybe<Scalars['Float']['output']>;
  total_writers?: Maybe<Scalars['Int']['output']>;
};

export type OverviewFilter = {
  month?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PendingEbook = {
  __typename?: 'PendingEbook';
  ebookStatus?: Maybe<EbookStatus>;
  ebookTitle?: Maybe<Scalars['String']['output']>;
};

export type Permission = {
  __typename?: 'Permission';
  _id: Scalars['ID']['output'];
  activateUserCashOut: Scalars['Boolean']['output'];
  activateWriterRegistration: Scalars['Boolean']['output'];
  approveBankTransfer: Scalars['Boolean']['output'];
  bestSeller: Scalars['Boolean']['output'];
  bookPageAd: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  editBankTransferCustomerDocument: Scalars['Boolean']['output'];
  editBankTransferMerchantDocument: Scalars['Boolean']['output'];
  editChapters: Scalars['Boolean']['output'];
  editEbooks: Scalars['Boolean']['output'];
  editUserPermissions: Scalars['Boolean']['output'];
  editWriterRegistration: Scalars['Boolean']['output'];
  exportRaws: Scalars['Boolean']['output'];
  feeds: Scalars['Boolean']['output'];
  libraryAd: Scalars['Boolean']['output'];
  markAsPaidBankTransfer: Scalars['Boolean']['output'];
  metrics: Scalars['Boolean']['output'];
  monthlyBankTransfer: Scalars['Boolean']['output'];
  pintoEbookCollection: Scalars['Boolean']['output'];
  pintoEbookDiscountCamPaign: Scalars['Boolean']['output'];
  pintoNotification: Scalars['Boolean']['output'];
  pintoProductCampaign: Scalars['Boolean']['output'];
  pintoVoucher: Scalars['Boolean']['output'];
  popupAd: Scalars['Boolean']['output'];
  removeBooks: Scalars['Boolean']['output'];
  removeEbooks: Scalars['Boolean']['output'];
  removeProductSets: Scalars['Boolean']['output'];
  removeUsers: Scalars['Boolean']['output'];
  resetUserPassword: Scalars['Boolean']['output'];
  sections: Scalars['Boolean']['output'];
  suggestionProduct: Scalars['Boolean']['output'];
  tags: Scalars['Boolean']['output'];
  taxDeductions: Scalars['Boolean']['output'];
  transactions: Scalars['Boolean']['output'];
  updateBooks: Scalars['Boolean']['output'];
  updateEbooks: Scalars['Boolean']['output'];
  updateProductSets: Scalars['Boolean']['output'];
  updateUsers: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
  viewBankTransfer: Scalars['Boolean']['output'];
  viewBooks: Scalars['Boolean']['output'];
  viewEbooks: Scalars['Boolean']['output'];
  viewProductSets: Scalars['Boolean']['output'];
  viewUsers: Scalars['Boolean']['output'];
  viewWriterRegistration: Scalars['Boolean']['output'];
  vouchers: Scalars['Boolean']['output'];
};

export type PermissionInput = {
  permissionList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type PickedTag = {
  __typename?: 'PickedTag';
  _id: Scalars['ID']['output'];
  contentType?: Maybe<ContentType>;
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  section: Scalars['String']['output'];
  tagId: Scalars['Int']['output'];
};

export enum PickedTagSectionType {
  EditProduct = 'editProduct',
  Explore = 'explore',
  Search = 'search'
}

export type PintoAnnouncementNotification = {
  __typename?: 'PintoAnnouncementNotification';
  _id: Scalars['ID']['output'];
  clickActionData?: Maybe<Scalars['String']['output']>;
  clickActionType?: Maybe<PintoAnnouncementNotificationClickActionType>;
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  notified: Scalars['Boolean']['output'];
  notifiedAt: Scalars['Date']['output'];
  platforms: Array<ClientPlatform>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  topics: Array<PintoAnnouncementNotificationTopic>;
  type: PintoAnnouncementNotificationType;
  updatedAt: Scalars['Date']['output'];
  userIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export enum PintoAnnouncementNotificationClickActionType {
  Link = 'link'
}

export type PintoAnnouncementNotificationConnection = {
  __typename?: 'PintoAnnouncementNotificationConnection';
  edges: Array<PintoAnnouncementNotificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PintoAnnouncementNotificationEdge = {
  __typename?: 'PintoAnnouncementNotificationEdge';
  cursor: Scalars['String']['output'];
  node: PintoAnnouncementNotification;
};

export enum PintoAnnouncementNotificationTopic {
  Android = 'android',
  AndroidLogin = 'androidLogin',
  Ios = 'ios',
  IosLogin = 'iosLogin',
  Web = 'web',
  WebLogin = 'webLogin'
}

export enum PintoAnnouncementNotificationType {
  All = 'all',
  SpecificUser = 'specificUser'
}

export type PintoAnnouncementNotificationsFilter = {
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  notified?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PintoAnnouncementNotificationsSortBy>;
  sortType?: InputMaybe<SortType>;
};

export enum PintoAnnouncementNotificationsSortBy {
  Created = 'created',
  Notified = 'notified'
}

export type PintoCategoriesFilter = {
  depth?: InputMaybe<Scalars['Int']['input']>;
};

export type PintoCategory = {
  __typename?: 'PintoCategory';
  _id: Scalars['ID']['output'];
  canSetPrice: Scalars['Boolean']['output'];
  childrens?: Maybe<Array<Maybe<PintoCategory>>>;
  contentType: ContentType;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  parent?: Maybe<PintoCategory>;
  parentId?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type PintoEbookCollection = {
  __typename?: 'PintoEbookCollection';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  darkModeHexColorCode: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  ebookCoverImageUrls: Array<Scalars['String']['output']>;
  emoji: Scalars['String']['output'];
  hexColorCode: Scalars['String']['output'];
  itemCount: Scalars['Int']['output'];
  ogImageUrl: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['Date']['output']>;
  status: PintoEbookCollectionStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type PintoEbookCollectionConnection = {
  __typename?: 'PintoEbookCollectionConnection';
  edges: Array<PintoEbookCollectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PintoEbookCollectionEdge = {
  __typename?: 'PintoEbookCollectionEdge';
  cursor: Scalars['String']['output'];
  node: PintoEbookCollection;
};

export type PintoEbookCollectionItemsFilter = {
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum PintoEbookCollectionStatus {
  Draft = 'draft',
  Public = 'public',
  Removed = 'removed'
}

export type PintoEbookCollectionsFilter = {
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PintoProductSetsFilterSortBy>;
  sortType?: InputMaybe<SortType>;
  status?: InputMaybe<PintoEbookCollectionStatus>;
};

export enum PintoEbookCollectionsFilterSortBy {
  Created = 'created',
  Published = 'published',
  Random = 'random',
  Title = 'title'
}

export type PintoEbookSubmission = {
  __typename?: 'PintoEbookSubmission';
  _id: Scalars['ID']['output'];
  actor: User;
  actorId: Scalars['String']['output'];
  adminNote?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  itemCount: Scalars['Int']['output'];
  itemStatusCounts: Array<PintoEbookSubmissionItemStatusCount>;
  status: PintoEbookSubmissionStatus;
  updatedAt: Scalars['Date']['output'];
};

export type PintoEbookSubmissionConnection = {
  __typename?: 'PintoEbookSubmissionConnection';
  edges: Array<PintoEbookSubmissionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PintoEbookSubmissionEdge = {
  __typename?: 'PintoEbookSubmissionEdge';
  cursor: Scalars['String']['output'];
  node: PintoEbookSubmission;
};

export type PintoEbookSubmissionItem = {
  __typename?: 'PintoEbookSubmissionItem';
  _id: Scalars['ID']['output'];
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  data: Scalars['JSON']['output'];
  ebook?: Maybe<Ebook>;
  ebookId?: Maybe<Scalars['ID']['output']>;
  ebookSubmissionId: Scalars['ID']['output'];
  errorNote?: Maybe<Scalars['String']['output']>;
  status: PintoEbookSubmissionItemStatus;
};

export type PintoEbookSubmissionItemConnection = {
  __typename?: 'PintoEbookSubmissionItemConnection';
  edges: Array<PintoEbookSubmissionItemEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PintoEbookSubmissionItemEdge = {
  __typename?: 'PintoEbookSubmissionItemEdge';
  cursor: Scalars['String']['output'];
  node: PintoEbookSubmissionItem;
};

export enum PintoEbookSubmissionItemStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing'
}

export type PintoEbookSubmissionItemStatusCount = {
  __typename?: 'PintoEbookSubmissionItemStatusCount';
  count: Scalars['Int']['output'];
  status: PintoEbookSubmissionItemStatus;
};

export type PintoEbookSubmissionItemsFilter = {
  anyStatuses?: InputMaybe<Array<PintoEbookSubmissionItemStatus>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortType>;
};

export type PintoEbookSubmissionPreview = {
  __typename?: 'PintoEbookSubmissionPreview';
  _id?: Maybe<Scalars['ID']['output']>;
  fileName: Scalars['String']['output'];
  invalidCount: Scalars['Int']['output'];
  rows: Array<PintoEbookSubmissionPreviewRow>;
  totalCount: Scalars['Int']['output'];
  validCount: Scalars['Int']['output'];
};

export type PintoEbookSubmissionPreviewRow = {
  __typename?: 'PintoEbookSubmissionPreviewRow';
  appleDiscountPriceTierId?: Maybe<Scalars['Int']['output']>;
  appleDiscountPriceTierThb?: Maybe<Scalars['Float']['output']>;
  applePriceTierId?: Maybe<Scalars['Int']['output']>;
  applePriceTierThb?: Maybe<Scalars['Float']['output']>;
  authorNames: Array<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  contentWarningPlainText?: Maybe<Scalars['String']['output']>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  coverPriceThb?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountEndedAt?: Maybe<Scalars['Date']['output']>;
  discountStartedAt?: Maybe<Scalars['Date']['output']>;
  errors: Array<PintoEbookSubmissionPreviewRowError>;
  googleDiscountPriceTierId?: Maybe<Scalars['Int']['output']>;
  googleDiscountPriceTierThb?: Maybe<Scalars['Float']['output']>;
  googlePriceTierId?: Maybe<Scalars['Int']['output']>;
  googlePriceTierThb?: Maybe<Scalars['Float']['output']>;
  isbn?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  mainEpubFileUrl?: Maybe<Scalars['String']['output']>;
  mainPdfFileUrl?: Maybe<Scalars['String']['output']>;
  no: Scalars['String']['output'];
  originalLanguage?: Maybe<Scalars['String']['output']>;
  priceThb?: Maybe<Scalars['Float']['output']>;
  productSetId?: Maybe<Scalars['String']['output']>;
  productSetTitle?: Maybe<Scalars['String']['output']>;
  productSetVol?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  readingType?: Maybe<Scalars['String']['output']>;
  sampleEpubFileUrl?: Maybe<Scalars['String']['output']>;
  samplePdfFileUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PintoEbookSubmissionPreviewRowStatus>;
  subscriptionTitleId?: Maybe<Scalars['String']['output']>;
  subscriptionTitleTitle?: Maybe<Scalars['String']['output']>;
  synopsisPlainText: Scalars['String']['output'];
  tagNames?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  translatorNames: Array<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  webDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  webDiscountPriceThb?: Maybe<Scalars['Float']['output']>;
  webDiscountThb?: Maybe<Scalars['Float']['output']>;
  writingType?: Maybe<Scalars['String']['output']>;
};

export type PintoEbookSubmissionPreviewRowError = {
  __typename?: 'PintoEbookSubmissionPreviewRowError';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum PintoEbookSubmissionPreviewRowStatus {
  Public = 'public',
  Scheduled = 'scheduled'
}

export enum PintoEbookSubmissionSortBy {
  Created = 'created',
  Updated = 'updated'
}

export enum PintoEbookSubmissionStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Pending = 'pending',
  Processing = 'processing'
}

export type PintoEbookSubmissionsFilter = {
  anyStatuses?: InputMaybe<Array<PintoEbookSubmissionStatus>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PintoEbookSubmissionSortBy>;
  sortType?: InputMaybe<SortType>;
};

export type PintoPreviewEbookSubmissionInput = {
  file: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type PintoProductCampaign = {
  __typename?: 'PintoProductCampaign';
  _id: Scalars['ID']['output'];
  bannerImageUrl: Scalars['String']['output'];
  categoryIds?: Maybe<Array<Scalars['Int']['output']>>;
  conditions?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Date']['output'];
  endedAt: Scalars['Date']['output'];
  exampleProductPromoteImageUrl: Scalars['String']['output'];
  exceptCategoryIds?: Maybe<Array<Scalars['Int']['output']>>;
  isActive: Scalars['Boolean']['output'];
  minimumDiscountRatio?: Maybe<Scalars['Float']['output']>;
  productTypes: Array<PintoProductCampaignProductType>;
  registrationEndedAt: Scalars['Date']['output'];
  registrationStartedAt: Scalars['Date']['output'];
  startedAt: Scalars['Date']['output'];
  status: PintoProductCampaignStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  templateOgImageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  userType: PintoProductCampaignUserType;
};

export type PintoProductCampaignConnection = {
  __typename?: 'PintoProductCampaignConnection';
  edges: Array<PintoProductCampaignEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PintoProductCampaignEdge = {
  __typename?: 'PintoProductCampaignEdge';
  cursor: Scalars['String']['output'];
  node: PintoProductCampaign;
};

export enum PintoProductCampaignProductType {
  Ebook = 'ebook',
  EbookBundle = 'ebookBundle'
}

export enum PintoProductCampaignStatus {
  Ended = 'ended',
  Pending = 'pending',
  RegistrationEnded = 'registrationEnded',
  RegistrationStarted = 'registrationStarted',
  Started = 'started'
}

export enum PintoProductCampaignUserType {
  All = 'all',
  Pgc = 'pgc',
  Specific = 'specific',
  Ugc = 'ugc'
}

export type PintoProductCampaignsFilter = {
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PintoProductCampaignsFilterSortBy>;
  sortType?: InputMaybe<SortType>;
};

export enum PintoProductCampaignsFilterSortBy {
  Created = 'created'
}

export type PintoProductSet = {
  __typename?: 'PintoProductSet';
  _id: Scalars['ID']['output'];
  activatedAt: Scalars['Date']['output'];
  coverImage?: Maybe<Scalars['String']['output']>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hasItemVol: Scalars['Boolean']['output'];
  itemSortBy: ProductSetItemSortBy;
  itemSortType: SortType;
  itemsCount: Scalars['Int']['output'];
  ogImageUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  status: ProductSetStatus;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export type PintoProductSetConnection = {
  __typename?: 'PintoProductSetConnection';
  edges: Array<PintoProductSetEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PintoProductSetEdge = {
  __typename?: 'PintoProductSetEdge';
  cursor: Scalars['String']['output'];
  node: PintoProductSet;
};

export type PintoProductSetsFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PintoProductSetsFilterSortBy>;
  sortType?: InputMaybe<SortType>;
  status?: InputMaybe<ProductSetStatus>;
  userId: Scalars['ID']['input'];
};

export enum PintoProductSetsFilterSortBy {
  Activated = 'activated',
  Created = 'created',
  IsFullAndTitle = 'isFullAndTitle',
  Published = 'published',
  Title = 'title'
}

export enum PintoRecommendationEbookReviewRatingTier {
  Tier1Plus = 'tier1Plus',
  Tier2Plus = 'tier2Plus',
  Tier3Plus = 'tier3Plus',
  Tier4Plus = 'tier4Plus'
}

export type PintoTag = {
  __typename?: 'PintoTag';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  isReserved: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productsCount: Scalars['Int']['output'];
  searchesCount: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type PintoTagConnection = {
  __typename?: 'PintoTagConnection';
  edges: Array<PintoTagEdge>;
  pageInfo: PageInfo;
};

export type PintoTagEdge = {
  __typename?: 'PintoTagEdge';
  cursor: Scalars['String']['output'];
  node: PintoTag;
};

export type PintoUploadEbookSubmissionInput = {
  _id: Scalars['ID']['input'];
  adminNote: Scalars['String']['input'];
};

export type PintoVoucher = {
  __typename?: 'PintoVoucher';
  code: Scalars['ID']['output'];
  conditionErrorMsg?: Maybe<Scalars['String']['output']>;
  conditions: Array<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountThb: Scalars['Float']['output'];
  discountType: PintoVoucherDiscountType;
  display: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  expiredAt?: Maybe<Scalars['Date']['output']>;
  iconImageUrl?: Maybe<Scalars['String']['output']>;
  isMembershipEarlyBird: Scalars['Boolean']['output'];
  isMembershipOnly: Scalars['Boolean']['output'];
  maximumDiscountAmount?: Maybe<Scalars['Float']['output']>;
  maximumRedeemedCounts?: Maybe<Scalars['Int']['output']>;
  maximumRedeemedCountsPerMembership?: Maybe<Scalars['Int']['output']>;
  maximumRedeemedCountsPerUser?: Maybe<Scalars['Int']['output']>;
  membershipStartedAt?: Maybe<Scalars['Date']['output']>;
  minimumSpendThb: Scalars['Float']['output'];
  myRedeemedCounts: Scalars['Int']['output'];
  participatingItems?: Maybe<PintoVoucherParticipatingItem>;
  redeemedCounts: Scalars['Int']['output'];
  startedAt: Scalars['Date']['output'];
  status: PintoVoucherStatus;
  subType: PintoVoucherSubType;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  type: PintoVoucherType;
  updatedAt: Scalars['Date']['output'];
};

export type PintoVoucherConnection = {
  __typename?: 'PintoVoucherConnection';
  edges: Array<PintoVoucherEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum PintoVoucherDiscountType {
  PercentageCoinBack = 'percentageCoinBack',
  PercentageThb = 'percentageThb',
  Thb = 'thb'
}

export type PintoVoucherEdge = {
  __typename?: 'PintoVoucherEdge';
  cursor: Scalars['String']['output'];
  node: PintoVoucher;
};

export type PintoVoucherParticipatingItem = {
  __typename?: 'PintoVoucherParticipatingItem';
  itemIds: Array<Scalars['ID']['output']>;
  itemType: PintoVoucherParticipatingItemType;
  items?: Maybe<Array<PintoVoucherParticipatingItemData>>;
};

export type PintoVoucherParticipatingItemData = PintoCategory | User;

export enum PintoVoucherParticipatingItemType {
  Category = 'category',
  Ebook = 'ebook',
  EbookBundle = 'ebookBundle',
  Seller = 'seller'
}

export enum PintoVoucherStatus {
  Active = 'active',
  Expired = 'expired',
  Scheduled = 'scheduled'
}

export enum PintoVoucherSubType {
  Normal = 'normal',
  Special = 'special'
}

export enum PintoVoucherType {
  AllUser = 'allUser',
  NonPaid = 'nonPaid',
  SpecificUser = 'specificUser'
}

export type PintoVouchersFilter = {
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PintoVoucherStatus>;
};

export enum Platform {
  Fictionlog = 'fictionlog',
  Pinto = 'pinto'
}

export type Popup = {
  __typename?: 'Popup';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  isActivated: Scalars['Boolean']['output'];
  items: Array<PopupItem>;
  itemsCount: PopupItemsCount;
  pref: FeedPref;
  slug?: Maybe<Scalars['String']['output']>;
  type: PopupType;
  unionItems: Array<UnionSectionItem>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};


export type PopupUnionItemsArgs = {
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
};

export type PopupConnection = {
  __typename?: 'PopupConnection';
  edges: Array<PopupEdge>;
  pageInfo: PageInfo;
};

export type PopupEdge = {
  __typename?: 'PopupEdge';
  cursor: Scalars['String']['output'];
  node: Popup;
};

export type PopupItem = {
  __typename?: 'PopupItem';
  _id: Scalars['ID']['output'];
  config: IPopupItemConfig;
  note?: Maybe<Scalars['String']['output']>;
  schedules?: Maybe<Array<Maybe<Schedule>>>;
  type: PopupItemType;
};

export type PopupItemConfigBook = IPopupItemConfig & {
  __typename?: 'PopupItemConfigBook';
  _id: Scalars['ID']['output'];
  popupImageUrl: Scalars['String']['output'];
};

export type PopupItemConfigEbook = IPopupItemConfig & {
  __typename?: 'PopupItemConfigEbook';
  _id: Scalars['ID']['output'];
  popupImageUrl: Scalars['String']['output'];
};

export type PopupItemConfigExploreBook = IPopupItemConfig & {
  __typename?: 'PopupItemConfigExploreBook';
  categoryTagId?: Maybe<Scalars['ID']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  contentRatingIds?: Maybe<Array<Scalars['ID']['output']>>;
  contentType: ContentType;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  popupImageUrl: Scalars['String']['output'];
  sortBy?: Maybe<ExploreBookSortBy>;
};

export type PopupItemConfigExploreEbook = IPopupItemConfig & {
  __typename?: 'PopupItemConfigExploreEbook';
  categoryTagId?: Maybe<Scalars['ID']['output']>;
  contentRatingIds?: Maybe<Array<Scalars['ID']['output']>>;
  contentType: ContentType;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  popupImageUrl: Scalars['String']['output'];
  sortBy?: Maybe<ExploreEbookSortBy>;
};

export type PopupItemConfigFeed = IPopupItemConfig & {
  __typename?: 'PopupItemConfigFeed';
  popupImageUrl: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type PopupItemConfigLink = IPopupItemConfig & {
  __typename?: 'PopupItemConfigLink';
  popupImageUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PopupItemConfigProductSet = IPopupItemConfig & {
  __typename?: 'PopupItemConfigProductSet';
  _id: Scalars['ID']['output'];
  popupImageUrl: Scalars['String']['output'];
};

export type PopupItemConfigSearch = IPopupItemConfig & {
  __typename?: 'PopupItemConfigSearch';
  categoryTagId?: Maybe<Scalars['ID']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  contentRatingIds?: Maybe<Array<Scalars['ID']['output']>>;
  contentType: ContentType;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  popupImageUrl: Scalars['String']['output'];
  searchText?: Maybe<Scalars['String']['output']>;
  searchType: SearchType;
};

export type PopupItemConfigSection = IPopupItemConfig & {
  __typename?: 'PopupItemConfigSection';
  _id: Scalars['ID']['output'];
  popupImageUrl: Scalars['String']['output'];
};

export type PopupItemConfigStatic = IPopupItemConfig & {
  __typename?: 'PopupItemConfigStatic';
  popupImageUrl: Scalars['String']['output'];
};

export enum PopupItemType {
  Book = 'book',
  Ebook = 'ebook',
  ExploreBook = 'exploreBook',
  ExploreEbook = 'exploreEbook',
  Feed = 'feed',
  Link = 'link',
  ProductSet = 'productSet',
  Search = 'search',
  Section = 'section',
  Static = 'static',
  User = 'user'
}

export type PopupItemsCount = {
  __typename?: 'PopupItemsCount';
  activeItems: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
};

export enum PopupType {
  Startup = 'startup'
}

export type PopupsFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  pref?: InputMaybe<FeedPref>;
  sortBy?: InputMaybe<PopupsFilterSortBy>;
  sortType?: InputMaybe<SortType>;
  type?: InputMaybe<PopupType>;
};

export enum PopupsFilterSortBy {
  Created = 'created',
  Updated = 'updated'
}

export enum Preference {
  Default = 'default',
  Female = 'female',
  Male = 'male',
  Y = 'y'
}

export type PresignedUpload = {
  __typename?: 'PresignedUpload';
  fields?: Maybe<Scalars['JSON']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PreviewFeedFilter = {
  enableNCContent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PreviewPintoProductCampaignOgImageInput = {
  discountRatio: Scalars['Float']['input'];
  ebookCoverImageUrl: Scalars['String']['input'];
  ebookOriginalPriceThb: Scalars['Float']['input'];
  templateOgImageUrl: Scalars['String']['input'];
};

export type PreviewProductItem = {
  __typename?: 'PreviewProductItem';
  _id: Scalars['ID']['output'];
  contentType: ContentType;
  coverImage: Scalars['String']['output'];
  productType: ProductType;
  title?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
};

export type PreviewProductsInput = {
  bookIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ebookIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Price = {
  __typename?: 'Price';
  _id?: Maybe<Scalars['ID']['output']>;
  goldCoin?: Maybe<Scalars['Int']['output']>;
  silverCoin?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<PriceType>;
};

export enum PriceType {
  EarlyChapter = 'earlyChapter',
  FreeChapter = 'freeChapter',
  PaidChapter = 'paidChapter'
}

export type Product = Book | Ebook;

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges: Array<ProductEdge>;
  pageInfo: PageInfo;
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type ProductSet = {
  __typename?: 'ProductSet';
  _id: Scalars['ID']['output'];
  activatedAt: Scalars['Date']['output'];
  contentType?: Maybe<ContentType>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  products?: Maybe<ProductConnection>;
  productsCount: ProductsCount;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  status: ProductSetStatus;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};


export type ProductSetProductsArgs = {
  filter?: InputMaybe<ProductSetProductsFilter>;
};

export type ProductSetConnection = {
  __typename?: 'ProductSetConnection';
  edges: Array<ProductSetEdge>;
  pageInfo: PageInfo;
};

export type ProductSetEdge = {
  __typename?: 'ProductSetEdge';
  cursor: Scalars['String']['output'];
  node: ProductSet;
};

export enum ProductSetItemSortBy {
  Activated = 'activated',
  Created = 'created',
  Order = 'order',
  Published = 'published',
  Vol = 'vol'
}

export type ProductSetProductsFilter = {
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProductSetStatus {
  Draft = 'draft',
  Public = 'public',
  Removed = 'removed'
}

export type ProductSetsFilter = {
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productType?: InputMaybe<ProductType>;
  sortBy?: InputMaybe<ProductSetsFilterSortBy>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ProductSetsFilterSortBy {
  Activated = 'activated',
  Created = 'created',
  Published = 'published'
}

export enum ProductType {
  Book = 'book',
  Ebook = 'ebook'
}

export type ProductsCount = {
  __typename?: 'ProductsCount';
  draft?: Maybe<Scalars['Int']['output']>;
  public: Scalars['Int']['output'];
  scheduled?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export enum PublisherType {
  Pgc = 'pgc',
  Ugc = 'ugc'
}

export type PurchaseTransaction = {
  __typename?: 'PurchaseTransaction';
  _id?: Maybe<Scalars['ID']['output']>;
  book?: Maybe<Book>;
  bookId?: Maybe<Scalars['ID']['output']>;
  buyer: User;
  chapter?: Maybe<Chapter>;
  chapterId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  earningsRatio?: Maybe<Scalars['Float']['output']>;
  ebook?: Maybe<Ebook>;
  ebookId?: Maybe<Scalars['ID']['output']>;
  goldCoin?: Maybe<Scalars['Int']['output']>;
  paidAt: Scalars['Date']['output'];
  seller: User;
  silverCoin?: Maybe<Scalars['Int']['output']>;
};

export type PurchaseTransactionBill = {
  __typename?: 'PurchaseTransactionBill';
  date?: Maybe<Scalars['String']['output']>;
  goldCoin?: Maybe<Scalars['Int']['output']>;
  item?: Maybe<PurchaseTransactionBillItem>;
  latestCreatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PurchaseTransactionBillItem = Book | Ebook;

export type PurchaseTransactionBillsFilter = {
  buyerId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseTransactionConnection = {
  __typename?: 'PurchaseTransactionConnection';
  edges: Array<PurchaseTransactionEdge>;
  pageInfo: PageInfo;
};

export type PurchaseTransactionEdge = {
  __typename?: 'PurchaseTransactionEdge';
  cursor: Scalars['String']['output'];
  node: PurchaseTransaction;
};

export type PurchaseTransactionsFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  bookId?: InputMaybe<Scalars['ID']['input']>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  chapterId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sellerId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ReadingType {
  LeftToRight = 'leftToRight',
  RightToLeft = 'rightToLeft',
  TopToBottomWithoutSpace = 'topToBottomWithoutSpace'
}

export type RefillCampaign = {
  __typename?: 'RefillCampaign';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  endedAt?: Maybe<Scalars['Date']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type RefillFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export enum RefillFlowId {
  AndroidInAppPurchase = 'androidInAppPurchase',
  IosInAppPurchase = 'iosInAppPurchase',
  NonSelectPackage = 'nonSelectPackage',
  OmiseCreditDebitCard = 'omiseCreditDebitCard',
  OmiseIBanking = 'omiseIBanking',
  QrCode = 'qrCode',
  RedeemVoucher = 'redeemVoucher',
  SelectPackage = 'selectPackage'
}

export type RefillPackageTier = {
  __typename?: 'RefillPackageTier';
  _id?: Maybe<Scalars['ID']['output']>;
  goldCoin?: Maybe<Scalars['Int']['output']>;
  goldCoinBonus?: Maybe<Scalars['Int']['output']>;
  thb?: Maybe<Scalars['Float']['output']>;
};

export enum RefillProvider {
  Apple = 'apple',
  Fictionlog = 'fictionlog',
  GbPrimePay = 'gbPrimePay',
  Google = 'google',
  Omise = 'omise',
  Razer = 'razer',
  ShopeePay = 'shopeePay'
}

export type RefillReportFilter = {
  endDate: Scalars['String']['input'];
  refillServiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['String']['input'];
  unit: RefillReportUnit;
};

export enum RefillReportUnit {
  GoldCoin = 'goldCoin',
  TimesCount = 'timesCount'
}

export type RefillService = {
  __typename?: 'RefillService';
  _id: Scalars['ID']['output'];
  flowId?: Maybe<RefillFlowId>;
  iconImage?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<RefillServiceMeta>;
  provider: RefillProvider;
  refillPackageTiers: Array<RefillPackageTier>;
  title: Scalars['String']['output'];
};

export type RefillServiceBadge = {
  __typename?: 'RefillServiceBadge';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  fontColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RefillServiceMeta = {
  __typename?: 'RefillServiceMeta';
  badges?: Maybe<Array<Maybe<RefillServiceBadge>>>;
  sourceType?: Maybe<Scalars['String']['output']>;
};

export type RefillTransaction = {
  __typename?: 'RefillTransaction';
  _id: Scalars['ID']['output'];
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  expiredAt?: Maybe<Scalars['Date']['output']>;
  goldCoin?: Maybe<Scalars['Int']['output']>;
  goldCoinBonus?: Maybe<Scalars['Int']['output']>;
  goldCoinGeneral: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  refillCampaign?: Maybe<RefillCampaign>;
  refillService: RefillService;
  silverCoin?: Maybe<Scalars['Int']['output']>;
  status: RefillTransactionStatus;
  thb?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type RefillTransactionConnection = {
  __typename?: 'RefillTransactionConnection';
  edges: Array<RefillTransactionEdge>;
  pageInfo: PageInfo;
};

export type RefillTransactionEdge = {
  __typename?: 'RefillTransactionEdge';
  cursor: Scalars['String']['output'];
  node: RefillTransaction;
};

export enum RefillTransactionStatus {
  Expired = 'expired',
  Failed = 'failed',
  Pending = 'pending',
  Reversed = 'reversed',
  Successful = 'successful'
}

export type RefillTransactionsFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RegisterFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type RejectTaxpayerBankAccountInput = {
  rejectNotes?: InputMaybe<Array<RejectTaxpayerBankAccountRejectNoteInput>>;
};

export type RejectTaxpayerBankAccountRejectNoteInput = {
  content: Scalars['String']['input'];
  type?: InputMaybe<TaxpayerBankAccountRejectNoteType>;
};

export type RemoveBookInput = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveEbookBundleInput = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveEbookInput = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type Report = {
  __typename?: 'Report';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  status: ReportStatus;
  type: ReportType;
  updatedAt: Scalars['Date']['output'];
};

export type ReportConnection = {
  __typename?: 'ReportConnection';
  edges: Array<ReportEdge>;
  pageInfo: PageInfo;
};

export type ReportEdge = {
  __typename?: 'ReportEdge';
  cursor: Scalars['String']['output'];
  node: Report;
};

export enum ReportStatus {
  Completed = 'completed',
  Failed = 'failed',
  Processing = 'processing',
  Waiting = 'waiting'
}

export enum ReportType {
  ActiveContent = 'activeContent',
  ActiveContentByCategory = 'activeContentByCategory',
  ActiveReaderByCategory = 'activeReaderByCategory',
  ActiveReaderByContent = 'activeReaderByContent',
  ActiveWriterByCategory = 'activeWriterByCategory',
  ActiveWriterByContent = 'activeWriterByContent',
  MonthlyActiveStakeholder = 'monthlyActiveStakeholder',
  Refill = 'refill',
  SaleByCategory = 'saleByCategory',
  SaleByContent = 'saleByContent',
  SaleByType = 'saleByType'
}

export type ReportsFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReportStatus>;
  types?: InputMaybe<Array<ReportType>>;
};

export type ResetPassword = {
  __typename?: 'ResetPassword';
  resetPasswordUrl: Scalars['String']['output'];
};

export type RetentionFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  ndays?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<RetentionScope>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export enum RetentionScope {
  BookPurchase = 'book_purchase',
  EbookPurchase = 'ebook_purchase',
  View = 'view'
}

export type RootMutation = {
  __typename?: 'RootMutation';
  activateTaxpayerBankAccount: TaxpayerBankAccount;
  approveBankTransfer: BankTransfer;
  approveEditChapter?: Maybe<Scalars['JSON']['output']>;
  approveEditEbook?: Maybe<DefaultType>;
  cancelEbookDiscountCampaign?: Maybe<Scalars['Void']['output']>;
  createAndSubmitReviewEbook: Ebook;
  createBookPageAd: BookPageAd;
  createDraftEbook: Ebook;
  createEbookDiscountCampaign: EbookDiscountCampaign;
  createFeed?: Maybe<Feed>;
  createPintoAnnouncementNotification: PintoAnnouncementNotification;
  createPintoEbookCollection: PintoEbookCollection;
  createPintoProductCampaign: PintoProductCampaign;
  createPintoSubscriptionTitle: SubscriptionTitle;
  createPopup: Popup;
  createPresignedUploadEbookFile?: Maybe<PresignedUpload>;
  createSection?: Maybe<Section>;
  createTag: Tag;
  createTemplate: Template;
  createVoucher?: Maybe<Voucher>;
  deleteExportRaw?: Maybe<Scalars['JSON']['output']>;
  deleteFeed?: Maybe<Scalars['JSON']['output']>;
  deletePintoAnnouncementNotification: PintoAnnouncementNotification;
  deletePintoEbookCollection: DefaultType;
  deletePintoProductCampaign: DefaultType;
  deletePintoVouchers: DefaultType;
  deleteProductSet: ProductSet;
  deleteSection?: Maybe<Scalars['JSON']['output']>;
  deleteStaticFile?: Maybe<Scalars['JSON']['output']>;
  deleteTag: Tag;
  deleteTaxpayerBankAccount: TaxpayerBankAccount;
  downloadEbookBundles: Scalars['String']['output'];
  downloadMonthlyBankTransfer: Scalars['String']['output'];
  editBook?: Maybe<Book>;
  editDraftEbook: Ebook;
  editEbook?: Maybe<Ebook>;
  editEbookWithSkipReview?: Maybe<Ebook>;
  editGeneralTaxpayerBankAccount: TaxpayerBankAccount;
  editPintoEbookCollection: PintoEbookCollection;
  editPintoSubscriptionTitle: SubscriptionTitle;
  editPremiumTaxpayerBankAccount: TaxpayerBankAccount;
  editProductSet: ProductSet;
  editTag: Tag;
  generateActiveContentByCategoryReport?: Maybe<Scalars['Void']['output']>;
  generateActiveContentReport?: Maybe<Scalars['Void']['output']>;
  generateActiveReaderByCategoryReport?: Maybe<Scalars['Void']['output']>;
  generateActiveReaderByContentReport?: Maybe<Scalars['Void']['output']>;
  generateActiveWriterByCategoryReport?: Maybe<Scalars['Void']['output']>;
  generateActiveWriterByContentReport?: Maybe<Scalars['Void']['output']>;
  generateExportRaw?: Maybe<ExportRaw>;
  generateMonthlyActiveStakeholderReport?: Maybe<Scalars['Void']['output']>;
  generateRefillReport?: Maybe<Scalars['Void']['output']>;
  generateSaleByCategoryReport?: Maybe<Scalars['Void']['output']>;
  generateSaleByContentReport?: Maybe<Scalars['Void']['output']>;
  generateSaleByTypeReport?: Maybe<Scalars['Void']['output']>;
  generateUser: User;
  hideEbook: Ebook;
  login: UserAndToken;
  logout: UserAndToken;
  markAsPaidBankTransfer: BankTransfer;
  pintoCancelEbookSubmission: DefaultType;
  pintoCancelEbookSubmissionItem: DefaultType;
  pintoCreateFeed: Feed;
  pintoCreatePresignedUploadEbookFile?: Maybe<PresignedUpload>;
  pintoCreateSection: Section;
  pintoDeleteFeed?: Maybe<Scalars['JSON']['output']>;
  pintoDeleteSection?: Maybe<Scalars['JSON']['output']>;
  pintoPreviewEbookSubmission: PintoEbookSubmissionPreview;
  pintoUpdateFeed: Feed;
  pintoUpdateSection?: Maybe<Section>;
  pintoUploadEbookImage: Scalars['String']['output'];
  pintoUploadEbookSubmission: PintoEbookSubmission;
  pintoUploadStaticFiles: Array<Maybe<StaticFile>>;
  previewFeed?: Maybe<Template>;
  previewPintoProductCampaignOgImage: Scalars['String']['output'];
  previewSection?: Maybe<SectionV3>;
  rejectEditChapter?: Maybe<EditChapter>;
  rejectEditEbook?: Maybe<DefaultType>;
  rejectTaxpayerBankAccount: TaxpayerBankAccount;
  removeBook?: Maybe<Book>;
  removeBookCoverImage?: Maybe<Scalars['JSON']['output']>;
  removeEbook?: Maybe<Ebook>;
  removeEbookBundle?: Maybe<EbookBundle>;
  removeEbookCoverImage?: Maybe<Scalars['JSON']['output']>;
  resetPassword: ResetPassword;
  searchUser?: Maybe<User>;
  sendNotifies?: Maybe<Scalars['JSON']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  submitReviewDraftEbook: Ebook;
  suspendedBook: Book;
  unhideEbook: Ebook;
  unsuspendedBook: Book;
  updateBankTransfer: BankTransfer;
  updateFeed?: Maybe<Feed>;
  updatePintoProductCampaign: PintoProductCampaign;
  updatePintoVouchers: DefaultType;
  updatePopup: Popup;
  updateSection?: Maybe<Section>;
  updateTemplate: Template;
  updateUser: User;
  uploadEbookBundle?: Maybe<Scalars['Void']['output']>;
  uploadMonthlyBankTransfer: Scalars['String']['output'];
  uploadPintoVouchers: UploadPintoVoucherInfo;
  uploadRequestedEbookFile?: Maybe<DefaultType>;
  uploadStaticFile?: Maybe<StaticFile>;
  upsertPermission?: Maybe<Scalars['JSON']['output']>;
  upsertPickedTag: CategoryPickedTag;
  upsertTemplate: Template;
};


export type RootMutationActivateTaxpayerBankAccountArgs = {
  input?: InputMaybe<ActivateTaxpayerBankAccountInput>;
  taxpayerBankAccountId: Scalars['ID']['input'];
};


export type RootMutationApproveBankTransferArgs = {
  bankTransferId: Scalars['ID']['input'];
  input?: InputMaybe<ApproveBankTransferInput>;
};


export type RootMutationApproveEditChapterArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationApproveEditEbookArgs = {
  ebookId: Scalars['ID']['input'];
  fileTypes: Array<EbookFileType>;
};


export type RootMutationCancelEbookDiscountCampaignArgs = {
  ebookDiscountCampaignId: Scalars['ID']['input'];
};


export type RootMutationCreateAndSubmitReviewEbookArgs = {
  input: CreateAndSubmitReviewEbookInput;
};


export type RootMutationCreateBookPageAdArgs = {
  input: CreateBookPageAdInput;
};


export type RootMutationCreateDraftEbookArgs = {
  input: CreateDraftEbookInput;
};


export type RootMutationCreateEbookDiscountCampaignArgs = {
  input: CreateEbookDiscountCampaignInput;
};


export type RootMutationCreateFeedArgs = {
  input: CreateFeedInput;
};


export type RootMutationCreatePintoAnnouncementNotificationArgs = {
  input: CreatePintoAnnouncementNotificationInput;
};


export type RootMutationCreatePintoEbookCollectionArgs = {
  input: CreatePintoEbookCollectionInput;
};


export type RootMutationCreatePintoProductCampaignArgs = {
  input: CreatePintoProductCampaignInput;
};


export type RootMutationCreatePintoSubscriptionTitleArgs = {
  input: CreatePintoSubscriptionTitleInput;
};


export type RootMutationCreatePopupArgs = {
  input: CreatePopupInput;
};


export type RootMutationCreatePresignedUploadEbookFileArgs = {
  ebookId: Scalars['ID']['input'];
  input: CreatePresignedUploadEbookFileInput;
};


export type RootMutationCreateSectionArgs = {
  input: SectionInput;
};


export type RootMutationCreateTagArgs = {
  input: CreateTagInput;
};


export type RootMutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type RootMutationCreateVoucherArgs = {
  input: VoucherInput;
};


export type RootMutationDeleteExportRawArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationDeleteFeedArgs = {
  pref: FeedPref;
  slug: Scalars['String']['input'];
};


export type RootMutationDeletePintoAnnouncementNotificationArgs = {
  announcementNotificationId: Scalars['ID']['input'];
};


export type RootMutationDeletePintoEbookCollectionArgs = {
  ebookCollectionId: Scalars['ID']['input'];
};


export type RootMutationDeletePintoProductCampaignArgs = {
  productCampaignId: Scalars['ID']['input'];
};


export type RootMutationDeletePintoVouchersArgs = {
  codes: Array<Scalars['ID']['input']>;
};


export type RootMutationDeleteProductSetArgs = {
  productSetId: Scalars['ID']['input'];
};


export type RootMutationDeleteSectionArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationDeleteStaticFileArgs = {
  url: Scalars['String']['input'];
};


export type RootMutationDeleteTagArgs = {
  tagId: Scalars['ID']['input'];
};


export type RootMutationDeleteTaxpayerBankAccountArgs = {
  taxpayerBankAccountId: Scalars['ID']['input'];
};


export type RootMutationDownloadMonthlyBankTransferArgs = {
  monthlyBankTransferId: Scalars['ID']['input'];
};


export type RootMutationEditBookArgs = {
  id: Scalars['ID']['input'];
  input: EditBookInput;
};


export type RootMutationEditDraftEbookArgs = {
  ebookId: Scalars['ID']['input'];
  input: EditDraftEbookInput;
};


export type RootMutationEditEbookArgs = {
  id: Scalars['ID']['input'];
  input: EditEbookInput;
};


export type RootMutationEditEbookWithSkipReviewArgs = {
  id: Scalars['ID']['input'];
  input: EditEbookInput;
};


export type RootMutationEditGeneralTaxpayerBankAccountArgs = {
  input: EditGeneralTaxpayerBankAccountInput;
  taxpayerBankAccountId: Scalars['ID']['input'];
};


export type RootMutationEditPintoEbookCollectionArgs = {
  ebookCollectionId: Scalars['ID']['input'];
  input: CreatePintoEbookCollectionInput;
};


export type RootMutationEditPintoSubscriptionTitleArgs = {
  input: EditPintoSubscriptionTitleInput;
  subscriptionTitleId: Scalars['ID']['input'];
};


export type RootMutationEditPremiumTaxpayerBankAccountArgs = {
  input: EditPremiumTaxpayerBankAccountInput;
  taxpayerBankAccountId: Scalars['ID']['input'];
};


export type RootMutationEditProductSetArgs = {
  input: EditProductSetInput;
  productSetId: Scalars['ID']['input'];
};


export type RootMutationEditTagArgs = {
  input: EditTagInput;
  tagId: Scalars['ID']['input'];
};


export type RootMutationGenerateActiveContentByCategoryReportArgs = {
  filter: GenerateActiveContentByCategoryReportFilter;
};


export type RootMutationGenerateActiveContentReportArgs = {
  filter: GenerateActiveContentReportFilter;
};


export type RootMutationGenerateActiveReaderByCategoryReportArgs = {
  filter: GenerateActiveStakeholderByCategoryReportFilter;
};


export type RootMutationGenerateActiveReaderByContentReportArgs = {
  filter: GenerateActiveStakeholderByContentReportFilter;
};


export type RootMutationGenerateActiveWriterByCategoryReportArgs = {
  filter: GenerateActiveStakeholderByCategoryReportFilter;
};


export type RootMutationGenerateActiveWriterByContentReportArgs = {
  filter: GenerateActiveStakeholderByContentReportFilter;
};


export type RootMutationGenerateExportRawArgs = {
  input: ExportRawInput;
};


export type RootMutationGenerateMonthlyActiveStakeholderReportArgs = {
  filter: GenerateMonthlyActiveStakeholderReportFilter;
};


export type RootMutationGenerateRefillReportArgs = {
  filter: RefillReportFilter;
};


export type RootMutationGenerateSaleByCategoryReportArgs = {
  filter: SaleByCategoryReportFilter;
};


export type RootMutationGenerateSaleByContentReportArgs = {
  filter: SaleByContentReportFilter;
};


export type RootMutationGenerateSaleByTypeReportArgs = {
  filter: SaleByTypeReportFilter;
};


export type RootMutationGenerateUserArgs = {
  input: GenerateUserInput;
};


export type RootMutationHideEbookArgs = {
  ebookId: Scalars['ID']['input'];
};


export type RootMutationLoginArgs = {
  input: LoginInput;
};


export type RootMutationMarkAsPaidBankTransferArgs = {
  bankTransferId: Scalars['ID']['input'];
  input: MarkAsPaidBankTransferInput;
};


export type RootMutationPintoCancelEbookSubmissionArgs = {
  ebookSubmissionId: Scalars['ID']['input'];
};


export type RootMutationPintoCancelEbookSubmissionItemArgs = {
  ebookSubmissionItemId: Scalars['ID']['input'];
};


export type RootMutationPintoCreateFeedArgs = {
  input: CreateFeedInput;
};


export type RootMutationPintoCreatePresignedUploadEbookFileArgs = {
  input: CreatePresignedUploadEbookFileInput;
};


export type RootMutationPintoCreateSectionArgs = {
  input: SectionInput;
};


export type RootMutationPintoDeleteFeedArgs = {
  pref: FeedPref;
  slug: Scalars['String']['input'];
};


export type RootMutationPintoDeleteSectionArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationPintoPreviewEbookSubmissionArgs = {
  input: PintoPreviewEbookSubmissionInput;
};


export type RootMutationPintoUpdateFeedArgs = {
  input: FeedInput;
  pref: FeedPref;
  slug: Scalars['String']['input'];
};


export type RootMutationPintoUpdateSectionArgs = {
  id: Scalars['ID']['input'];
  input: SectionInput;
};


export type RootMutationPintoUploadEbookImageArgs = {
  input: UploadEbookImageInput;
};


export type RootMutationPintoUploadEbookSubmissionArgs = {
  input: PintoUploadEbookSubmissionInput;
};


export type RootMutationPintoUploadStaticFilesArgs = {
  data: Array<Scalars['String']['input']>;
};


export type RootMutationPreviewFeedArgs = {
  filter?: InputMaybe<PreviewFeedFilter>;
  input: FeedInput;
};


export type RootMutationPreviewPintoProductCampaignOgImageArgs = {
  input: PreviewPintoProductCampaignOgImageInput;
};


export type RootMutationPreviewSectionArgs = {
  input: SectionInput;
};


export type RootMutationRejectEditChapterArgs = {
  id: Scalars['ID']['input'];
  rejectNote?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationRejectEditEbookArgs = {
  ebookId: Scalars['ID']['input'];
  fileTypes: Array<EbookFileType>;
  rejectNote?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationRejectTaxpayerBankAccountArgs = {
  input: RejectTaxpayerBankAccountInput;
  taxpayerBankAccountId: Scalars['ID']['input'];
};


export type RootMutationRemoveBookArgs = {
  input: RemoveBookInput;
};


export type RootMutationRemoveBookCoverImageArgs = {
  bookId: Scalars['ID']['input'];
};


export type RootMutationRemoveEbookArgs = {
  input: RemoveEbookInput;
};


export type RootMutationRemoveEbookBundleArgs = {
  input: RemoveEbookBundleInput;
};


export type RootMutationRemoveEbookCoverImageArgs = {
  ebookId: Scalars['ID']['input'];
};


export type RootMutationResetPasswordArgs = {
  userId: Scalars['ID']['input'];
};


export type RootMutationSearchUserArgs = {
  text: Scalars['String']['input'];
};


export type RootMutationSendNotifiesArgs = {
  key: Scalars['String']['input'];
};


export type RootMutationSignedUrlArgs = {
  url: Scalars['String']['input'];
};


export type RootMutationSubmitReviewDraftEbookArgs = {
  ebookId: Scalars['ID']['input'];
  input: SubmitReviewEbookInput;
};


export type RootMutationSuspendedBookArgs = {
  bookId: Scalars['ID']['input'];
};


export type RootMutationUnhideEbookArgs = {
  ebookId: Scalars['ID']['input'];
};


export type RootMutationUnsuspendedBookArgs = {
  bookId: Scalars['ID']['input'];
};


export type RootMutationUpdateBankTransferArgs = {
  bankTransferId: Scalars['ID']['input'];
  input: UpdateBankTransferInput;
};


export type RootMutationUpdateFeedArgs = {
  input: FeedInput;
  pref: FeedPref;
  slug: Scalars['String']['input'];
};


export type RootMutationUpdatePintoProductCampaignArgs = {
  input: UpdatePintoProductCampaignInput;
  productCampaignId: Scalars['ID']['input'];
};


export type RootMutationUpdatePintoVouchersArgs = {
  codes: Array<Scalars['ID']['input']>;
  input: UpdatePintoVouchersInput;
};


export type RootMutationUpdatePopupArgs = {
  input: UpdatePopupInput;
  popupId: Scalars['ID']['input'];
};


export type RootMutationUpdateSectionArgs = {
  id: Scalars['ID']['input'];
  input: SectionInput;
};


export type RootMutationUpdateTemplateArgs = {
  input: UpdateTemplateInput;
  templateId: Scalars['ID']['input'];
};


export type RootMutationUpdateUserArgs = {
  input: UpdateUserInput;
  userId: Scalars['ID']['input'];
};


export type RootMutationUploadEbookBundleArgs = {
  input: UploadEbookBundleInput;
};


export type RootMutationUploadMonthlyBankTransferArgs = {
  input: UploadMonthlyBankTransferInput;
  monthlyBankTransferId: Scalars['ID']['input'];
};


export type RootMutationUploadPintoVouchersArgs = {
  input: UploadPintoVouchersInput;
};


export type RootMutationUploadRequestedEbookFileArgs = {
  ebookId: Scalars['ID']['input'];
  input: UploadRequestedEbookFileInput;
};


export type RootMutationUploadStaticFileArgs = {
  data: Scalars['String']['input'];
};


export type RootMutationUpsertPermissionArgs = {
  input: PermissionInput;
};


export type RootMutationUpsertPickedTagArgs = {
  input: UpsertPickedTagInput;
};


export type RootMutationUpsertTemplateArgs = {
  input: UpsertTemplateInput;
};

export type RootQuery = {
  __typename?: 'RootQuery';
  bankTransfer: BankTransfer;
  bankTransfers: BankTransferConnection;
  bestSeller?: Maybe<Array<Maybe<BestSeller>>>;
  book?: Maybe<Book>;
  bookPageAd: BookPageAd;
  bookPageAds: BookPageAdConnection;
  books?: Maybe<BookConnection>;
  categories?: Maybe<Array<Maybe<Category>>>;
  chapter?: Maybe<Chapter>;
  chapters?: Maybe<Array<Maybe<Chapter>>>;
  contentRatings?: Maybe<Array<Maybe<ContentRating>>>;
  currentUser?: Maybe<User>;
  ebook?: Maybe<Ebook>;
  ebookBundle: EbookBundle;
  ebookBundleSubmissions: Array<Maybe<EbookBundleSubmission>>;
  ebookDiscountCampaign: EbookDiscountCampaign;
  ebookDiscountCampaigns: EbookDiscountCampaignConnection;
  ebookOptions: EbookOptions;
  ebooks?: Maybe<EbookConnection>;
  editChapter?: Maybe<EditChapter>;
  editChapters?: Maybe<Array<Maybe<EditChapter>>>;
  editEbook?: Maybe<EditEbook>;
  editEbooks?: Maybe<EditEbookConnection>;
  exportBankTransfers?: Maybe<Scalars['String']['output']>;
  exportPurchaseTransactions?: Maybe<Scalars['String']['output']>;
  exportRaws?: Maybe<Array<Maybe<ExportRaw>>>;
  exportRefillTransactions?: Maybe<Scalars['String']['output']>;
  feed?: Maybe<Feed>;
  feedPagination?: Maybe<FeedConnection>;
  feeds?: Maybe<Array<Maybe<Feed>>>;
  isConvertToPgc?: Maybe<Scalars['Boolean']['output']>;
  metric?: Maybe<Metric>;
  monthlyBankTransfers: MonthlyBankTransferConnection;
  overviews?: Maybe<Overview>;
  pendingEbookInSubscriptionTitle: Array<PendingEbook>;
  permission?: Maybe<Permission>;
  pickedTags: Array<Maybe<CategoryPickedTag>>;
  pintoAnnouncementNotifications: PintoAnnouncementNotificationConnection;
  pintoCategories: Array<Maybe<PintoCategory>>;
  pintoEbookCollection: PintoEbookCollection;
  pintoEbookCollectionItems: EbookConnection;
  pintoEbookCollections: PintoEbookCollectionConnection;
  pintoEbookSubmission: PintoEbookSubmission;
  pintoEbookSubmissionItems: PintoEbookSubmissionItemConnection;
  pintoEbookSubmissions: PintoEbookSubmissionConnection;
  pintoFeed?: Maybe<Feed>;
  pintoFeeds: FeedConnection;
  pintoProductCampaign: PintoProductCampaign;
  pintoProductCampaigns: PintoProductCampaignConnection;
  pintoProductSet: PintoProductSet;
  pintoProductSets: PintoProductSetConnection;
  pintoSection?: Maybe<Section>;
  pintoSections: SectionConnection;
  pintoStaticFiles?: Maybe<Array<Maybe<StaticFile>>>;
  pintoVoucher: PintoVoucher;
  pintoVouchers: PintoVoucherConnection;
  popup?: Maybe<Popup>;
  popups: PopupConnection;
  previewProducts: Array<PreviewProductItem>;
  previewSection: SectionV3;
  productSet: ProductSet;
  productSets: ProductSetConnection;
  purchaseTransactionBills?: Maybe<Array<Maybe<PurchaseTransactionBill>>>;
  purchaseTransactions: PurchaseTransactionConnection;
  refillReport: Array<Scalars['JSON']['output']>;
  refillServices: Array<RefillService>;
  refillTransactions: RefillTransactionConnection;
  refills?: Maybe<Metric>;
  registers?: Maybe<Metric>;
  reports: ReportConnection;
  requestedEbookFiles?: Maybe<EditEbookConnection>;
  retention?: Maybe<Metric>;
  saleByCategoryReport: Array<Scalars['JSON']['output']>;
  saleByContentReport: Array<Scalars['JSON']['output']>;
  saleByTypeReport: Array<Scalars['JSON']['output']>;
  /** @deprecated No longer supported */
  salesReport?: Maybe<Metric>;
  salesReports: SalesReportConnection;
  searchBooks: BookConnection;
  searchEbooks: EbookConnection;
  searchPintoTags: PintoTagConnection;
  searchSubscriptionTitles: SubscriptionTitleConnection;
  searchTags: TagConnection;
  searchUsers: UserConnection;
  section?: Maybe<Section>;
  sectionPagination?: Maybe<SectionConnection>;
  sections?: Maybe<Array<Maybe<Section>>>;
  staticFiles?: Maybe<Array<Maybe<StaticFile>>>;
  subscriptionTitle: SubscriptionTitle;
  tag?: Maybe<Tag>;
  tags: TagConnection;
  tagsCount: TagsCount;
  taxDeductionDocuments: TaxDeductionDocumentConnection;
  taxpayerBankAccount: TaxpayerBankAccount;
  taxpayerBankAccountOptions: TaxpayerBankAccountOptions;
  taxpayerBankAccounts: TaxpayerBankAccountConnection;
  template?: Maybe<Template>;
  templateByQuery?: Maybe<Template>;
  templates: TemplateConnection;
  user?: Maybe<User>;
  users: UserConnection;
  voucher?: Maybe<Voucher>;
  voucherRedemptions?: Maybe<Array<Maybe<VoucherRedemption>>>;
  vouchers?: Maybe<VoucherConnection>;
};


export type RootQueryBankTransferArgs = {
  bankTransferId: Scalars['ID']['input'];
};


export type RootQueryBankTransfersArgs = {
  filter?: InputMaybe<BankTransfersFilter>;
};


export type RootQueryBestSellerArgs = {
  filter?: InputMaybe<BestSellerFilter>;
};


export type RootQueryBookArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryBookPageAdArgs = {
  bookPageAdId: Scalars['ID']['input'];
};


export type RootQueryBookPageAdsArgs = {
  filter?: InputMaybe<BookPageAdsFilter>;
};


export type RootQueryBooksArgs = {
  filter?: InputMaybe<BooksFilter>;
};


export type RootQueryCategoriesArgs = {
  filter?: InputMaybe<CategoriesFilter>;
};


export type RootQueryChapterArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryChaptersArgs = {
  bookId: Scalars['ID']['input'];
};


export type RootQueryContentRatingsArgs = {
  filter?: InputMaybe<ContentRatingsFilter>;
};


export type RootQueryEbookArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryEbookBundleArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryEbookDiscountCampaignArgs = {
  ebookDiscountCampaignId: Scalars['ID']['input'];
};


export type RootQueryEbookDiscountCampaignsArgs = {
  filter?: InputMaybe<EbookDiscountCampaignsFilter>;
};


export type RootQueryEbookOptionsArgs = {
  filter?: InputMaybe<EbookOptionFilter>;
};


export type RootQueryEbooksArgs = {
  filter?: InputMaybe<EbooksFilter>;
};


export type RootQueryEditChapterArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryEditChaptersArgs = {
  filter?: InputMaybe<EditChapterFilter>;
};


export type RootQueryEditEbookArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryEditEbooksArgs = {
  filter?: InputMaybe<EditEbookFilter>;
};


export type RootQueryExportBankTransfersArgs = {
  filter?: InputMaybe<DateRangeFilter>;
};


export type RootQueryExportPurchaseTransactionsArgs = {
  filter?: InputMaybe<DateRangeFilter>;
};


export type RootQueryExportRefillTransactionsArgs = {
  filter?: InputMaybe<DateRangeFilter>;
};


export type RootQueryFeedArgs = {
  pref: Preference;
  slug: Scalars['String']['input'];
};


export type RootQueryFeedPaginationArgs = {
  filter?: InputMaybe<FeedsFilterV2>;
};


export type RootQueryFeedsArgs = {
  filter?: InputMaybe<FeedsFilter>;
};


export type RootQueryIsConvertToPgcArgs = {
  taxpayerBankAccountId: Scalars['ID']['input'];
};


export type RootQueryMetricArgs = {
  filter?: InputMaybe<MetricFilter>;
};


export type RootQueryMonthlyBankTransfersArgs = {
  filter?: InputMaybe<MonthlyBankTransfersFilter>;
};


export type RootQueryOverviewsArgs = {
  filter: OverviewFilter;
};


export type RootQueryPendingEbookInSubscriptionTitleArgs = {
  subscriptionTitleId: Scalars['ID']['input'];
};


export type RootQueryPermissionArgs = {
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryPickedTagsArgs = {
  contentType: ContentType;
  productType?: InputMaybe<ProductType>;
  section: PickedTagSectionType;
};


export type RootQueryPintoAnnouncementNotificationsArgs = {
  filter?: InputMaybe<PintoAnnouncementNotificationsFilter>;
};


export type RootQueryPintoCategoriesArgs = {
  filter?: InputMaybe<PintoCategoriesFilter>;
};


export type RootQueryPintoEbookCollectionArgs = {
  ebookCollectionId: Scalars['ID']['input'];
};


export type RootQueryPintoEbookCollectionItemsArgs = {
  ebookCollectionId: Scalars['ID']['input'];
  filter?: InputMaybe<PintoEbookCollectionItemsFilter>;
};


export type RootQueryPintoEbookCollectionsArgs = {
  filter?: InputMaybe<PintoEbookCollectionsFilter>;
};


export type RootQueryPintoEbookSubmissionArgs = {
  ebookSubmissionId: Scalars['ID']['input'];
};


export type RootQueryPintoEbookSubmissionItemsArgs = {
  ebookSubmissionId: Scalars['ID']['input'];
  filter?: InputMaybe<PintoEbookSubmissionItemsFilter>;
};


export type RootQueryPintoEbookSubmissionsArgs = {
  filter?: InputMaybe<PintoEbookSubmissionsFilter>;
};


export type RootQueryPintoFeedArgs = {
  pref: Preference;
  slug: Scalars['String']['input'];
};


export type RootQueryPintoFeedsArgs = {
  filter?: InputMaybe<FeedsFilterV2>;
};


export type RootQueryPintoProductCampaignArgs = {
  productCampaignId: Scalars['ID']['input'];
};


export type RootQueryPintoProductCampaignsArgs = {
  filter?: InputMaybe<PintoProductCampaignsFilter>;
};


export type RootQueryPintoProductSetArgs = {
  productSetId: Scalars['ID']['input'];
};


export type RootQueryPintoProductSetsArgs = {
  filter?: InputMaybe<PintoProductSetsFilter>;
};


export type RootQueryPintoSectionArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryPintoSectionsArgs = {
  filter?: InputMaybe<SectionsFilterV2>;
};


export type RootQueryPintoVoucherArgs = {
  code: Scalars['ID']['input'];
};


export type RootQueryPintoVouchersArgs = {
  filter?: InputMaybe<PintoVouchersFilter>;
};


export type RootQueryPopupArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryPopupsArgs = {
  filter?: InputMaybe<PopupsFilter>;
};


export type RootQueryPreviewProductsArgs = {
  input: PreviewProductsInput;
};


export type RootQueryPreviewSectionArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryProductSetArgs = {
  productSetId: Scalars['ID']['input'];
};


export type RootQueryProductSetsArgs = {
  filter?: InputMaybe<ProductSetsFilter>;
};


export type RootQueryPurchaseTransactionBillsArgs = {
  filter?: InputMaybe<PurchaseTransactionBillsFilter>;
};


export type RootQueryPurchaseTransactionsArgs = {
  filter?: InputMaybe<PurchaseTransactionsFilter>;
};


export type RootQueryRefillReportArgs = {
  filter: RefillReportFilter;
};


export type RootQueryRefillTransactionsArgs = {
  filter?: InputMaybe<RefillTransactionsFilter>;
};


export type RootQueryRefillsArgs = {
  filter: RefillFilter;
};


export type RootQueryRegistersArgs = {
  filter?: InputMaybe<RegisterFilter>;
};


export type RootQueryReportsArgs = {
  filter: ReportsFilter;
};


export type RootQueryRequestedEbookFilesArgs = {
  filter?: InputMaybe<EditEbookFilter>;
};


export type RootQueryRetentionArgs = {
  filter?: InputMaybe<RetentionFilter>;
};


export type RootQuerySaleByCategoryReportArgs = {
  filter: SaleByCategoryReportFilter;
};


export type RootQuerySaleByContentReportArgs = {
  filter: SaleByContentReportFilter;
};


export type RootQuerySaleByTypeReportArgs = {
  filter: SaleByTypeReportFilter;
};


export type RootQuerySalesReportArgs = {
  filter?: InputMaybe<SalesReportFilter>;
};


export type RootQuerySalesReportsArgs = {
  filter?: InputMaybe<SalesReportsFilter>;
};


export type RootQuerySearchBooksArgs = {
  filter?: InputMaybe<SearchBooksFilter>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type RootQuerySearchEbooksArgs = {
  filter?: InputMaybe<SearchEbooksFilter>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type RootQuerySearchPintoTagsArgs = {
  filter?: InputMaybe<SearchPintoTagsFilter>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type RootQuerySearchSubscriptionTitlesArgs = {
  filter?: InputMaybe<SearchSubscriptionTitlesFilter>;
};


export type RootQuerySearchTagsArgs = {
  filter?: InputMaybe<SearchTagsFilter>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type RootQuerySearchUsersArgs = {
  filter?: InputMaybe<SearchUsersFilter>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type RootQuerySectionArgs = {
  id: Scalars['ID']['input'];
};


export type RootQuerySectionPaginationArgs = {
  filter?: InputMaybe<SectionsFilterV2>;
};


export type RootQuerySectionsArgs = {
  filter?: InputMaybe<SectionsFilter>;
};


export type RootQuerySubscriptionTitleArgs = {
  subscriptionTitleId: Scalars['ID']['input'];
};


export type RootQueryTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTagsArgs = {
  filter?: InputMaybe<TagsFilter>;
};


export type RootQueryTaxDeductionDocumentsArgs = {
  filter?: InputMaybe<TaxDeductionDocumentsFilter>;
};


export type RootQueryTaxpayerBankAccountArgs = {
  taxpayerBankAccountId: Scalars['ID']['input'];
};


export type RootQueryTaxpayerBankAccountOptionsArgs = {
  filter?: InputMaybe<TaxpayerBankAccountOptionsFilter>;
};


export type RootQueryTaxpayerBankAccountsArgs = {
  filter?: InputMaybe<TaxpayerBankAccountsFilter>;
};


export type RootQueryTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTemplateByQueryArgs = {
  filter?: InputMaybe<TemplateFilter>;
};


export type RootQueryTemplatesArgs = {
  filter?: InputMaybe<TemplatesFilter>;
};


export type RootQueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryUsersArgs = {
  filter?: InputMaybe<UsersFilter>;
};


export type RootQueryVoucherArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryVoucherRedemptionsArgs = {
  voucherId: Scalars['ID']['input'];
};


export type RootQueryVouchersArgs = {
  filter?: InputMaybe<VouchersFilter>;
};

export type SaleByCategoryReportFilter = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentType: ContentType;
  endDate: Scalars['String']['input'];
  productType?: InputMaybe<ProductType>;
  startDate: Scalars['String']['input'];
  unit: SaleReportUnit;
};

export type SaleByContentReportFilter = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentType?: InputMaybe<ContentType>;
  endDate: Scalars['String']['input'];
  productType?: InputMaybe<ProductType>;
  startDate: Scalars['String']['input'];
  unit: SaleReportUnit;
};

export type SaleByTypeReportFilter = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentType?: InputMaybe<ContentType>;
  endDate: Scalars['String']['input'];
  productType?: InputMaybe<ProductType>;
  startDate: Scalars['String']['input'];
  unit: SaleReportUnit;
};

export enum SaleReportUnit {
  GoldCoin = 'goldCoin',
  TimesCount = 'timesCount'
}

export type SalesReport = {
  __typename?: 'SalesReport';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  goldCoin?: Maybe<Scalars['Int']['output']>;
  status: SalesReportStatus;
  thb?: Maybe<Scalars['Float']['output']>;
  transferred: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SalesReportConnection = {
  __typename?: 'SalesReportConnection';
  edges: Array<SalesReportEdge>;
  pageInfo: PageInfo;
};

export type SalesReportEdge = {
  __typename?: 'SalesReportEdge';
  cursor: Scalars['String']['output'];
  node: SalesReport;
};

export type SalesReportFilter = {
  category?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<SalesReportKey>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export enum SalesReportKey {
  GoldCoin = 'goldCoin',
  GoldCoinSilverCoin = 'goldCoin_silverCoin',
  SilverCoin = 'silverCoin',
  Views = 'views'
}

export enum SalesReportStatus {
  Cancelled = 'cancelled',
  Pending = 'pending',
  Success = 'success'
}

export type SalesReports = {
  __typename?: 'SalesReports';
  _id: Scalars['ID']['output'];
  bookGoldCoin?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  cycle: Scalars['String']['output'];
  ebookGoldCoin?: Maybe<Scalars['Int']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  goldCoin?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['String']['output'];
};

export type SalesReportsFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SalesReportsSortBy>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum SalesReportsSortBy {
  Created = 'created',
  Cycle = 'cycle'
}

export type Schedule = {
  __typename?: 'Schedule';
  _id?: Maybe<Scalars['ID']['output']>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
};

export type ScheduleInput = {
  endedAt: Scalars['Date']['input'];
  startedAt: Scalars['Date']['input'];
};

export type SearchBooksFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  status?: InputMaybe<BookStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchEbooksFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentType>;
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  status?: InputMaybe<EbookStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchLink = {
  __typename?: 'SearchLink';
  anyPriceTypes?: Maybe<Array<EbookPriceType>>;
  anyTypes?: Maybe<Array<EbookType>>;
  anyWritingTypes?: Maybe<Array<EbookWritingType>>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  categoryTagId?: Maybe<Scalars['ID']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  contentRatingIds?: Maybe<Array<Scalars['ID']['output']>>;
  contentType?: Maybe<ContentType>;
  coverImage?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gteRating?: Maybe<Scalars['Int']['output']>;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  isTranslated?: Maybe<Scalars['Boolean']['output']>;
  placeholderBackgroundColor?: Maybe<Scalars['String']['output']>;
  searchField?: Maybe<Scalars['String']['output']>;
  searchText?: Maybe<Scalars['String']['output']>;
  searchType?: Maybe<SearchType>;
  sortBy?: Maybe<Scalars['String']['output']>;
  sortType?: Maybe<SortType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SearchPintoTagsFilter = {
  isReserved?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchSubscriptionTitlesFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchTagsFilter = {
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  isProhibited?: InputMaybe<Scalars['Boolean']['input']>;
  isReserved?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  type?: InputMaybe<TagType>;
};

export enum SearchType {
  Book = 'book',
  Ebook = 'ebook',
  User = 'user'
}

export type SearchUsersFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  type?: InputMaybe<UserType>;
};

export type Section = {
  __typename?: 'Section';
  _id?: Maybe<Scalars['ID']['output']>;
  camelCaseLayoutId?: Maybe<SectionLayoutId>;
  configItems?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  contentType?: Maybe<ContentType>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  darkBgImageUrl?: Maybe<Scalars['String']['output']>;
  dayBgImageUrl?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActivated?: Maybe<Scalars['Boolean']['output']>;
  isNCContent?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** @deprecated Use field camelCaseLayoutId instead */
  layoutId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  pref?: Maybe<FeedPref>;
  productType?: Maybe<ProductType>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  target?: Maybe<SectionTarget>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SectionConnection = {
  __typename?: 'SectionConnection';
  edges: Array<SectionEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SectionEdge = {
  __typename?: 'SectionEdge';
  cursor: Scalars['String']['output'];
  node: SectionV3;
};

export type SectionInput = {
  categoryTagId?: InputMaybe<Scalars['Int']['input']>;
  configItems?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contentType?: InputMaybe<ContentType>;
  darkBgImageUrl?: InputMaybe<Scalars['String']['input']>;
  dayBgImageUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isNCContent?: InputMaybe<Scalars['Boolean']['input']>;
  layoutId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pref?: InputMaybe<FeedPref>;
  productType?: InputMaybe<ProductType>;
  target?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SectionItem = {
  __typename?: 'SectionItem';
  book?: Maybe<Book>;
  ebook?: Maybe<Ebook>;
  explore?: Maybe<Explore>;
  feed?: Maybe<Feed>;
  link?: Maybe<Link>;
  productSet?: Maybe<ProductSet>;
  search?: Maybe<SearchLink>;
  type?: Maybe<SectionItemType>;
};

export enum SectionItemType {
  Book = 'book',
  Ebook = 'ebook',
  EbookBundleShortcut = 'ebookBundleShortcut',
  EbookCollectionShortcut = 'ebookCollectionShortcut',
  EbookShortcut = 'ebookShortcut',
  Explore = 'explore',
  ExploreBundleShortcut = 'exploreBundleShortcut',
  ExploreEbookCollectionShortcut = 'exploreEbookCollectionShortcut',
  ExploreShortcut = 'exploreShortcut',
  Feed = 'feed',
  Link = 'link',
  LinkShortcut = 'linkShortcut',
  PintoCustomLink = 'pintoCustomLink',
  PintoEbook = 'pintoEbook',
  PintoEbookBundle = 'pintoEbookBundle',
  PintoEbookCollection = 'pintoEbookCollection',
  PintoExplore = 'pintoExplore',
  PintoExploreBundle = 'pintoExploreBundle',
  PintoExploreEbookCollection = 'pintoExploreEbookCollection',
  PintoFeed = 'pintoFeed',
  PintoFeedShortcut = 'pintoFeedShortcut',
  PintoLink = 'pintoLink',
  PintoProductSet = 'pintoProductSet',
  PintoSearch = 'pintoSearch',
  PintoUserProfile = 'pintoUserProfile',
  ProductSet = 'productSet',
  ProductSetShortcut = 'productSetShortcut',
  Search = 'search',
  SearchShortcut = 'searchShortcut',
  UserProfileShortcut = 'userProfileShortcut'
}

export enum SectionLayoutId {
  BannerFullWidth = 'bannerFullWidth',
  BookBanner = 'bookBanner',
  BookCover = 'bookCover',
  BookCover2 = 'bookCover2',
  BookCoverWithBanner = 'bookCoverWithBanner',
  EditorReview = 'editorReview',
  LibraryAd = 'libraryAd',
  LinkBanner = 'linkBanner',
  LinkBannerFullWidth = 'linkBannerFullWidth',
  MainBanner = 'mainBanner',
  MarqueeAnnouncement = 'marqueeAnnouncement',
  Rank = 'rank',
  Shortcut = 'shortcut',
  SquareCover = 'squareCover',
  StaticBanner = 'staticBanner',
  TagCloud = 'tagCloud'
}

export type SectionTarget = Explore | ExploreProductSet | Feed | Link | SearchLink | SectionTargetExploreEbookBundle | SectionTargetExploreEbookRecommendation | SectionTargetProductSet | SectionTargetSection | User;

export type SectionTargetExploreEbookBundle = {
  __typename?: 'SectionTargetExploreEbookBundle';
  categoryId?: Maybe<Scalars['ID']['output']>;
  exploreType?: Maybe<SectionTargetExploreEbookBundleType>;
  hasDiscount?: Maybe<Scalars['Boolean']['output']>;
  sortBy?: Maybe<SectionTargetExploreEbookBundleSortBy>;
  sortType?: Maybe<SortType>;
};

export enum SectionTargetExploreEbookBundleSortBy {
  BestSeller = 'bestSeller',
  BestSeller7Days = 'bestSeller7Days',
  BestSeller30Days = 'bestSeller30Days',
  DiscountEnded = 'discountEnded',
  PriceThb = 'priceThb',
  Started = 'started',
  Title = 'title'
}

export enum SectionTargetExploreEbookBundleType {
  All = 'all',
  BestSeller = 'bestSeller',
  NewArrival = 'newArrival'
}

export type SectionTargetExploreEbookRecommendation = {
  __typename?: 'SectionTargetExploreEbookRecommendation';
  anyFileTypes?: Maybe<Array<FileType>>;
  anyPriceTypes?: Maybe<Array<EbookPriceType>>;
  anyTagNames?: Maybe<Array<Scalars['String']['output']>>;
  anyTypes?: Maybe<Array<EbookType>>;
  anyUserIds?: Maybe<Array<Scalars['ID']['output']>>;
  anyWritingTypes?: Maybe<Array<EbookWritingType>>;
  blacklistIds?: Maybe<Array<Scalars['ID']['output']>>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  hasDiscount?: Maybe<Scalars['Boolean']['output']>;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  reviewRatingTier?: Maybe<PintoRecommendationEbookReviewRatingTier>;
  tagNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type SectionTargetProductSet = {
  __typename?: 'SectionTargetProductSet';
  _id?: Maybe<Scalars['ID']['output']>;
};

export type SectionTargetSection = {
  __typename?: 'SectionTargetSection';
  _id?: Maybe<Scalars['ID']['output']>;
};

export type SectionV3 = {
  __typename?: 'SectionV3';
  _id: Scalars['ID']['output'];
  camelCaseLayoutId?: Maybe<SectionLayoutId>;
  categoryTag?: Maybe<Tag>;
  categoryTagId?: Maybe<Scalars['ID']['output']>;
  configItems?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  contentType?: Maybe<ContentType>;
  createdAt: Scalars['Date']['output'];
  darkBgImageUrl?: Maybe<Scalars['String']['output']>;
  dayBgImageUrl?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActivated?: Maybe<Scalars['Boolean']['output']>;
  isNCContent?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use field unionItems instead */
  items?: Maybe<Array<Maybe<SectionItem>>>;
  /** @deprecated Use field camelCaseLayoutId instead */
  layoutId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  pref?: Maybe<FeedPref>;
  productType?: Maybe<ProductType>;
  schedules?: Maybe<Array<Maybe<Schedule>>>;
  target?: Maybe<SectionTarget>;
  title?: Maybe<Scalars['String']['output']>;
  unionItems: Array<UnionSectionItem>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};


export type SectionV3UnionItemsArgs = {
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
};

export type SectionsFilter = {
  _id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contentType?: InputMaybe<ContentType>;
  layoutId?: InputMaybe<SectionLayoutId>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pref?: InputMaybe<FeedPref>;
  productType?: InputMaybe<ProductType>;
};

export enum SectionsFilterSortBy {
  Created = 'created',
  Updated = 'updated'
}

export type SectionsFilterV2 = {
  _id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentType>;
  layoutId?: InputMaybe<SectionLayoutId>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pref?: InputMaybe<FeedPref>;
  productType?: InputMaybe<ProductType>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SectionsFilterSortBy>;
  sortType?: InputMaybe<SortType>;
};

export enum SortType {
  Asc = 'asc',
  Desc = 'desc'
}

export type Static = {
  __typename?: 'Static';
  bannerImage?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StaticFile = {
  __typename?: 'StaticFile';
  url?: Maybe<Scalars['String']['output']>;
};

export type SubTag = {
  __typename?: 'SubTag';
  _id: Scalars['ID']['output'];
  categoryTagId?: Maybe<Scalars['ID']['output']>;
  contentType?: Maybe<ContentType>;
  createdAt: Scalars['Date']['output'];
  productsCount: Scalars['Int']['output'];
  searchesCount: Scalars['Int']['output'];
  tagId: Scalars['ID']['output'];
  trendingScore?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type SubmitReviewEbookEbookFileInput = {
  mainFileUrl: Scalars['String']['input'];
  mainFilename: Scalars['String']['input'];
  sampleFileUrl: Scalars['String']['input'];
  sampleFilename: Scalars['String']['input'];
  type: EbookFileType;
};

export type SubmitReviewEbookInput = {
  appleOriginalPriceTierId?: InputMaybe<Scalars['ID']['input']>;
  authorNames: Array<Scalars['String']['input']>;
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['ID']['input'];
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  coverPriceThb?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  discount?: InputMaybe<EbookDiscountInput>;
  ebookFiles: Array<SubmitReviewEbookEbookFileInput>;
  googleOriginalPriceTierId?: InputMaybe<Scalars['ID']['input']>;
  isRTL?: InputMaybe<Scalars['Boolean']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  originalLanguageCode?: InputMaybe<Scalars['String']['input']>;
  originalPriceThb: Scalars['Float']['input'];
  productSetId?: InputMaybe<Scalars['ID']['input']>;
  productSetVol?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['Date']['input']>;
  readingType?: InputMaybe<ReadingType>;
  synopsis: Scalars['JSON']['input'];
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  translatorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  writingType?: InputMaybe<EbookWritingType>;
};

export type SubscriptionTitle = {
  __typename?: 'SubscriptionTitle';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  ebooksCount: Scalars['Int']['output'];
  latestEbook?: Maybe<Ebook>;
  latestEbookId?: Maybe<Scalars['ID']['output']>;
  packages?: Maybe<Array<Maybe<SubscriptionTitlePackage>>>;
  publishedEbooksCount: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status: SubscriptionTitleStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type SubscriptionTitleConnection = {
  __typename?: 'SubscriptionTitleConnection';
  edges: Array<SubscriptionTitleEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionTitleEdge = {
  __typename?: 'SubscriptionTitleEdge';
  cursor: Scalars['String']['output'];
  node: SubscriptionTitle;
};

export type SubscriptionTitlePackage = {
  __typename?: 'SubscriptionTitlePackage';
  _id: Scalars['ID']['output'];
  applePriceTier?: Maybe<SubscriptionTitlePriceTier>;
  applePriceTierId?: Maybe<Scalars['ID']['output']>;
  appleProductId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  googlePriceTier?: Maybe<SubscriptionTitlePriceTier>;
  googlePriceTierId?: Maybe<Scalars['ID']['output']>;
  googleProductId?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  packageType: SubscriptionTitlePackageType;
  period?: Maybe<Scalars['String']['output']>;
  priceThb?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum SubscriptionTitlePackageType {
  AutoRenew = 'autoRenew',
  Credit = 'credit'
}

export type SubscriptionTitlePriceTier = {
  __typename?: 'SubscriptionTitlePriceTier';
  _id: Scalars['ID']['output'];
  thb: Scalars['Float']['output'];
  usd: Scalars['Float']['output'];
};

export enum SubscriptionTitleStatus {
  Published = 'published',
  Unpublished = 'unpublished'
}

export type SummaryEbookLog = {
  __typename?: 'SummaryEbookLog';
  created?: Maybe<EbookLog>;
  latestUpdated?: Maybe<EbookLog>;
};

export type Tag = {
  __typename?: 'Tag';
  _id: Scalars['ID']['output'];
  isProhibited: Scalars['Boolean']['output'];
  isReserved: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productsCount: Scalars['Int']['output'];
  searchesCount: Scalars['Int']['output'];
  subTag?: Maybe<Array<SubTag>>;
  type: TagType;
};

export type TagConnection = {
  __typename?: 'TagConnection';
  edges: Array<TagEdge>;
  pageInfo: PageInfo;
};

export type TagEdge = {
  __typename?: 'TagEdge';
  cursor: Scalars['String']['output'];
  node: Tag;
};

export enum TagType {
  Category = 'category',
  General = 'general'
}

export type TagsCount = {
  __typename?: 'TagsCount';
  category: Scalars['Int']['output'];
  comic: Scalars['Int']['output'];
  fiction: Scalars['Int']['output'];
  general: Scalars['Int']['output'];
  nonfiction: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TagsFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentType>;
  isProhibited?: InputMaybe<Scalars['Boolean']['input']>;
  isReserved?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<ProductType>;
  sortBy?: InputMaybe<TagsFilterSortBy>;
  sortType?: InputMaybe<SortType>;
};

export enum TagsFilterSortBy {
  Created = 'created',
  Name = 'name',
  Popular = 'popular',
  Trending = 'trending'
}

export type TaxDeductionDocument = {
  __typename?: 'TaxDeductionDocument';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  date?: Maybe<Scalars['String']['output']>;
  goldCoin?: Maybe<Scalars['Int']['output']>;
  rawDataFileUrl?: Maybe<Scalars['String']['output']>;
  receiptFileUrl?: Maybe<Scalars['String']['output']>;
  receiptId?: Maybe<Scalars['String']['output']>;
  status: TaxDeductionDocumentStatus;
  taxDeductionParticipant: TaxDeductionParticipant;
  updatedAt: Scalars['Date']['output'];
};

export type TaxDeductionDocumentConnection = {
  __typename?: 'TaxDeductionDocumentConnection';
  edges: Array<TaxDeductionDocumentEdge>;
  pageInfo: PageInfo;
};

export type TaxDeductionDocumentEdge = {
  __typename?: 'TaxDeductionDocumentEdge';
  cursor: Scalars['String']['output'];
  node: TaxDeductionDocument;
};

export enum TaxDeductionDocumentStatus {
  Cancelled = 'cancelled',
  Pending = 'pending',
  Successful = 'successful'
}

export type TaxDeductionDocumentsFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  gteDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  lteDate?: InputMaybe<Scalars['String']['input']>;
  receiptId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<TaxDeductionDocumentsSortBy>;
  sortType?: InputMaybe<TaxDeductionDocumentsSortType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum TaxDeductionDocumentsSortBy {
  Created = 'created',
  Date = 'date'
}

export enum TaxDeductionDocumentsSortType {
  Asc = 'asc',
  Desc = 'desc'
}

export type TaxDeductionParticipant = {
  __typename?: 'TaxDeductionParticipant';
  _id: Scalars['ID']['output'];
  address: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  idCardNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export type Taxpayer = {
  __typename?: 'Taxpayer';
  _id: Scalars['ID']['output'];
  calculateVat: Scalars['Boolean']['output'];
  contact: Contact;
  createdAt: Scalars['Date']['output'];
  deductedTaxType?: Maybe<TaxpayerDeductedTaxType>;
  idCardFileUrl?: Maybe<Scalars['String']['output']>;
  idNumber?: Maybe<Scalars['String']['output']>;
  taxForm?: Maybe<TaxpayerTaxForm>;
  updatedAt: Scalars['Date']['output'];
};

export type TaxpayerBankAccount = {
  __typename?: 'TaxpayerBankAccount';
  _id: Scalars['ID']['output'];
  bankAccount: BankAccount;
  contract?: Maybe<Contract>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  isForeigner: Scalars['Boolean']['output'];
  isPremium: Scalars['Boolean']['output'];
  legacy: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  rejectNotes?: Maybe<Array<TaxpayerBankAccountRejectNote>>;
  status: TaxpayerBankAccountStatus;
  taxpayer: Taxpayer;
  type: TaxpayerBankAccountType;
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export type TaxpayerBankAccountConnection = {
  __typename?: 'TaxpayerBankAccountConnection';
  edges: Array<TaxpayerBankAccountEdge>;
  pageInfo: PageInfo;
};

export type TaxpayerBankAccountEdge = {
  __typename?: 'TaxpayerBankAccountEdge';
  cursor: Scalars['String']['output'];
  node: TaxpayerBankAccount;
};

export type TaxpayerBankAccountOptions = {
  __typename?: 'TaxpayerBankAccountOptions';
  banks: Array<Bank>;
  contact: TaxpayerBankAccountOptionsContact;
};

export type TaxpayerBankAccountOptionsContact = {
  __typename?: 'TaxpayerBankAccountOptionsContact';
  generalNameTitles: Array<Scalars['String']['output']>;
  premiumCorporationNameTitles: Array<Scalars['String']['output']>;
  premiumIndividualNameTitles: Array<Scalars['String']['output']>;
  provinceDistrictSubDistrictOptions?: Maybe<Scalars['JSON']['output']>;
};

export type TaxpayerBankAccountOptionsFilter = {
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaxpayerBankAccountRejectNote = {
  __typename?: 'TaxpayerBankAccountRejectNote';
  content: Scalars['String']['output'];
  type?: Maybe<TaxpayerBankAccountRejectNoteType>;
};

export enum TaxpayerBankAccountRejectNoteType {
  BankAccount = 'bankAccount',
  Taxpayer = 'taxpayer',
  User = 'user'
}

export enum TaxpayerBankAccountStatus {
  Activated = 'activated',
  Approved = 'approved',
  Failed = 'failed',
  Pending = 'pending',
  Rejected = 'rejected'
}

export enum TaxpayerBankAccountType {
  Corporation = 'corporation',
  Individual = 'individual'
}

export type TaxpayerBankAccountsFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  sortBy?: InputMaybe<TaxpayerBankAccountsFilterSortBy>;
  sortType?: InputMaybe<SortType>;
  status?: InputMaybe<TaxpayerBankAccountStatus>;
  type?: InputMaybe<TaxpayerBankAccountType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum TaxpayerBankAccountsFilterSortBy {
  Activated = 'activated',
  ContractExpired = 'contractExpired',
  Created = 'created',
  Updated = 'updated'
}

export enum TaxpayerDeductedTaxType {
  TaxDeduction_40_3 = 'tax_deduction_40_3',
  TaxDeduction_40_8 = 'tax_deduction_40_8'
}

export enum TaxpayerTaxForm {
  IncomeTax_2 = 'income_tax_2',
  IncomeTax_3 = 'income_tax_3',
  IncomeTax_53 = 'income_tax_53'
}

export type Template = {
  __typename?: 'Template';
  _id: Scalars['ID']['output'];
  categoryTag?: Maybe<Tag>;
  categoryTagId?: Maybe<Scalars['ID']['output']>;
  contentType?: Maybe<ContentType>;
  createdAt: Scalars['Date']['output'];
  isActivated: Scalars['Boolean']['output'];
  meta?: Maybe<TemplateMeta>;
  placement: TemplatePlacement;
  pref?: Maybe<FeedPref>;
  productType?: Maybe<ProductType>;
  sections: Array<SectionV3>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type TemplateConnection = {
  __typename?: 'TemplateConnection';
  edges: Array<TemplateEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TemplateEdge = {
  __typename?: 'TemplateEdge';
  cursor: Scalars['String']['output'];
  node: Template;
};

export type TemplateFilter = {
  categoryTagId?: InputMaybe<Scalars['ID']['input']>;
  contentType?: InputMaybe<ContentType>;
  placement?: InputMaybe<TemplatePlacement>;
  pref?: InputMaybe<FeedPref>;
  productType?: InputMaybe<ProductType>;
};

export type TemplateMeta = {
  __typename?: 'TemplateMeta';
  ogDescription?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<Scalars['String']['output']>;
  ogTitle?: Maybe<Scalars['String']['output']>;
};

export type TemplateMetaInput = {
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
};

export enum TemplatePlacement {
  Feed = 'feed',
  Library = 'library',
  Product = 'product'
}

export type TemplatesFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentType>;
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  placement?: InputMaybe<TemplatePlacement>;
  productType?: InputMaybe<ProductType>;
  sortBy?: InputMaybe<TemplatesFilterSortBy>;
  sortType?: InputMaybe<TemplatesSortType>;
};

export enum TemplatesFilterSortBy {
  Created = 'created',
  Updated = 'updated'
}

export enum TemplatesSortType {
  Asc = 'asc',
  Desc = 'desc'
}

export type UnionSectionItem = Book | Ebook | EbookBundle | Explore | Feed | Link | ProductSet | SearchLink | Section | Static;

export type UpdateBankTransferInput = {
  invoiceFile?: InputMaybe<Scalars['String']['input']>;
  receiptFile?: InputMaybe<Scalars['String']['input']>;
  slipFile?: InputMaybe<Scalars['String']['input']>;
  whtCertificateFile?: InputMaybe<Scalars['String']['input']>;
  whtCertificateId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePintoProductCampaignInput = {
  bannerImageUrl?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  conditions?: InputMaybe<Array<Scalars['String']['input']>>;
  endedAt?: InputMaybe<Scalars['Date']['input']>;
  exampleProductPromoteImageUrl?: InputMaybe<Scalars['String']['input']>;
  exceptCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  minimumDiscountRatio?: InputMaybe<Scalars['Float']['input']>;
  productTypes?: InputMaybe<Array<PintoProductCampaignProductType>>;
  registrationEndedAt?: InputMaybe<Scalars['Date']['input']>;
  registrationStartedAt?: InputMaybe<Scalars['Date']['input']>;
  specificWriterUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startedAt?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateOgImageUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<PintoProductCampaignUserType>;
};

export type UpdatePintoVouchersInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePopupInput = {
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<UpdatePopupItemInput>>;
};

export type UpdatePopupItemConfigExploreBookInput = {
  categoryTagId?: InputMaybe<Scalars['ID']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  contentRatingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentType: ContentType;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  popupImageUrl: Scalars['String']['input'];
  sortBy: ExploreBookSortBy;
};

export type UpdatePopupItemConfigExploreEbookInput = {
  categoryTagId?: InputMaybe<Scalars['ID']['input']>;
  contentRatingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentType: ContentType;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  popupImageUrl: Scalars['String']['input'];
  sortBy: ExploreEbookSortBy;
};

export type UpdatePopupItemConfigFeedInput = {
  popupImageUrl: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type UpdatePopupItemConfigIdInput = {
  _id: Scalars['ID']['input'];
  popupImageUrl: Scalars['String']['input'];
};

export type UpdatePopupItemConfigInput = {
  book?: InputMaybe<UpdatePopupItemConfigIdInput>;
  ebook?: InputMaybe<UpdatePopupItemConfigIdInput>;
  exploreBook?: InputMaybe<UpdatePopupItemConfigExploreBookInput>;
  exploreEbook?: InputMaybe<UpdatePopupItemConfigExploreEbookInput>;
  feed?: InputMaybe<UpdatePopupItemConfigFeedInput>;
  link?: InputMaybe<UpdatePopupItemConfigLinkInput>;
  productSet?: InputMaybe<UpdatePopupItemConfigIdInput>;
  search?: InputMaybe<UpdatePopupItemConfigSearchInput>;
  section?: InputMaybe<UpdatePopupItemConfigIdInput>;
  static?: InputMaybe<UpdatePopupItemConfigStaticInput>;
  user?: InputMaybe<UpdatePopupItemConfigIdInput>;
};

export type UpdatePopupItemConfigLinkInput = {
  popupImageUrl: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UpdatePopupItemConfigSearchInput = {
  categoryTagId?: InputMaybe<Scalars['ID']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  contentRatingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentType: ContentType;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  popupImageUrl: Scalars['String']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  searchType: SearchType;
};

export type UpdatePopupItemConfigStaticInput = {
  popupImageUrl: Scalars['String']['input'];
};

export type UpdatePopupItemInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  config: UpdatePopupItemConfigInput;
  note?: InputMaybe<Scalars['String']['input']>;
  schedules?: InputMaybe<Array<ScheduleInput>>;
  type: PopupItemType;
};

export type UpdateTemplateInput = {
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  sections?: InputMaybe<Array<UpdateTemplateInputSection>>;
};

export type UpdateTemplateInputSection = {
  _id: Scalars['ID']['input'];
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  schedules?: InputMaybe<Array<UpdateTemplateInputSectionSchedule>>;
};

export type UpdateTemplateInputSectionSchedule = {
  endedAt: Scalars['Date']['input'];
  startedAt: Scalars['Date']['input'];
};

export type UpdateUserInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameTitle?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  subDistrict?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
};

export type UploadEbookBundleInput = {
  adminNote: Scalars['String']['input'];
  file: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type UploadEbookImageInput = {
  base64: Scalars['String']['input'];
  type: UploadEbookImageType;
  userId: Scalars['String']['input'];
};

export enum UploadEbookImageType {
  BannerImage = 'bannerImage',
  CoverImage = 'coverImage',
  Synopsis = 'synopsis'
}

export type UploadMonthlyBankTransferInput = {
  file: Scalars['String']['input'];
};

export type UploadPintoVoucherInfo = {
  __typename?: 'UploadPintoVoucherInfo';
  errors?: Maybe<Array<UploadPintoVoucherInfoError>>;
  valid: Scalars['Boolean']['output'];
};

export type UploadPintoVoucherInfoError = {
  __typename?: 'UploadPintoVoucherInfoError';
  code: Scalars['ID']['output'];
  errors: Array<Scalars['String']['output']>;
};

export type UploadPintoVouchersInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  fileData: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type UploadRequestedEbookFileData = {
  mainFileUrl: Scalars['String']['input'];
  mainFilename: Scalars['String']['input'];
  sampleFileUrl: Scalars['String']['input'];
  sampleFilename: Scalars['String']['input'];
  type: EbookFileType;
};

export type UploadRequestedEbookFileInput = {
  ebookFiles?: InputMaybe<Array<UploadRequestedEbookFileData>>;
};

export type UpsertPickedTagInput = {
  categoryTagId?: InputMaybe<Scalars['ID']['input']>;
  contentType: ContentType;
  productType?: InputMaybe<ProductType>;
  section: PickedTagSectionType;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type UpsertTemplateInput = {
  categoryTagId?: InputMaybe<Scalars['ID']['input']>;
  contentType?: InputMaybe<ContentType>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  placement: TemplatePlacement;
  pref?: InputMaybe<FeedPref>;
  productType?: InputMaybe<ProductType>;
  sectionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sections?: InputMaybe<Array<UpdateTemplateInputSection>>;
};

export type User = {
  __typename?: 'User';
  _id?: Maybe<Scalars['ID']['output']>;
  appleId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentEarnings?: Maybe<Scalars['BigInt']['output']>;
  currentTaxpayerBankAccounts?: Maybe<TaxpayerBankAccount>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use field fictionlogEarningsRatio or pintoEarningsRatio instead */
  earningsRatio?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enableNCContent?: Maybe<Scalars['Boolean']['output']>;
  facebookId?: Maybe<Scalars['String']['output']>;
  feedPref: FeedPref;
  fictionlogEarningsRatio: Scalars['Float']['output'];
  followersCount?: Maybe<Scalars['Int']['output']>;
  followingCount?: Maybe<Scalars['Int']['output']>;
  goldCoin?: Maybe<Scalars['Int']['output']>;
  hasPassword: Scalars['Boolean']['output'];
  isForeigner: Scalars['Boolean']['output'];
  isPremium: Scalars['Boolean']['output'];
  isSupervised: Scalars['Boolean']['output'];
  omiseCustomerId?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Permission>;
  pintoAppEarningsRatio: Scalars['Float']['output'];
  pintoEarningsRatio: Scalars['Float']['output'];
  profileImage?: Maybe<Scalars['String']['output']>;
  silverCoin?: Maybe<Scalars['Int']['output']>;
  totalEarnings?: Maybe<Scalars['BigInt']['output']>;
  type: UserType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserAndToken = {
  __typename?: 'UserAndToken';
  accessToken: Scalars['String']['output'];
  permission?: Maybe<Permission>;
  user: User;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserReviewsCount = {
  __typename?: 'UserReviewsCount';
  negative?: Maybe<Scalars['Int']['output']>;
  positive?: Maybe<Scalars['Int']['output']>;
  ratingScore?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum UserType {
  Corporation = 'corporation',
  Individual = 'individual',
  Staff = 'staff'
}

export type UsersFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  isPremium?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['OneToOneHundredInt']['input']>;
  sortBy?: InputMaybe<UsersFilterSortBy>;
  type?: InputMaybe<UserType>;
};

export enum UsersFilterSortBy {
  Created = 'created',
  Updated = 'updated'
}

export type Voucher = {
  __typename?: 'Voucher';
  _id?: Maybe<Scalars['ID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['ID']['output']>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  goldCoin?: Maybe<Scalars['Int']['output']>;
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  redeemsCount?: Maybe<Scalars['Int']['output']>;
  silverCoin?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type VoucherConnection = {
  __typename?: 'VoucherConnection';
  edges?: Maybe<Array<Maybe<VoucherEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type VoucherEdge = {
  __typename?: 'VoucherEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Voucher>;
};

export type VoucherInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  expiredAt?: InputMaybe<Scalars['Date']['input']>;
  goldCoin?: InputMaybe<Scalars['Int']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  silverCoin?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VoucherType>;
};

export type VoucherRedemption = {
  __typename?: 'VoucherRedemption';
  createdAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
  voucherId?: Maybe<Scalars['ID']['output']>;
};

export enum VoucherType {
  FalseRefill = 'false_refill',
  GiftCard = 'gift_card',
  PromoCode = 'promo_code',
  TrueMoney = 'true_money',
  TrueWallet = 'true_wallet'
}

export type VouchersFilter = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EbookDiscountCampaignFragment = { __typename?: 'EbookDiscountCampaign', _id: string, title: string, status: EbookDiscountCampaignStatus, startedAt: any, endedAt?: any | null, fileName: string, fileUrl: string, createdAt: any, updatedAt: any };

export type EditEbookFragment = { __typename?: 'EditEbook', _id: string, ebookId?: string | null, status?: EditEbookStatus | null, categoryId?: number | null, userNote?: string | null, rejectNotes?: Array<string | null> | null, activatedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, correctionEbookFiles: Array<{ __typename?: 'EditEbookFile', type: EbookFileType, sampleFilename?: string | null, sampleFileUrl?: string | null, mainFilename?: string | null, mainFileUrl?: string | null, requestedFileUrl?: string | null, requestedFileName?: string | null, requestedFileType?: string | null, status?: CorrectionEbookFileStatus | null, requestedSampleFileType?: CorrectionEbookRequestedSampleFileType | null, lastSampleChapterNumber?: number | null, lastSampleChapterName?: string | null, isAutoGenerateSampleFile?: boolean | null }>, ebook?: { __typename?: 'Ebook', _id: string, title?: string | null, coverImageUrl?: string | null, status: EbookStatus, user: { __typename?: 'User', _id?: string | null, username?: string | null } } | null };

export type EditEbookFileFragment = { __typename?: 'EditEbookFile', type: EbookFileType, sampleFilename?: string | null, sampleFileUrl?: string | null, mainFilename?: string | null, mainFileUrl?: string | null, requestedFileUrl?: string | null, requestedFileName?: string | null, requestedFileType?: string | null, status?: CorrectionEbookFileStatus | null, requestedSampleFileType?: CorrectionEbookRequestedSampleFileType | null, lastSampleChapterNumber?: number | null, lastSampleChapterName?: string | null, isAutoGenerateSampleFile?: boolean | null };

export type FeedFragment = { __typename?: 'Feed', _id?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, title?: string | null, description?: string | null, coverImage?: string | null, bannerImage?: string | null, meta?: any | null, slug?: string | null, createdAt?: any | null, updatedAt?: any | null, sections?: Array<{ __typename?: 'Section', _id?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, camelCaseLayoutId?: SectionLayoutId | null, isNCContent?: boolean | null, isActivated?: boolean | null, title?: string | null, configItems?: Array<any | null> | null, items?: Array<any | null> | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, startedAt?: any | null, endedAt?: any | null, target?: { __typename: 'Explore', exploreType?: ExploreType | null, completed?: boolean | null, sortBy?: string | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null } | { __typename: 'ExploreProductSet', sortBy?: string | null, sortType?: SortType | null, categoryId?: string | null } | { __typename: 'Feed', feedId?: string | null } | { __typename: 'Link', url?: string | null } | { __typename: 'SearchLink', searchType?: SearchType | null, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null } | { __typename: 'SectionTargetExploreEbookBundle' } | { __typename: 'SectionTargetExploreEbookRecommendation' } | { __typename: 'SectionTargetProductSet', sectionTargetProductSetId?: string | null } | { __typename: 'SectionTargetSection', sectionTargetSectionId?: string | null } | { __typename: 'User', userId?: string | null } | null } | null> | null };

export type SectionFragment = { __typename?: 'Section', _id?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, camelCaseLayoutId?: SectionLayoutId | null, isNCContent?: boolean | null, isActivated?: boolean | null, title?: string | null, configItems?: Array<any | null> | null, items?: Array<any | null> | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, startedAt?: any | null, endedAt?: any | null, target?: { __typename: 'Explore', exploreType?: ExploreType | null, completed?: boolean | null, sortBy?: string | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null } | { __typename: 'ExploreProductSet', sortBy?: string | null, sortType?: SortType | null, categoryId?: string | null } | { __typename: 'Feed', feedId?: string | null } | { __typename: 'Link', url?: string | null } | { __typename: 'SearchLink', searchType?: SearchType | null, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null } | { __typename: 'SectionTargetExploreEbookBundle' } | { __typename: 'SectionTargetExploreEbookRecommendation' } | { __typename: 'SectionTargetProductSet', sectionTargetProductSetId?: string | null } | { __typename: 'SectionTargetSection', sectionTargetSectionId?: string | null } | { __typename: 'User', userId?: string | null } | null };

export type SubscriptionTitlePriceTierFragment = { __typename?: 'SubscriptionTitlePriceTier', _id: string, thb: number, usd: number };

export type BookPageAdFragment = { __typename?: 'BookPageAd', _id: string, title: string, note?: string | null, bookId: string, destinationUrl: string, createdAt: any };

export type CurrentUserFragment = { __typename?: 'User', _id?: string | null, type: UserType, username?: string | null, displayName?: string | null, profileImage?: string | null, permission?: { __typename?: 'Permission', _id: string, viewUsers: boolean, updateUsers: boolean, removeUsers: boolean, editUserPermissions: boolean, viewBooks: boolean, updateBooks: boolean, removeBooks: boolean, editChapters: boolean, viewEbooks: boolean, updateEbooks: boolean, removeEbooks: boolean, editEbooks: boolean, viewProductSets: boolean, updateProductSets: boolean, removeProductSets: boolean, feeds: boolean, sections: boolean, vouchers: boolean, metrics: boolean, bestSeller: boolean, transactions: boolean, exportRaws: boolean, taxDeductions: boolean, tags: boolean, pintoWriterCampaign: boolean } | null };

export type EbookBundleFragment = { __typename?: 'EbookBundle', _id: string, title?: string | null, description?: string | null, coverImageUrl?: string | null, bannerImageUrl?: string | null, ebookCount: number, status: EbookBundleStatus, createdAt: any, updatedAt: any, startedAt?: any | null, priceThb?: number | null, originalPriceThb?: number | null, discountRatio?: number | null, googleDiscountRatio?: number | null, userId: string };

export type EbookDetailFragment = { __typename?: 'Ebook', _id: string, title?: string | null, description?: string | null, coverImageUrl?: string | null, bannerImageUrl?: string | null, status: EbookStatus, correctionEbookStatus?: CorrectionEbookStatus | null, synopsis?: any | null, isFree: boolean, readingType: ReadingType, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, authorNames?: Array<string | null> | null, translatorNames?: Array<string | null> | null, viewsCount?: number | null, purchasesCount: number, totalSales: number, earningsRatio: number, originalPriceThb?: number | null, priceThb?: number | null, discountRatio?: number | null, coverPriceThb?: number | null, isbn?: string | null, pagesCount?: number | null, productSetId?: string | null, productSetVol?: number | null, writingType: EbookWritingType, subscriptionTitleId?: string | null, appleOriginalPriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null, googleOriginalPriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null, discount?: { __typename?: 'EbookDiscount', endedAt?: any | null, ratio?: number | null, startedAt: any, thb?: number | null, googlePriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null, applePriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null } | null, originalLanguage: { __typename?: 'Language', name: string, code: string }, language: { __typename?: 'Language', name: string, code: string }, productSet?: { __typename?: 'PintoProductSet', _id: string, title?: string | null, itemsCount: number } | null, ebookFiles: Array<{ __typename?: 'EbookFile', mainFileUrl?: string | null, mainFilename?: string | null, sampleFileUrl?: string | null, sampleFilename?: string | null, sizeInKB: number, type: EbookFileType }>, tags: Array<{ __typename?: 'Tag', _id: string, name: string }>, category?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null, parent?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null, parent?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null } | null } | null } | null, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null, profileImage?: string | null, type: UserType, email?: string | null, isPremium: boolean }, summaryEbookLog?: { __typename?: 'SummaryEbookLog', created?: { __typename?: 'EbookLog', actor: { __typename?: 'User', displayName?: string | null } } | null, latestUpdated?: { __typename?: 'EbookLog', actor: { __typename?: 'User', displayName?: string | null } } | null } | null, correction?: { __typename?: 'CorrectionEbook', status: CorrectionEbookStatus, rejectNotes?: Array<string> | null, category?: { __typename?: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, parentId?: number | null, parent?: { __typename?: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, parentId?: number | null, parent?: { __typename?: 'PintoCategory', name: string, _id: string } | null } | null } | null, correctionEbookFiles: Array<{ __typename?: 'CorrectionEbookFile', mainFileUrl?: string | null, sampleFileUrl?: string | null, type: EbookFileType, mainFilename?: string | null, sampleFilename?: string | null, status: CorrectionEbookFileStatus }> } | null, subscriptionTitle?: { __typename?: 'SubscriptionTitle', _id: string, title: string } | null };

export type EbookSubmissionFragment = { __typename?: 'PintoEbookSubmission', _id: string, status: PintoEbookSubmissionStatus, itemCount: number, fileName: string, fileUrl: string, adminNote?: string | null, cancelledAt?: any | null, createdAt: any, updatedAt: any, actor: { __typename?: 'User', _id?: string | null, username?: string | null }, itemStatusCounts: Array<{ __typename?: 'PintoEbookSubmissionItemStatusCount', status: PintoEbookSubmissionItemStatus, count: number }> };

export type EbookSubmissionPreviewRowFragment = { __typename?: 'PintoEbookSubmissionPreviewRow', no: string, userId?: string | null, username?: string | null, title?: string | null, description?: string | null, contentWarningPlainText?: string | null, synopsisPlainText: string, tagNames?: Array<string> | null, authorNames: Array<string>, translatorNames: Array<string>, categoryId?: number | null, categoryName?: string | null, writingType?: string | null, originalLanguage?: string | null, language?: string | null, isbn?: string | null, coverPriceThb?: number | null, priceThb?: number | null, applePriceTierId?: number | null, applePriceTierThb?: number | null, googlePriceTierId?: number | null, googlePriceTierThb?: number | null, productSetId?: string | null, productSetTitle?: string | null, productSetVol?: number | null, subscriptionTitleId?: string | null, subscriptionTitleTitle?: string | null, readingType?: string | null, webDiscountPercentage?: number | null, webDiscountThb?: number | null, appleDiscountPriceTierId?: number | null, appleDiscountPriceTierThb?: number | null, googleDiscountPriceTierId?: number | null, googleDiscountPriceTierThb?: number | null, discountStartedAt?: any | null, discountEndedAt?: any | null, status?: PintoEbookSubmissionPreviewRowStatus | null, publishedAt?: any | null, coverImageUrl?: string | null, bannerImageUrl?: string | null, samplePdfFileUrl?: string | null, mainPdfFileUrl?: string | null, sampleEpubFileUrl?: string | null, mainEpubFileUrl?: string | null, errors: Array<{ __typename?: 'PintoEbookSubmissionPreviewRowError', field: string, message: string, value?: string | null }> };

export type EbookFileFragment = { __typename?: 'EbookFile', mainFileUrl?: string | null, pagesCount: number, sampleFileUrl?: string | null, type: EbookFileType };

export type LanguageFragment = { __typename?: 'Language', code: string, name: string };

export type PageInfoFragment = { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null };

export type PintoAnnouncementNotificationFragment = { __typename?: 'PintoAnnouncementNotification', _id: string, title: string, subTitle?: string | null, description: string, clickActionType?: PintoAnnouncementNotificationClickActionType | null, clickActionData?: string | null, notified: boolean, notifiedAt: any, topics: Array<PintoAnnouncementNotificationTopic>, type: PintoAnnouncementNotificationType, userIds?: Array<string> | null, createdAt: any, updatedAt: any, platforms: Array<ClientPlatform> };

export type PintoCategoryFragment = { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null };

export type PintoEbookCollectionFragment = { __typename?: 'PintoEbookCollection', _id: string, title: string, description: string, emoji: string, hexColorCode: string, darkModeHexColorCode: string, ogImageUrl: string, ebookCoverImageUrls: Array<string>, itemCount: number, status: PintoEbookCollectionStatus, createdAt: any, updatedAt: any, publishedAt?: any | null, deletedAt?: any | null, userId: string, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null, profileImage?: string | null, type: UserType, email?: string | null, isPremium: boolean } };

export type PintoProductSetFragment = { __typename?: 'PintoProductSet', _id: string, activatedAt: any, coverImageUrl?: string | null, createdAt: any, description?: string | null, itemsCount: number, hasItemVol: boolean, publishedAt?: any | null, status: ProductSetStatus, title?: string | null, updatedAt: any, user: { __typename: 'User', _id?: string | null, username?: string | null } };

export type PintoVoucherFragment = { __typename?: 'PintoVoucher', code: string, conditions: Array<string>, description?: string | null, createdAt: any, display: boolean, discountAmount: number, discountThb: number, discountType: PintoVoucherDiscountType, expiredAt?: any | null, startedAt: any, enabled: boolean, isMembershipEarlyBird: boolean, isMembershipOnly: boolean, maximumDiscountAmount?: number | null, maximumRedeemedCounts?: number | null, maximumRedeemedCountsPerMembership?: number | null, maximumRedeemedCountsPerUser?: number | null, membershipStartedAt?: any | null, minimumSpendThb: number, myRedeemedCounts: number, redeemedCounts: number, subType: PintoVoucherSubType, status: PintoVoucherStatus, title: string, type: PintoVoucherType, participatingItems?: { __typename?: 'PintoVoucherParticipatingItem', itemType: PintoVoucherParticipatingItemType, itemIds: Array<string>, items?: Array<{ __typename?: 'PintoCategory', _id: string, name: string } | { __typename?: 'User', username?: string | null }> | null } | null };

export type PintoWriterCampaignFragment = { __typename?: 'PintoProductCampaign', _id: string, title: string, status: PintoProductCampaignStatus, userType: PintoProductCampaignUserType, productTypes: Array<PintoProductCampaignProductType>, isActive: boolean, startedAt: any, endedAt: any, registrationStartedAt: any, registrationEndedAt: any, minimumDiscountRatio?: number | null, categoryIds?: Array<number> | null, exceptCategoryIds?: Array<number> | null, conditions?: Array<string> | null, tags?: Array<string> | null, bannerImageUrl: string, exampleProductPromoteImageUrl: string, templateOgImageUrl: string, createdAt: any, updatedAt: any };

export type PopupNodeFragment = { __typename?: 'Popup', _id: string, pref: FeedPref, type: PopupType, updatedAt?: any | null, createdAt?: any | null, isActivated: boolean, itemsCount: { __typename?: 'PopupItemsCount', activeItems: number, totalItems: number }, items: Array<{ __typename?: 'PopupItem', _id: string, type: PopupItemType, note?: string | null, config: { __typename: 'PopupItemConfigBook', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigEbook', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigExploreBook', contentType: ContentType, completed?: boolean | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, popupImageUrl: string, sortByBook?: ExploreBookSortBy | null } | { __typename: 'PopupItemConfigExploreEbook', contentType: ContentType, categoryTagId?: string | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, popupImageUrl: string, sortByEbook?: ExploreEbookSortBy | null } | { __typename: 'PopupItemConfigFeed', slug: string, popupImageUrl: string } | { __typename: 'PopupItemConfigLink', url: string, popupImageUrl: string } | { __typename: 'PopupItemConfigProductSet', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigSearch', searchType: SearchType, contentType: ContentType, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, categoryTagId?: string | null, popupImageUrl: string } | { __typename: 'PopupItemConfigSection', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigStatic', popupImageUrl: string }, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, startedAt?: any | null, endedAt?: any | null } | null> | null }>, unionItems: Array<{ __typename: 'Book', bookId?: string | null } | { __typename: 'Ebook', ebookId: string } | { __typename: 'EbookBundle' } | { __typename: 'Explore' } | { __typename: 'Feed', _id?: string | null } | { __typename: 'Link' } | { __typename: 'ProductSet' } | { __typename: 'SearchLink' } | { __typename: 'Section', _id?: string | null, title?: string | null, note?: string | null, isNCContent?: boolean | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null } | { __typename: 'Static' }> };

export type PopupNodeWithoutItemsFragment = { __typename?: 'Popup', _id: string, pref: FeedPref, type: PopupType, updatedAt?: any | null, createdAt?: any | null, isActivated: boolean, itemsCount: { __typename?: 'PopupItemsCount', activeItems: number, totalItems: number } };

export type PriceTierFragment = { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number };

type SectionTarget_Explore_Fragment = { __typename: 'Explore', exploreType?: ExploreType | null, completed?: boolean | null, sortBy?: string | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null };

type SectionTarget_ExploreProductSet_Fragment = { __typename: 'ExploreProductSet', sortBy?: string | null, sortType?: SortType | null, categoryId?: string | null };

type SectionTarget_Feed_Fragment = { __typename: 'Feed', feedId?: string | null };

type SectionTarget_Link_Fragment = { __typename: 'Link', url?: string | null };

type SectionTarget_SearchLink_Fragment = { __typename: 'SearchLink', searchType?: SearchType | null, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null };

type SectionTarget_SectionTargetExploreEbookBundle_Fragment = { __typename: 'SectionTargetExploreEbookBundle' };

type SectionTarget_SectionTargetExploreEbookRecommendation_Fragment = { __typename: 'SectionTargetExploreEbookRecommendation' };

type SectionTarget_SectionTargetProductSet_Fragment = { __typename: 'SectionTargetProductSet', sectionTargetProductSetId?: string | null };

type SectionTarget_SectionTargetSection_Fragment = { __typename: 'SectionTargetSection', sectionTargetSectionId?: string | null };

type SectionTarget_User_Fragment = { __typename: 'User', userId?: string | null };

export type SectionTargetFragment = SectionTarget_Explore_Fragment | SectionTarget_ExploreProductSet_Fragment | SectionTarget_Feed_Fragment | SectionTarget_Link_Fragment | SectionTarget_SearchLink_Fragment | SectionTarget_SectionTargetExploreEbookBundle_Fragment | SectionTarget_SectionTargetExploreEbookRecommendation_Fragment | SectionTarget_SectionTargetProductSet_Fragment | SectionTarget_SectionTargetSection_Fragment | SectionTarget_User_Fragment;

export type SectionV3Fragment = { __typename?: 'SectionV3', _id: string, camelCaseLayoutId?: SectionLayoutId | null, title?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, note?: string | null, isNCContent?: boolean | null, isActivated?: boolean | null, unionItems: Array<{ __typename: 'Book', title?: string | null, viewsCount?: number | null, coverImage?: string | null, completed?: boolean | null, placeholderBackgroundColor?: string | null, authorName?: string | null, translatorName?: string | null, bookId?: string | null, categoryTag?: { __typename?: 'Tag', _id: string, name: string } | null, contentRating?: { __typename?: 'ContentRating', _id?: string | null, name?: string | null } | null, sectionItemUser?: { __typename?: 'User', displayName?: string | null } | null } | { __typename: 'Ebook', _id: string, coverImage?: string | null, title?: string | null, placeholderBackgroundColor?: string | null, authorName?: string | null, translatorName?: string | null, discountPriceTierDetail?: any | null, categoryTag?: { __typename?: 'Tag', name: string } | null, contentRating?: { __typename?: 'ContentRating', _id?: string | null, name?: string | null } | null, user: { __typename?: 'User', displayName?: string | null } } | { __typename: 'EbookBundle' } | { __typename: 'Explore' } | { __typename: 'Feed' } | { __typename: 'Link' } | { __typename: 'ProductSet' } | { __typename: 'SearchLink' } | { __typename: 'Section' } | { __typename: 'Static' }>, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, startedAt?: any | null, endedAt?: any | null } | null> | null, target?: { __typename: 'Explore', exploreType?: ExploreType | null, completed?: boolean | null, sortBy?: string | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null } | { __typename: 'ExploreProductSet', sortBy?: string | null, sortType?: SortType | null, categoryId?: string | null } | { __typename: 'Feed', feedId?: string | null } | { __typename: 'Link', url?: string | null } | { __typename: 'SearchLink', searchType?: SearchType | null, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null } | { __typename: 'SectionTargetExploreEbookBundle' } | { __typename: 'SectionTargetExploreEbookRecommendation' } | { __typename: 'SectionTargetProductSet', sectionTargetProductSetId?: string | null } | { __typename: 'SectionTargetSection', sectionTargetSectionId?: string | null } | { __typename: 'User', userId?: string | null } | null };

export type SectionV3WithoutItemsFragment = { __typename?: 'SectionV3', _id: string, camelCaseLayoutId?: SectionLayoutId | null, title?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, note?: string | null, isNCContent?: boolean | null, isActivated?: boolean | null, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, startedAt?: any | null, endedAt?: any | null } | null> | null };

export type SubscriptionTitleDetailFragment = { __typename?: 'SubscriptionTitle', _id: string, title: string, slug?: string | null, ebooksCount: number, publishedEbooksCount: number, createdAt: any, updatedAt: any, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null, profileImage?: string | null, type: UserType, email?: string | null, isPremium: boolean }, packages?: Array<{ __typename?: 'SubscriptionTitlePackage', _id: string, title: string, packageType: SubscriptionTitlePackageType, applePriceTierId?: string | null, googlePriceTierId?: string | null, priceThb?: number | null, period?: string | null, appleProductId?: string | null, googleProductId?: string | null, isEnabled: boolean, deletedAt?: any | null, createdAt: any, updatedAt: any, applePriceTier?: { __typename?: 'SubscriptionTitlePriceTier', _id: string, thb: number, usd: number } | null, googlePriceTier?: { __typename?: 'SubscriptionTitlePriceTier', _id: string, thb: number, usd: number } | null } | null> | null };

export type TagFragment = { __typename?: 'Tag', _id: string, name: string, productsCount: number, searchesCount: number };

export type TemplateFragment = { __typename?: 'Template', _id: string, contentType?: ContentType | null, isActivated: boolean, placement: TemplatePlacement, pref?: FeedPref | null, slug?: string | null, productType?: ProductType | null, updatedAt: any, categoryTag?: { __typename?: 'Tag', _id: string, name: string } | null, meta?: { __typename?: 'TemplateMeta', ogImage?: string | null, ogTitle?: string | null, ogDescription?: string | null } | null, sections: Array<{ __typename?: 'SectionV3', _id: string, camelCaseLayoutId?: SectionLayoutId | null, title?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, note?: string | null, isNCContent?: boolean | null, isActivated?: boolean | null, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, startedAt?: any | null, endedAt?: any | null } | null> | null }> };

export type TemplateNodeFragment = { __typename?: 'Template', _id: string, contentType?: ContentType | null, isActivated: boolean, placement: TemplatePlacement, pref?: FeedPref | null, productType?: ProductType | null, updatedAt: any, categoryTag?: { __typename?: 'Tag', _id: string, name: string } | null };

type UnionSectionItem_Book_Fragment = { __typename: 'Book', bookId?: string | null };

type UnionSectionItem_Ebook_Fragment = { __typename: 'Ebook', ebookId: string };

type UnionSectionItem_EbookBundle_Fragment = { __typename: 'EbookBundle' };

type UnionSectionItem_Explore_Fragment = { __typename: 'Explore' };

type UnionSectionItem_Feed_Fragment = { __typename: 'Feed', _id?: string | null };

type UnionSectionItem_Link_Fragment = { __typename: 'Link' };

type UnionSectionItem_ProductSet_Fragment = { __typename: 'ProductSet' };

type UnionSectionItem_SearchLink_Fragment = { __typename: 'SearchLink' };

type UnionSectionItem_Section_Fragment = { __typename: 'Section', _id?: string | null, title?: string | null, note?: string | null, isNCContent?: boolean | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null };

type UnionSectionItem_Static_Fragment = { __typename: 'Static' };

export type UnionSectionItemFragment = UnionSectionItem_Book_Fragment | UnionSectionItem_Ebook_Fragment | UnionSectionItem_EbookBundle_Fragment | UnionSectionItem_Explore_Fragment | UnionSectionItem_Feed_Fragment | UnionSectionItem_Link_Fragment | UnionSectionItem_ProductSet_Fragment | UnionSectionItem_SearchLink_Fragment | UnionSectionItem_Section_Fragment | UnionSectionItem_Static_Fragment;

export type CancelEbookSubmissionMutationVariables = Exact<{
  ebookSubmissionId: Scalars['ID']['input'];
}>;


export type CancelEbookSubmissionMutation = { __typename?: 'RootMutation', cancelEbookSubmission: { __typename?: 'DefaultType', success?: boolean | null } };

export type CancelEbookSubmissionItemMutationVariables = Exact<{
  ebookSubmissionItemId: Scalars['ID']['input'];
}>;


export type CancelEbookSubmissionItemMutation = { __typename?: 'RootMutation', cancelEbookSubmissionItem: { __typename?: 'DefaultType', success?: boolean | null } };

export type CreateAndSubmitReviewEbookMutationVariables = Exact<{
  input: CreateAndSubmitReviewEbookInput;
}>;


export type CreateAndSubmitReviewEbookMutation = { __typename?: 'RootMutation', createAndSubmitReviewEbook: { __typename?: 'Ebook', _id: string, title?: string | null, description?: string | null, coverImageUrl?: string | null, bannerImageUrl?: string | null, status: EbookStatus, correctionEbookStatus?: CorrectionEbookStatus | null, synopsis?: any | null, isFree: boolean, readingType: ReadingType, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, authorNames?: Array<string | null> | null, translatorNames?: Array<string | null> | null, viewsCount?: number | null, purchasesCount: number, totalSales: number, earningsRatio: number, originalPriceThb?: number | null, priceThb?: number | null, discountRatio?: number | null, coverPriceThb?: number | null, isbn?: string | null, pagesCount?: number | null, productSetId?: string | null, productSetVol?: number | null, writingType: EbookWritingType, subscriptionTitleId?: string | null, appleOriginalPriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null, googleOriginalPriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null, discount?: { __typename?: 'EbookDiscount', endedAt?: any | null, ratio?: number | null, startedAt: any, thb?: number | null, googlePriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null, applePriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null } | null, originalLanguage: { __typename?: 'Language', name: string, code: string }, language: { __typename?: 'Language', name: string, code: string }, productSet?: { __typename?: 'PintoProductSet', _id: string, title?: string | null, itemsCount: number } | null, ebookFiles: Array<{ __typename?: 'EbookFile', mainFileUrl?: string | null, mainFilename?: string | null, sampleFileUrl?: string | null, sampleFilename?: string | null, sizeInKB: number, type: EbookFileType }>, tags: Array<{ __typename?: 'Tag', _id: string, name: string }>, category?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null, parent?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null, parent?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null } | null } | null } | null, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null, profileImage?: string | null, type: UserType, email?: string | null, isPremium: boolean }, summaryEbookLog?: { __typename?: 'SummaryEbookLog', created?: { __typename?: 'EbookLog', actor: { __typename?: 'User', displayName?: string | null } } | null, latestUpdated?: { __typename?: 'EbookLog', actor: { __typename?: 'User', displayName?: string | null } } | null } | null, correction?: { __typename?: 'CorrectionEbook', status: CorrectionEbookStatus, rejectNotes?: Array<string> | null, category?: { __typename?: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, parentId?: number | null, parent?: { __typename?: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, parentId?: number | null, parent?: { __typename?: 'PintoCategory', name: string, _id: string } | null } | null } | null, correctionEbookFiles: Array<{ __typename?: 'CorrectionEbookFile', mainFileUrl?: string | null, sampleFileUrl?: string | null, type: EbookFileType, mainFilename?: string | null, sampleFilename?: string | null, status: CorrectionEbookFileStatus }> } | null, subscriptionTitle?: { __typename?: 'SubscriptionTitle', _id: string, title: string } | null } };

export type CreateBookPageAdMutationVariables = Exact<{
  input: CreateBookPageAdInput;
}>;


export type CreateBookPageAdMutation = { __typename?: 'RootMutation', createBookPageAd: { __typename?: 'BookPageAd', _id: string, title: string, note?: string | null, bookId: string, destinationUrl: string, createdAt: any } };

export type CreateDraftEbookMutationVariables = Exact<{
  input: CreateDraftEbookInput;
}>;


export type CreateDraftEbookMutation = { __typename?: 'RootMutation', createDraftEbook: { __typename?: 'Ebook', _id: string } };

export type CreatePintoEbookCollectionMutationVariables = Exact<{
  input: CreatePintoEbookCollectionInput;
}>;


export type CreatePintoEbookCollectionMutation = { __typename?: 'RootMutation', createPintoEbookCollection: { __typename?: 'PintoEbookCollection', _id: string, title: string, description: string, emoji: string, hexColorCode: string, darkModeHexColorCode: string, ogImageUrl: string, ebookCoverImageUrls: Array<string>, itemCount: number, status: PintoEbookCollectionStatus, createdAt: any, updatedAt: any, publishedAt?: any | null, deletedAt?: any | null, userId: string, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null, profileImage?: string | null, type: UserType, email?: string | null, isPremium: boolean } } };

export type CreatePintoSubscriptionTitleMutationVariables = Exact<{
  input: CreatePintoSubscriptionTitleInput;
}>;


export type CreatePintoSubscriptionTitleMutation = { __typename?: 'RootMutation', createPintoSubscriptionTitle: { __typename?: 'SubscriptionTitle', _id: string } };

export type CreatePintoWriterCampaignMutationVariables = Exact<{
  input: CreatePintoProductCampaignInput;
}>;


export type CreatePintoWriterCampaignMutation = { __typename?: 'RootMutation', createPintoWriterCampaign: { __typename?: 'PintoProductCampaign', _id: string, title: string, status: PintoProductCampaignStatus, userType: PintoProductCampaignUserType, productTypes: Array<PintoProductCampaignProductType>, isActive: boolean, startedAt: any, endedAt: any, registrationStartedAt: any, registrationEndedAt: any, minimumDiscountRatio?: number | null, categoryIds?: Array<number> | null, exceptCategoryIds?: Array<number> | null, conditions?: Array<string> | null, tags?: Array<string> | null, bannerImageUrl: string, exampleProductPromoteImageUrl: string, templateOgImageUrl: string, createdAt: any, updatedAt: any } };

export type CreatePopupMutationVariables = Exact<{
  input: CreatePopupInput;
}>;


export type CreatePopupMutation = { __typename?: 'RootMutation', createPopup: { __typename?: 'Popup', _id: string, pref: FeedPref, type: PopupType, updatedAt?: any | null, createdAt?: any | null, isActivated: boolean, itemsCount: { __typename?: 'PopupItemsCount', activeItems: number, totalItems: number }, items: Array<{ __typename?: 'PopupItem', _id: string, type: PopupItemType, note?: string | null, config: { __typename: 'PopupItemConfigBook', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigEbook', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigExploreBook', contentType: ContentType, completed?: boolean | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, popupImageUrl: string, sortByBook?: ExploreBookSortBy | null } | { __typename: 'PopupItemConfigExploreEbook', contentType: ContentType, categoryTagId?: string | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, popupImageUrl: string, sortByEbook?: ExploreEbookSortBy | null } | { __typename: 'PopupItemConfigFeed', slug: string, popupImageUrl: string } | { __typename: 'PopupItemConfigLink', url: string, popupImageUrl: string } | { __typename: 'PopupItemConfigProductSet', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigSearch', searchType: SearchType, contentType: ContentType, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, categoryTagId?: string | null, popupImageUrl: string } | { __typename: 'PopupItemConfigSection', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigStatic', popupImageUrl: string }, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, startedAt?: any | null, endedAt?: any | null } | null> | null }>, unionItems: Array<{ __typename: 'Book', bookId?: string | null } | { __typename: 'Ebook', ebookId: string } | { __typename: 'EbookBundle' } | { __typename: 'Explore' } | { __typename: 'Feed', _id?: string | null } | { __typename: 'Link' } | { __typename: 'ProductSet' } | { __typename: 'SearchLink' } | { __typename: 'Section', _id?: string | null, title?: string | null, note?: string | null, isNCContent?: boolean | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null } | { __typename: 'Static' }> } };

export type CreatePresignedUploadEbookFileMutationVariables = Exact<{
  ebookId: Scalars['ID']['input'];
  input: CreatePresignedUploadEbookFileInput;
}>;


export type CreatePresignedUploadEbookFileMutation = { __typename?: 'RootMutation', createPresignedUploadEbookFile?: { __typename?: 'PresignedUpload', fields?: any | null, url?: string | null } | null };

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'RootMutation', createTag: { __typename?: 'Tag', _id: string, type: TagType, name: string, isReserved: boolean, isProhibited: boolean, productsCount: number, searchesCount: number, subTag?: Array<{ __typename?: 'SubTag', _id: string, tagId: string, categoryTagId?: string | null, contentType?: ContentType | null, productsCount: number, searchesCount: number, trendingScore?: number | null, createdAt: any, updatedAt: any }> | null } };

export type DeletePintoEbookCollectionMutationVariables = Exact<{
  ebookCollectionId: Scalars['ID']['input'];
}>;


export type DeletePintoEbookCollectionMutation = { __typename?: 'RootMutation', deletePintoEbookCollection: { __typename?: 'DefaultType', success?: boolean | null, message?: string | null } };

export type DeletePintoWriterCampaignMutationVariables = Exact<{
  productCampaignId: Scalars['ID']['input'];
}>;


export type DeletePintoWriterCampaignMutation = { __typename?: 'RootMutation', deletePintoWriterCampaign: { __typename?: 'DefaultType', success?: boolean | null, message?: string | null } };

export type EditDraftEbookMutationVariables = Exact<{
  ebookId: Scalars['ID']['input'];
  input: EditDraftEbookInput;
}>;


export type EditDraftEbookMutation = { __typename?: 'RootMutation', editDraftEbook: { __typename?: 'Ebook', _id: string } };

export type EditEbookMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: EditEbookInput;
}>;


export type EditEbookMutation = { __typename?: 'RootMutation', editEbook?: { __typename?: 'Ebook', _id: string } | null };

export type EditPintoEbookCollectionMutationVariables = Exact<{
  ebookCollectionId: Scalars['ID']['input'];
  input: CreatePintoEbookCollectionInput;
}>;


export type EditPintoEbookCollectionMutation = { __typename?: 'RootMutation', editPintoEbookCollection: { __typename?: 'PintoEbookCollection', _id: string, title: string, description: string, emoji: string, hexColorCode: string, darkModeHexColorCode: string, ogImageUrl: string, ebookCoverImageUrls: Array<string>, itemCount: number, status: PintoEbookCollectionStatus, createdAt: any, updatedAt: any, publishedAt?: any | null, deletedAt?: any | null, userId: string, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null, profileImage?: string | null, type: UserType, email?: string | null, isPremium: boolean } } };

export type EditPintoSubscriptionTitleMutationVariables = Exact<{
  subscriptionTitleId: Scalars['ID']['input'];
  input: EditPintoSubscriptionTitleInput;
}>;


export type EditPintoSubscriptionTitleMutation = { __typename?: 'RootMutation', editPintoSubscriptionTitle: { __typename?: 'SubscriptionTitle', _id: string } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'RootMutation', login: { __typename?: 'UserAndToken', accessToken: string, user: { __typename?: 'User', _id?: string | null, type: UserType, username?: string | null, displayName?: string | null, profileImage?: string | null, permission?: { __typename?: 'Permission', _id: string, viewUsers: boolean, updateUsers: boolean, removeUsers: boolean, editUserPermissions: boolean, viewBooks: boolean, updateBooks: boolean, removeBooks: boolean, editChapters: boolean, viewEbooks: boolean, updateEbooks: boolean, removeEbooks: boolean, editEbooks: boolean, viewProductSets: boolean, updateProductSets: boolean, removeProductSets: boolean, feeds: boolean, sections: boolean, vouchers: boolean, metrics: boolean, bestSeller: boolean, transactions: boolean, exportRaws: boolean, taxDeductions: boolean, tags: boolean, pintoWriterCampaign: boolean } | null } } };

export type PintoAnnouncementNotificationDeleteMutationVariables = Exact<{
  announcementNotificationId: Scalars['ID']['input'];
}>;


export type PintoAnnouncementNotificationDeleteMutation = { __typename?: 'RootMutation', deletePintoAnnouncementNotification: { __typename?: 'PintoAnnouncementNotification', _id: string } };

export type PintoCancelEbookDiscountCampaignMutationVariables = Exact<{
  ebookDiscountCampaignId: Scalars['ID']['input'];
}>;


export type PintoCancelEbookDiscountCampaignMutation = { __typename?: 'RootMutation', cancelEbookDiscountCampaign?: any | null };

export type PintoCreateAnnouncementNotificationMutationVariables = Exact<{
  input: CreatePintoAnnouncementNotificationInput;
}>;


export type PintoCreateAnnouncementNotificationMutation = { __typename?: 'RootMutation', createPintoAnnouncementNotification: { __typename?: 'PintoAnnouncementNotification', _id: string, title: string, subTitle?: string | null, description: string, clickActionType?: PintoAnnouncementNotificationClickActionType | null, clickActionData?: string | null, notified: boolean, notifiedAt: any, topics: Array<PintoAnnouncementNotificationTopic>, type: PintoAnnouncementNotificationType, userIds?: Array<string> | null, createdAt: any, updatedAt: any, platforms: Array<ClientPlatform> } };

export type PintoCreateEbookDiscountCampaignMutationVariables = Exact<{
  input: CreateEbookDiscountCampaignInput;
}>;


export type PintoCreateEbookDiscountCampaignMutation = { __typename?: 'RootMutation', createEbookDiscountCampaign: { __typename?: 'EbookDiscountCampaign', _id: string, title: string, status: EbookDiscountCampaignStatus, startedAt: any, endedAt?: any | null, fileUrl: string } };

export type PintoCreateFeedMutationVariables = Exact<{
  input: CreateFeedInput;
}>;


export type PintoCreateFeedMutation = { __typename?: 'RootMutation', pintoCreateFeed: { __typename?: 'Feed', _id?: string | null } };

export type PintoCreatePresignedUploadEbookFileMutationVariables = Exact<{
  input: CreatePresignedUploadEbookFileInput;
}>;


export type PintoCreatePresignedUploadEbookFileMutation = { __typename?: 'RootMutation', pintoCreatePresignedUploadEbookFile?: { __typename?: 'PresignedUpload', url?: string | null, fields?: any | null } | null };

export type PintoCreateSectionMutationVariables = Exact<{
  input: SectionInput;
}>;


export type PintoCreateSectionMutation = { __typename?: 'RootMutation', pintoCreateSection: { __typename?: 'Section', _id?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, camelCaseLayoutId?: SectionLayoutId | null, isNCContent?: boolean | null, isActivated?: boolean | null, title?: string | null, configItems?: Array<any | null> | null, items?: Array<any | null> | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, startedAt?: any | null, endedAt?: any | null, target?: { __typename: 'Explore', exploreType?: ExploreType | null, completed?: boolean | null, sortBy?: string | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null } | { __typename: 'ExploreProductSet', sortBy?: string | null, sortType?: SortType | null, categoryId?: string | null } | { __typename: 'Feed', feedId?: string | null } | { __typename: 'Link', url?: string | null } | { __typename: 'SearchLink', searchType?: SearchType | null, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null } | { __typename: 'SectionTargetExploreEbookBundle' } | { __typename: 'SectionTargetExploreEbookRecommendation' } | { __typename: 'SectionTargetProductSet', sectionTargetProductSetId?: string | null } | { __typename: 'SectionTargetSection', sectionTargetSectionId?: string | null } | { __typename: 'User', userId?: string | null } | null } };

export type PintoDeleteFeedMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  pref: FeedPref;
}>;


export type PintoDeleteFeedMutation = { __typename?: 'RootMutation', pintoDeleteFeed?: any | null };

export type PintoDeleteSectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PintoDeleteSectionMutation = { __typename?: 'RootMutation', pintoDeleteSection?: any | null };

export type PintoDownloadEbookBundlesMutationVariables = Exact<{ [key: string]: never; }>;


export type PintoDownloadEbookBundlesMutation = { __typename?: 'RootMutation', downloadEbookBundles: string };

export type PintoHideEbookMutationVariables = Exact<{
  ebookId: Scalars['ID']['input'];
}>;


export type PintoHideEbookMutation = { __typename?: 'RootMutation', hideEbook: { __typename?: 'Ebook', _id: string } };

export type PintoRejectEditEbookMutationVariables = Exact<{
  ebookId: Scalars['ID']['input'];
  rejectNote?: InputMaybe<Scalars['String']['input']>;
  fileTypes: Array<EbookFileType> | EbookFileType;
}>;


export type PintoRejectEditEbookMutation = { __typename?: 'RootMutation', rejectEditEbook?: { __typename?: 'DefaultType', message?: string | null, success?: boolean | null } | null };

export type PintoRemoveEbookMutationVariables = Exact<{
  input: RemoveEbookInput;
}>;


export type PintoRemoveEbookMutation = { __typename?: 'RootMutation', removeEbook?: { __typename?: 'Ebook', _id: string } | null };

export type PintoRemoveEbookBundleMutationVariables = Exact<{
  input: RemoveEbookBundleInput;
}>;


export type PintoRemoveEbookBundleMutation = { __typename?: 'RootMutation', removeEbookBundle?: { __typename?: 'EbookBundle', _id: string } | null };

export type PintoUnHideEbookMutationVariables = Exact<{
  ebookId: Scalars['ID']['input'];
}>;


export type PintoUnHideEbookMutation = { __typename?: 'RootMutation', unhideEbook: { __typename?: 'Ebook', _id: string } };

export type PintoUpdateFeedMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  pref: FeedPref;
  input: FeedInput;
}>;


export type PintoUpdateFeedMutation = { __typename?: 'RootMutation', pintoUpdateFeed: { __typename?: 'Feed', _id?: string | null } };

export type PintoUpdateSectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SectionInput;
}>;


export type PintoUpdateSectionMutation = { __typename?: 'RootMutation', pintoUpdateSection?: { __typename?: 'Section', _id?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, camelCaseLayoutId?: SectionLayoutId | null, isNCContent?: boolean | null, isActivated?: boolean | null, title?: string | null, configItems?: Array<any | null> | null, items?: Array<any | null> | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, startedAt?: any | null, endedAt?: any | null, target?: { __typename: 'Explore', exploreType?: ExploreType | null, completed?: boolean | null, sortBy?: string | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null } | { __typename: 'ExploreProductSet', sortBy?: string | null, sortType?: SortType | null, categoryId?: string | null } | { __typename: 'Feed', feedId?: string | null } | { __typename: 'Link', url?: string | null } | { __typename: 'SearchLink', searchType?: SearchType | null, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null } | { __typename: 'SectionTargetExploreEbookBundle' } | { __typename: 'SectionTargetExploreEbookRecommendation' } | { __typename: 'SectionTargetProductSet', sectionTargetProductSetId?: string | null } | { __typename: 'SectionTargetSection', sectionTargetSectionId?: string | null } | { __typename: 'User', userId?: string | null } | null } | null };

export type PintoUploadEbookBundleMutationVariables = Exact<{
  input: UploadEbookBundleInput;
}>;


export type PintoUploadEbookBundleMutation = { __typename?: 'RootMutation', uploadEbookBundle?: any | null };

export type PintoUploadEbookImageMutationVariables = Exact<{
  input: UploadEbookImageInput;
}>;


export type PintoUploadEbookImageMutation = { __typename?: 'RootMutation', pintoUploadEbookImage: string };

export type PintoUploadRequestedEbookFileMutationVariables = Exact<{
  ebookId: Scalars['ID']['input'];
  input: UploadRequestedEbookFileInput;
}>;


export type PintoUploadRequestedEbookFileMutation = { __typename?: 'RootMutation', uploadRequestedEbookFile?: { __typename?: 'DefaultType', message?: string | null, success?: boolean | null } | null };

export type PintoVouchersDeleteMutationVariables = Exact<{
  codes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PintoVouchersDeleteMutation = { __typename?: 'RootMutation', deletePintoVouchers: { __typename?: 'DefaultType', message?: string | null, success?: boolean | null } };

export type PintoVouchersUpdateMutationVariables = Exact<{
  codes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdatePintoVouchersInput;
}>;


export type PintoVouchersUpdateMutation = { __typename?: 'RootMutation', updatePintoVouchers: { __typename?: 'DefaultType', message?: string | null, success?: boolean | null } };

export type PintoVouchersUploadMutationVariables = Exact<{
  input: UploadPintoVouchersInput;
}>;


export type PintoVouchersUploadMutation = { __typename?: 'RootMutation', uploadPintoVouchers: { __typename?: 'UploadPintoVoucherInfo', valid: boolean, errors?: Array<{ __typename?: 'UploadPintoVoucherInfoError', code: string, errors: Array<string> }> | null } };

export type PreviewEbookSubmissionMutationVariables = Exact<{
  input: PintoPreviewEbookSubmissionInput;
}>;


export type PreviewEbookSubmissionMutation = { __typename?: 'RootMutation', previewEbookSubmission: { __typename?: 'PintoEbookSubmissionPreview', _id?: string | null, fileName: string, totalCount: number, validCount: number, invalidCount: number, rows: Array<{ __typename?: 'PintoEbookSubmissionPreviewRow', no: string, userId?: string | null, username?: string | null, title?: string | null, description?: string | null, contentWarningPlainText?: string | null, synopsisPlainText: string, tagNames?: Array<string> | null, authorNames: Array<string>, translatorNames: Array<string>, categoryId?: number | null, categoryName?: string | null, writingType?: string | null, originalLanguage?: string | null, language?: string | null, isbn?: string | null, coverPriceThb?: number | null, priceThb?: number | null, applePriceTierId?: number | null, applePriceTierThb?: number | null, googlePriceTierId?: number | null, googlePriceTierThb?: number | null, productSetId?: string | null, productSetTitle?: string | null, productSetVol?: number | null, subscriptionTitleId?: string | null, subscriptionTitleTitle?: string | null, readingType?: string | null, webDiscountPercentage?: number | null, webDiscountThb?: number | null, appleDiscountPriceTierId?: number | null, appleDiscountPriceTierThb?: number | null, googleDiscountPriceTierId?: number | null, googleDiscountPriceTierThb?: number | null, discountStartedAt?: any | null, discountEndedAt?: any | null, status?: PintoEbookSubmissionPreviewRowStatus | null, publishedAt?: any | null, coverImageUrl?: string | null, bannerImageUrl?: string | null, samplePdfFileUrl?: string | null, mainPdfFileUrl?: string | null, sampleEpubFileUrl?: string | null, mainEpubFileUrl?: string | null, errors: Array<{ __typename?: 'PintoEbookSubmissionPreviewRowError', field: string, message: string, value?: string | null }> }> } };

export type PreviewPintoWriterCampaignOgImageMutationVariables = Exact<{
  input: PreviewPintoProductCampaignOgImageInput;
}>;


export type PreviewPintoWriterCampaignOgImageMutation = { __typename?: 'RootMutation', previewPintoWriterCampaignOgImage: string };

export type SignedUrlMutationVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type SignedUrlMutation = { __typename?: 'RootMutation', signedUrl?: string | null };

export type SubmitReviewDraftEbookMutationVariables = Exact<{
  ebookId: Scalars['ID']['input'];
  input: SubmitReviewEbookInput;
}>;


export type SubmitReviewDraftEbookMutation = { __typename?: 'RootMutation', submitReviewDraftEbook: { __typename?: 'Ebook', _id: string, title?: string | null, description?: string | null, coverImageUrl?: string | null, bannerImageUrl?: string | null, status: EbookStatus, correctionEbookStatus?: CorrectionEbookStatus | null, synopsis?: any | null, isFree: boolean, readingType: ReadingType, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, authorNames?: Array<string | null> | null, translatorNames?: Array<string | null> | null, viewsCount?: number | null, purchasesCount: number, totalSales: number, earningsRatio: number, originalPriceThb?: number | null, priceThb?: number | null, discountRatio?: number | null, coverPriceThb?: number | null, isbn?: string | null, pagesCount?: number | null, productSetId?: string | null, productSetVol?: number | null, writingType: EbookWritingType, subscriptionTitleId?: string | null, appleOriginalPriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null, googleOriginalPriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null, discount?: { __typename?: 'EbookDiscount', endedAt?: any | null, ratio?: number | null, startedAt: any, thb?: number | null, googlePriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null, applePriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null } | null, originalLanguage: { __typename?: 'Language', name: string, code: string }, language: { __typename?: 'Language', name: string, code: string }, productSet?: { __typename?: 'PintoProductSet', _id: string, title?: string | null, itemsCount: number } | null, ebookFiles: Array<{ __typename?: 'EbookFile', mainFileUrl?: string | null, mainFilename?: string | null, sampleFileUrl?: string | null, sampleFilename?: string | null, sizeInKB: number, type: EbookFileType }>, tags: Array<{ __typename?: 'Tag', _id: string, name: string }>, category?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null, parent?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null, parent?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null } | null } | null } | null, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null, profileImage?: string | null, type: UserType, email?: string | null, isPremium: boolean }, summaryEbookLog?: { __typename?: 'SummaryEbookLog', created?: { __typename?: 'EbookLog', actor: { __typename?: 'User', displayName?: string | null } } | null, latestUpdated?: { __typename?: 'EbookLog', actor: { __typename?: 'User', displayName?: string | null } } | null } | null, correction?: { __typename?: 'CorrectionEbook', status: CorrectionEbookStatus, rejectNotes?: Array<string> | null, category?: { __typename?: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, parentId?: number | null, parent?: { __typename?: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, parentId?: number | null, parent?: { __typename?: 'PintoCategory', name: string, _id: string } | null } | null } | null, correctionEbookFiles: Array<{ __typename?: 'CorrectionEbookFile', mainFileUrl?: string | null, sampleFileUrl?: string | null, type: EbookFileType, mainFilename?: string | null, sampleFilename?: string | null, status: CorrectionEbookFileStatus }> } | null, subscriptionTitle?: { __typename?: 'SubscriptionTitle', _id: string, title: string } | null } };

export type UpdatePintoWriterCampaignMutationVariables = Exact<{
  productCampaignId: Scalars['ID']['input'];
  input: UpdatePintoProductCampaignInput;
}>;


export type UpdatePintoWriterCampaignMutation = { __typename?: 'RootMutation', updatePintoWriterCampaign: { __typename?: 'PintoProductCampaign', _id: string, title: string, status: PintoProductCampaignStatus, userType: PintoProductCampaignUserType, productTypes: Array<PintoProductCampaignProductType>, isActive: boolean, startedAt: any, endedAt: any, registrationStartedAt: any, registrationEndedAt: any, minimumDiscountRatio?: number | null, categoryIds?: Array<number> | null, exceptCategoryIds?: Array<number> | null, conditions?: Array<string> | null, tags?: Array<string> | null, bannerImageUrl: string, exampleProductPromoteImageUrl: string, templateOgImageUrl: string, createdAt: any, updatedAt: any } };

export type UpdatePopupMutationVariables = Exact<{
  popupId: Scalars['ID']['input'];
  input: UpdatePopupInput;
}>;


export type UpdatePopupMutation = { __typename?: 'RootMutation', updatePopup: { __typename?: 'Popup', _id: string, pref: FeedPref, type: PopupType, updatedAt?: any | null, createdAt?: any | null, isActivated: boolean, itemsCount: { __typename?: 'PopupItemsCount', activeItems: number, totalItems: number }, items: Array<{ __typename?: 'PopupItem', _id: string, type: PopupItemType, note?: string | null, config: { __typename: 'PopupItemConfigBook', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigEbook', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigExploreBook', contentType: ContentType, completed?: boolean | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, popupImageUrl: string, sortByBook?: ExploreBookSortBy | null } | { __typename: 'PopupItemConfigExploreEbook', contentType: ContentType, categoryTagId?: string | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, popupImageUrl: string, sortByEbook?: ExploreEbookSortBy | null } | { __typename: 'PopupItemConfigFeed', slug: string, popupImageUrl: string } | { __typename: 'PopupItemConfigLink', url: string, popupImageUrl: string } | { __typename: 'PopupItemConfigProductSet', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigSearch', searchType: SearchType, contentType: ContentType, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, categoryTagId?: string | null, popupImageUrl: string } | { __typename: 'PopupItemConfigSection', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigStatic', popupImageUrl: string }, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, startedAt?: any | null, endedAt?: any | null } | null> | null }>, unionItems: Array<{ __typename: 'Book', bookId?: string | null } | { __typename: 'Ebook', ebookId: string } | { __typename: 'EbookBundle' } | { __typename: 'Explore' } | { __typename: 'Feed', _id?: string | null } | { __typename: 'Link' } | { __typename: 'ProductSet' } | { __typename: 'SearchLink' } | { __typename: 'Section', _id?: string | null, title?: string | null, note?: string | null, isNCContent?: boolean | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null } | { __typename: 'Static' }> } };

export type UpdateTemplateMutationVariables = Exact<{
  templateId: Scalars['ID']['input'];
  input: UpdateTemplateInput;
}>;


export type UpdateTemplateMutation = { __typename?: 'RootMutation', updateTemplate: { __typename?: 'Template', _id: string, contentType?: ContentType | null, isActivated: boolean, placement: TemplatePlacement, pref?: FeedPref | null, slug?: string | null, productType?: ProductType | null, updatedAt: any, categoryTag?: { __typename?: 'Tag', _id: string, name: string } | null, meta?: { __typename?: 'TemplateMeta', ogImage?: string | null, ogTitle?: string | null, ogDescription?: string | null } | null, sections: Array<{ __typename?: 'SectionV3', _id: string, camelCaseLayoutId?: SectionLayoutId | null, title?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, note?: string | null, isNCContent?: boolean | null, isActivated?: boolean | null, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, startedAt?: any | null, endedAt?: any | null } | null> | null }> } };

export type UploadEbookSubmissionMutationVariables = Exact<{
  input: PintoUploadEbookSubmissionInput;
}>;


export type UploadEbookSubmissionMutation = { __typename?: 'RootMutation', uploadEbookSubmission: { __typename?: 'PintoEbookSubmission', _id: string, status: PintoEbookSubmissionStatus, itemCount: number, fileName: string, fileUrl: string, adminNote?: string | null, cancelledAt?: any | null, createdAt: any, updatedAt: any, actor: { __typename?: 'User', _id?: string | null, username?: string | null }, itemStatusCounts: Array<{ __typename?: 'PintoEbookSubmissionItemStatusCount', status: PintoEbookSubmissionItemStatus, count: number }> } };

export type UploadStaticFileMutationVariables = Exact<{
  data: Scalars['String']['input'];
}>;


export type UploadStaticFileMutation = { __typename?: 'RootMutation', uploadStaticFile?: { __typename?: 'StaticFile', url?: string | null } | null };

export type UpsertTemplateMutationVariables = Exact<{
  input: UpsertTemplateInput;
}>;


export type UpsertTemplateMutation = { __typename?: 'RootMutation', upsertTemplate: { __typename?: 'Template', _id: string, contentType?: ContentType | null, isActivated: boolean, placement: TemplatePlacement, pref?: FeedPref | null, slug?: string | null, productType?: ProductType | null, updatedAt: any, categoryTag?: { __typename?: 'Tag', _id: string, name: string } | null, meta?: { __typename?: 'TemplateMeta', ogImage?: string | null, ogTitle?: string | null, ogDescription?: string | null } | null, sections: Array<{ __typename?: 'SectionV3', _id: string, camelCaseLayoutId?: SectionLayoutId | null, title?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, note?: string | null, isNCContent?: boolean | null, isActivated?: boolean | null, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, startedAt?: any | null, endedAt?: any | null } | null> | null }> } };

export type SearchSubscriptionTitlesQueryVariables = Exact<{
  filter: SearchSubscriptionTitlesFilter;
  includeDetail: Scalars['Boolean']['input'];
}>;


export type SearchSubscriptionTitlesQuery = { __typename?: 'RootQuery', searchSubscriptionTitles: { __typename?: 'SubscriptionTitleConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename?: 'SubscriptionTitleEdge', node: { __typename?: 'SubscriptionTitle', _id: string, title: string, slug?: string | null, ebooksCount: number, publishedEbooksCount: number, createdAt: any, updatedAt: any, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null, profileImage?: string | null, type: UserType, email?: string | null, isPremium: boolean }, packages?: Array<{ __typename?: 'SubscriptionTitlePackage', _id: string, title: string, packageType: SubscriptionTitlePackageType, applePriceTierId?: string | null, googlePriceTierId?: string | null, priceThb?: number | null, period?: string | null, appleProductId?: string | null, googleProductId?: string | null, isEnabled: boolean, deletedAt?: any | null, createdAt: any, updatedAt: any, applePriceTier?: { __typename?: 'SubscriptionTitlePriceTier', _id: string, thb: number, usd: number } | null, googlePriceTier?: { __typename?: 'SubscriptionTitlePriceTier', _id: string, thb: number, usd: number } | null } | null> | null } }> } };

export type AllCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCategoriesQuery = { __typename?: 'RootQuery', fictionCategories?: Array<{ __typename?: 'Category', _id?: string | null, name?: string | null } | null> | null, comicCategories?: Array<{ __typename?: 'Category', _id?: string | null, name?: string | null } | null> | null, nonfictionCategories?: Array<{ __typename?: 'Category', _id?: string | null, name?: string | null } | null> | null, fictionContentRatings?: Array<{ __typename?: 'ContentRating', _id?: string | null, name?: string | null } | null> | null, comicContentRatings?: Array<{ __typename?: 'ContentRating', _id?: string | null, name?: string | null } | null> | null, nonfictionContentRatings?: Array<{ __typename?: 'ContentRating', _id?: string | null, name?: string | null } | null> | null };

export type BookPageAdsQueryVariables = Exact<{
  filter?: InputMaybe<BookPageAdsFilter>;
}>;


export type BookPageAdsQuery = { __typename?: 'RootQuery', bookPageAds: { __typename?: 'BookPageAdConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'BookPageAdEdge', node: { __typename?: 'BookPageAd', _id: string, title: string, note?: string | null, bookId: string, destinationUrl: string, createdAt: any, chapterPageAds: Array<{ __typename?: 'ChapterPageAd', chapterId: string, title: string }> } }> } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'RootQuery', currentUser?: { __typename?: 'User', _id?: string | null, type: UserType, username?: string | null, displayName?: string | null, profileImage?: string | null, permission?: { __typename?: 'Permission', _id: string, viewUsers: boolean, updateUsers: boolean, removeUsers: boolean, editUserPermissions: boolean, viewBooks: boolean, updateBooks: boolean, removeBooks: boolean, editChapters: boolean, viewEbooks: boolean, updateEbooks: boolean, removeEbooks: boolean, editEbooks: boolean, viewProductSets: boolean, updateProductSets: boolean, removeProductSets: boolean, feeds: boolean, sections: boolean, vouchers: boolean, metrics: boolean, bestSeller: boolean, transactions: boolean, exportRaws: boolean, taxDeductions: boolean, tags: boolean, pintoWriterCampaign: boolean } | null } | null };

export type EbookOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type EbookOptionsQuery = { __typename?: 'RootQuery', languageOptions: { __typename?: 'EbookOptions', languages: Array<{ __typename?: 'Language', code: string, name: string }> }, applePriceTierOptions: { __typename?: 'EbookOptions', priceTiers: Array<{ __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number }> }, googlePriceTierOptions: { __typename?: 'EbookOptions', priceTiers: Array<{ __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number }> } };

export type EbookSubmissionQueryVariables = Exact<{
  ebookSubmissionId: Scalars['ID']['input'];
}>;


export type EbookSubmissionQuery = { __typename?: 'RootQuery', ebookSubmission: { __typename?: 'PintoEbookSubmission', _id: string, status: PintoEbookSubmissionStatus, itemCount: number, fileName: string, fileUrl: string, adminNote?: string | null, cancelledAt?: any | null, createdAt: any, updatedAt: any, actor: { __typename?: 'User', _id?: string | null, username?: string | null }, itemStatusCounts: Array<{ __typename?: 'PintoEbookSubmissionItemStatusCount', status: PintoEbookSubmissionItemStatus, count: number }> } };

export type EbookSubmissionItemsQueryVariables = Exact<{
  ebookSubmissionId: Scalars['ID']['input'];
  filter?: InputMaybe<PintoEbookSubmissionItemsFilter>;
}>;


export type EbookSubmissionItemsQuery = { __typename?: 'RootQuery', ebookSubmissionItems: { __typename?: 'PintoEbookSubmissionItemConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'PintoEbookSubmissionItemEdge', node: { __typename?: 'PintoEbookSubmissionItem', _id: string, status: PintoEbookSubmissionItemStatus, data: any, errorNote?: string | null, cancelledAt?: any | null, ebookId?: string | null, ebook?: { __typename?: 'Ebook', _id: string, status: EbookStatus, publishedAt?: any | null } | null } }> } };

export type EbookSubmissionsQueryVariables = Exact<{
  filter?: InputMaybe<PintoEbookSubmissionsFilter>;
}>;


export type EbookSubmissionsQuery = { __typename?: 'RootQuery', ebookSubmissions: { __typename?: 'PintoEbookSubmissionConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'PintoEbookSubmissionEdge', node: { __typename?: 'PintoEbookSubmission', _id: string, status: PintoEbookSubmissionStatus, itemCount: number, fileName: string, fileUrl: string, adminNote?: string | null, cancelledAt?: any | null, createdAt: any, updatedAt: any, actor: { __typename?: 'User', _id?: string | null, username?: string | null }, itemStatusCounts: Array<{ __typename?: 'PintoEbookSubmissionItemStatusCount', status: PintoEbookSubmissionItemStatus, count: number }> } }> } };

export type PendingEbookInSubscriptionTitleQueryVariables = Exact<{
  subscriptionTitleId: Scalars['ID']['input'];
}>;


export type PendingEbookInSubscriptionTitleQuery = { __typename?: 'RootQuery', pendingEbookInSubscriptionTitle: Array<{ __typename?: 'PendingEbook', ebookTitle?: string | null, ebookStatus?: EbookStatus | null }> };

export type PintoAnnouncementNotificationsQueryVariables = Exact<{
  filter?: InputMaybe<PintoAnnouncementNotificationsFilter>;
}>;


export type PintoAnnouncementNotificationsQuery = { __typename?: 'RootQuery', pintoAnnouncementNotifications: { __typename?: 'PintoAnnouncementNotificationConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'PintoAnnouncementNotificationEdge', cursor: string, node: { __typename?: 'PintoAnnouncementNotification', _id: string, title: string, subTitle?: string | null, description: string, clickActionType?: PintoAnnouncementNotificationClickActionType | null, clickActionData?: string | null, notified: boolean, notifiedAt: any, topics: Array<PintoAnnouncementNotificationTopic>, type: PintoAnnouncementNotificationType, userIds?: Array<string> | null, createdAt: any, updatedAt: any, platforms: Array<ClientPlatform> } }> } };

export type PintoCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type PintoCategoriesQuery = { __typename?: 'RootQuery', pintoCategories: Array<{ __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null, childrens?: Array<{ __typename: 'PintoCategory', parentId?: number | null, _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null, parent?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null } | null, childrens?: Array<{ __typename: 'PintoCategory', parentId?: number | null, _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null, parent?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null } | null, childrens?: Array<{ __typename: 'PintoCategory', parentId?: number | null, _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null, parent?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null } | null } | null> | null } | null> | null } | null> | null } | null> };

export type PintoEbookQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PintoEbookQuery = { __typename?: 'RootQuery', ebook?: { __typename?: 'Ebook', _id: string, title?: string | null, description?: string | null, coverImageUrl?: string | null, bannerImageUrl?: string | null, status: EbookStatus, correctionEbookStatus?: CorrectionEbookStatus | null, synopsis?: any | null, isFree: boolean, readingType: ReadingType, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, authorNames?: Array<string | null> | null, translatorNames?: Array<string | null> | null, viewsCount?: number | null, purchasesCount: number, totalSales: number, earningsRatio: number, originalPriceThb?: number | null, priceThb?: number | null, discountRatio?: number | null, coverPriceThb?: number | null, isbn?: string | null, pagesCount?: number | null, productSetId?: string | null, productSetVol?: number | null, writingType: EbookWritingType, subscriptionTitleId?: string | null, appleOriginalPriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null, googleOriginalPriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null, discount?: { __typename?: 'EbookDiscount', endedAt?: any | null, ratio?: number | null, startedAt: any, thb?: number | null, googlePriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null, applePriceTier?: { __typename?: 'AppPriceTier', _id: string, platform: AppPriceTierPlatform, thb: number, usd: number } | null } | null, originalLanguage: { __typename?: 'Language', name: string, code: string }, language: { __typename?: 'Language', name: string, code: string }, productSet?: { __typename?: 'PintoProductSet', _id: string, title?: string | null, itemsCount: number } | null, ebookFiles: Array<{ __typename?: 'EbookFile', mainFileUrl?: string | null, mainFilename?: string | null, sampleFileUrl?: string | null, sampleFilename?: string | null, sizeInKB: number, type: EbookFileType }>, tags: Array<{ __typename?: 'Tag', _id: string, name: string }>, category?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null, parent?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null, parent?: { __typename: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, slug?: string | null } | null } | null } | null, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null, profileImage?: string | null, type: UserType, email?: string | null, isPremium: boolean }, summaryEbookLog?: { __typename?: 'SummaryEbookLog', created?: { __typename?: 'EbookLog', actor: { __typename?: 'User', displayName?: string | null } } | null, latestUpdated?: { __typename?: 'EbookLog', actor: { __typename?: 'User', displayName?: string | null } } | null } | null, correction?: { __typename?: 'CorrectionEbook', status: CorrectionEbookStatus, rejectNotes?: Array<string> | null, category?: { __typename?: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, parentId?: number | null, parent?: { __typename?: 'PintoCategory', _id: string, name: string, canSetPrice: boolean, contentType: ContentType, parentId?: number | null, parent?: { __typename?: 'PintoCategory', name: string, _id: string } | null } | null } | null, correctionEbookFiles: Array<{ __typename?: 'CorrectionEbookFile', mainFileUrl?: string | null, sampleFileUrl?: string | null, type: EbookFileType, mainFilename?: string | null, sampleFilename?: string | null, status: CorrectionEbookFileStatus }> } | null, subscriptionTitle?: { __typename?: 'SubscriptionTitle', _id: string, title: string } | null } | null };

export type PintoEbookBundleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PintoEbookBundleQuery = { __typename?: 'RootQuery', ebookBundle: { __typename?: 'EbookBundle', _id: string, title?: string | null, description?: string | null, coverImageUrl?: string | null, bannerImageUrl?: string | null, ebookCount: number, status: EbookBundleStatus, createdAt: any, updatedAt: any, startedAt?: any | null, priceThb?: number | null, originalPriceThb?: number | null, discountRatio?: number | null, googleDiscountRatio?: number | null, userId: string } };

export type PintoEbookBundleSubmissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PintoEbookBundleSubmissionsQuery = { __typename?: 'RootQuery', ebookBundleSubmissions: Array<{ __typename?: 'EbookBundleSubmission', _id: string, fileName: string, createdAt: any, adminNote: string, ebookBundleCount: number } | null> };

export type PintoEbookCollectionQueryVariables = Exact<{
  ebookCollectionId: Scalars['ID']['input'];
}>;


export type PintoEbookCollectionQuery = { __typename?: 'RootQuery', pintoEbookCollection: { __typename?: 'PintoEbookCollection', _id: string, title: string, description: string, emoji: string, hexColorCode: string, darkModeHexColorCode: string, ogImageUrl: string, ebookCoverImageUrls: Array<string>, itemCount: number, status: PintoEbookCollectionStatus, createdAt: any, updatedAt: any, publishedAt?: any | null, deletedAt?: any | null, userId: string, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null, profileImage?: string | null, type: UserType, email?: string | null, isPremium: boolean } } };

export type PintoEbookCollectionItemsQueryVariables = Exact<{
  ebookCollectionId: Scalars['ID']['input'];
  filter?: InputMaybe<PintoEbookCollectionItemsFilter>;
}>;


export type PintoEbookCollectionItemsQuery = { __typename?: 'RootQuery', pintoEbookCollectionItems: { __typename?: 'EbookConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'EbookEdge', cursor: string, node: { __typename?: 'Ebook', _id: string, coverImageUrl?: string | null } }> } };

export type PintoEbookCollectionsQueryVariables = Exact<{
  filter?: InputMaybe<PintoEbookCollectionsFilter>;
}>;


export type PintoEbookCollectionsQuery = { __typename?: 'RootQuery', pintoEbookCollections: { __typename?: 'PintoEbookCollectionConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'PintoEbookCollectionEdge', cursor: string, node: { __typename?: 'PintoEbookCollection', _id: string, title: string, description: string, emoji: string, hexColorCode: string, darkModeHexColorCode: string, ogImageUrl: string, ebookCoverImageUrls: Array<string>, itemCount: number, status: PintoEbookCollectionStatus, createdAt: any, updatedAt: any, publishedAt?: any | null, deletedAt?: any | null, userId: string, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null, profileImage?: string | null, type: UserType, email?: string | null, isPremium: boolean } } }> } };

export type PintoEbookDiscountCampaignQueryVariables = Exact<{
  ebookDiscountCampaignId: Scalars['ID']['input'];
}>;


export type PintoEbookDiscountCampaignQuery = { __typename?: 'RootQuery', ebookDiscountCampaign: { __typename?: 'EbookDiscountCampaign', _id: string, title: string, status: EbookDiscountCampaignStatus, startedAt: any, endedAt?: any | null, fileName: string, fileUrl: string, createdAt: any, updatedAt: any } };

export type PintoEbookDiscountCampaignsQueryVariables = Exact<{
  filter?: InputMaybe<EbookDiscountCampaignsFilter>;
}>;


export type PintoEbookDiscountCampaignsQuery = { __typename?: 'RootQuery', ebookDiscountCampaigns: { __typename?: 'EbookDiscountCampaignConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'EbookDiscountCampaignEdge', node: { __typename?: 'EbookDiscountCampaign', _id: string, title: string, status: EbookDiscountCampaignStatus, startedAt: any, endedAt?: any | null, fileName: string, fileUrl: string, createdAt: any, updatedAt: any } }> } };

export type PintoEbooksQueryVariables = Exact<{
  filter?: InputMaybe<EbooksFilter>;
}>;


export type PintoEbooksQuery = { __typename?: 'RootQuery', ebooks?: { __typename?: 'EbookConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'EbookEdge', node: { __typename?: 'Ebook', _id: string, title?: string | null, coverImageUrl?: string | null, status: EbookStatus, correctionEbookStatus?: CorrectionEbookStatus | null, updatedAt?: any | null, originalLanguage: { __typename?: 'Language', name: string, code: string }, language: { __typename?: 'Language', name: string, code: string }, category?: { __typename?: 'PintoCategory', _id: string, name: string } | null, correction?: { __typename?: 'CorrectionEbook', categoryId?: string | null, category?: { __typename?: 'PintoCategory', _id: string, contentType: ContentType, canSetPrice: boolean, name: string, parentId?: number | null, parent?: { __typename?: 'PintoCategory', _id: string, contentType: ContentType, canSetPrice: boolean, name: string, parentId?: number | null } | null } | null } | null, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null } } }> } | null };

export type PintoFeedQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  pref: Preference;
}>;


export type PintoFeedQuery = { __typename?: 'RootQuery', pintoFeed?: { __typename?: 'Feed', _id?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, title?: string | null, description?: string | null, coverImage?: string | null, bannerImage?: string | null, meta?: any | null, slug?: string | null, createdAt?: any | null, updatedAt?: any | null, sections?: Array<{ __typename?: 'Section', _id?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, camelCaseLayoutId?: SectionLayoutId | null, isNCContent?: boolean | null, isActivated?: boolean | null, title?: string | null, configItems?: Array<any | null> | null, items?: Array<any | null> | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, startedAt?: any | null, endedAt?: any | null, target?: { __typename: 'Explore', exploreType?: ExploreType | null, completed?: boolean | null, sortBy?: string | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null } | { __typename: 'ExploreProductSet', sortBy?: string | null, sortType?: SortType | null, categoryId?: string | null } | { __typename: 'Feed', feedId?: string | null } | { __typename: 'Link', url?: string | null } | { __typename: 'SearchLink', searchType?: SearchType | null, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null } | { __typename: 'SectionTargetExploreEbookBundle' } | { __typename: 'SectionTargetExploreEbookRecommendation' } | { __typename: 'SectionTargetProductSet', sectionTargetProductSetId?: string | null } | { __typename: 'SectionTargetSection', sectionTargetSectionId?: string | null } | { __typename: 'User', userId?: string | null } | null } | null> | null } | null };

export type PintoFeedsQueryVariables = Exact<{
  filter?: InputMaybe<FeedsFilterV2>;
}>;


export type PintoFeedsQuery = { __typename?: 'RootQuery', pintoFeeds: { __typename?: 'FeedConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'FeedEdge', cursor: string, node: { __typename?: 'Feed', _id?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, title?: string | null, description?: string | null, coverImage?: string | null, bannerImage?: string | null, meta?: any | null, slug?: string | null, createdAt?: any | null, updatedAt?: any | null, sections?: Array<{ __typename?: 'Section', _id?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, camelCaseLayoutId?: SectionLayoutId | null, isNCContent?: boolean | null, isActivated?: boolean | null, title?: string | null, configItems?: Array<any | null> | null, items?: Array<any | null> | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, startedAt?: any | null, endedAt?: any | null, target?: { __typename: 'Explore', exploreType?: ExploreType | null, completed?: boolean | null, sortBy?: string | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null } | { __typename: 'ExploreProductSet', sortBy?: string | null, sortType?: SortType | null, categoryId?: string | null } | { __typename: 'Feed', feedId?: string | null } | { __typename: 'Link', url?: string | null } | { __typename: 'SearchLink', searchType?: SearchType | null, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null } | { __typename: 'SectionTargetExploreEbookBundle' } | { __typename: 'SectionTargetExploreEbookRecommendation' } | { __typename: 'SectionTargetProductSet', sectionTargetProductSetId?: string | null } | { __typename: 'SectionTargetSection', sectionTargetSectionId?: string | null } | { __typename: 'User', userId?: string | null } | null } | null> | null } }> } };

export type PintoProductSetQueryVariables = Exact<{
  productSetId: Scalars['ID']['input'];
}>;


export type PintoProductSetQuery = { __typename?: 'RootQuery', pintoProductSet: { __typename?: 'PintoProductSet', _id: string, activatedAt: any, coverImageUrl?: string | null, createdAt: any, description?: string | null, itemsCount: number, hasItemVol: boolean, publishedAt?: any | null, status: ProductSetStatus, title?: string | null, updatedAt: any, user: { __typename: 'User', _id?: string | null, username?: string | null } } };

export type PintoProductSetsQueryVariables = Exact<{
  filter?: InputMaybe<PintoProductSetsFilter>;
}>;


export type PintoProductSetsQuery = { __typename?: 'RootQuery', pintoProductSets: { __typename?: 'PintoProductSetConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'PintoProductSetEdge', node: { __typename?: 'PintoProductSet', _id: string, activatedAt: any, coverImageUrl?: string | null, createdAt: any, description?: string | null, itemsCount: number, hasItemVol: boolean, publishedAt?: any | null, status: ProductSetStatus, title?: string | null, updatedAt: any, user: { __typename: 'User', _id?: string | null, username?: string | null } } }> } };

export type PintoSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PintoSectionQuery = { __typename?: 'RootQuery', pintoSection?: { __typename?: 'Section', _id?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, camelCaseLayoutId?: SectionLayoutId | null, isNCContent?: boolean | null, isActivated?: boolean | null, title?: string | null, imageUrl?: string | null, dayBgImageUrl?: string | null, darkBgImageUrl?: string | null, configItems?: Array<any | null> | null, items?: Array<any | null> | null, note?: string | null, createdAt?: any | null, updatedAt?: any | null, target?: { __typename: 'Explore', exploreType?: ExploreType | null, sortBy?: string | null, sortType?: SortType | null, categoryId?: string | null, gteRating?: number | null, anyPriceTypes?: Array<EbookPriceType> | null, anyTypes?: Array<EbookType> | null, anyFileTypes?: Array<FileType> | null, anyWritingTypes?: Array<EbookWritingType> | null } | { __typename: 'ExploreProductSet', sortBy?: string | null, sortType?: SortType | null, categoryId?: string | null } | { __typename: 'Feed', _id?: string | null, slug?: string | null } | { __typename: 'Link', url?: string | null } | { __typename: 'SearchLink', searchType?: SearchType | null, searchText?: string | null, searchField?: string | null, categoryId?: string | null, sortBy?: string | null, sortType?: SortType | null, gteRating?: number | null, anyTypes?: Array<EbookType> | null, anyPriceTypes?: Array<EbookPriceType> | null, anyWritingTypes?: Array<EbookWritingType> | null } | { __typename: 'SectionTargetExploreEbookBundle', sortType?: SortType | null, categoryId?: string | null, hasDiscount?: boolean | null, bundleExploreType?: SectionTargetExploreEbookBundleType | null, bundleSortBy?: SectionTargetExploreEbookBundleSortBy | null } | { __typename: 'SectionTargetExploreEbookRecommendation' } | { __typename: 'SectionTargetProductSet' } | { __typename: 'SectionTargetSection' } | { __typename: 'User', _id?: string | null } | null } | null };

export type PintoSectionsQueryVariables = Exact<{
  filter?: InputMaybe<SectionsFilterV2>;
}>;


export type PintoSectionsQuery = { __typename?: 'RootQuery', pintoSections: { __typename?: 'SectionConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'SectionEdge', node: { __typename?: 'SectionV3', _id: string, note?: string | null, isNCContent?: boolean | null, updatedAt: any, camelCaseLayoutId?: SectionLayoutId | null } }> } };

export type PintoSubscriptionEbooksQueryVariables = Exact<{
  filter?: InputMaybe<EbooksFilter>;
}>;


export type PintoSubscriptionEbooksQuery = { __typename?: 'RootQuery', ebooks?: { __typename?: 'EbookConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'EbookEdge', node: { __typename?: 'Ebook', _id: string, title?: string | null, status: EbookStatus, createdAt?: any | null, updatedAt?: any | null } }> } | null };

export type PintoSubscriptionTitleQueryVariables = Exact<{
  subscriptionTitleId: Scalars['ID']['input'];
}>;


export type PintoSubscriptionTitleQuery = { __typename?: 'RootQuery', subscriptionTitle: { __typename?: 'SubscriptionTitle', _id: string, title: string, slug?: string | null, ebooksCount: number, publishedEbooksCount: number, createdAt: any, updatedAt: any, user: { __typename?: 'User', _id?: string | null, displayName?: string | null, username?: string | null, profileImage?: string | null, type: UserType, email?: string | null, isPremium: boolean }, packages?: Array<{ __typename?: 'SubscriptionTitlePackage', _id: string, title: string, packageType: SubscriptionTitlePackageType, applePriceTierId?: string | null, googlePriceTierId?: string | null, priceThb?: number | null, period?: string | null, appleProductId?: string | null, googleProductId?: string | null, isEnabled: boolean, deletedAt?: any | null, createdAt: any, updatedAt: any, applePriceTier?: { __typename?: 'SubscriptionTitlePriceTier', _id: string, thb: number, usd: number } | null, googlePriceTier?: { __typename?: 'SubscriptionTitlePriceTier', _id: string, thb: number, usd: number } | null } | null> | null } };

export type PintoVoucherQueryVariables = Exact<{
  code: Scalars['ID']['input'];
}>;


export type PintoVoucherQuery = { __typename?: 'RootQuery', pintoVoucher: { __typename?: 'PintoVoucher', code: string, conditions: Array<string>, description?: string | null, createdAt: any, display: boolean, discountAmount: number, discountThb: number, discountType: PintoVoucherDiscountType, expiredAt?: any | null, startedAt: any, enabled: boolean, isMembershipEarlyBird: boolean, isMembershipOnly: boolean, maximumDiscountAmount?: number | null, maximumRedeemedCounts?: number | null, maximumRedeemedCountsPerMembership?: number | null, maximumRedeemedCountsPerUser?: number | null, membershipStartedAt?: any | null, minimumSpendThb: number, myRedeemedCounts: number, redeemedCounts: number, subType: PintoVoucherSubType, status: PintoVoucherStatus, title: string, type: PintoVoucherType, participatingItems?: { __typename?: 'PintoVoucherParticipatingItem', itemType: PintoVoucherParticipatingItemType, itemIds: Array<string>, items?: Array<{ __typename?: 'PintoCategory', _id: string, name: string } | { __typename?: 'User', username?: string | null }> | null } | null } };

export type PintoVouchersQueryVariables = Exact<{
  filter?: InputMaybe<PintoVouchersFilter>;
}>;


export type PintoVouchersQuery = { __typename?: 'RootQuery', pintoVouchers: { __typename?: 'PintoVoucherConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'PintoVoucherEdge', cursor: string, node: { __typename?: 'PintoVoucher', code: string, conditions: Array<string>, description?: string | null, createdAt: any, display: boolean, discountAmount: number, discountThb: number, discountType: PintoVoucherDiscountType, expiredAt?: any | null, startedAt: any, enabled: boolean, isMembershipEarlyBird: boolean, isMembershipOnly: boolean, maximumDiscountAmount?: number | null, maximumRedeemedCounts?: number | null, maximumRedeemedCountsPerMembership?: number | null, maximumRedeemedCountsPerUser?: number | null, membershipStartedAt?: any | null, minimumSpendThb: number, myRedeemedCounts: number, redeemedCounts: number, subType: PintoVoucherSubType, status: PintoVoucherStatus, title: string, type: PintoVoucherType, participatingItems?: { __typename?: 'PintoVoucherParticipatingItem', itemType: PintoVoucherParticipatingItemType, itemIds: Array<string>, items?: Array<{ __typename?: 'PintoCategory', _id: string, name: string } | { __typename?: 'User', username?: string | null }> | null } | null } }> } };

export type PintoWriterCampaignQueryVariables = Exact<{
  productCampaignId: Scalars['ID']['input'];
}>;


export type PintoWriterCampaignQuery = { __typename?: 'RootQuery', pintoWriterCampaign: { __typename?: 'PintoProductCampaign', _id: string, title: string, status: PintoProductCampaignStatus, userType: PintoProductCampaignUserType, productTypes: Array<PintoProductCampaignProductType>, isActive: boolean, startedAt: any, endedAt: any, registrationStartedAt: any, registrationEndedAt: any, minimumDiscountRatio?: number | null, categoryIds?: Array<number> | null, exceptCategoryIds?: Array<number> | null, conditions?: Array<string> | null, tags?: Array<string> | null, bannerImageUrl: string, exampleProductPromoteImageUrl: string, templateOgImageUrl: string, createdAt: any, updatedAt: any } };

export type PintoWriterCampaignsQueryVariables = Exact<{
  filter?: InputMaybe<PintoProductCampaignsFilter>;
}>;


export type PintoWriterCampaignsQuery = { __typename?: 'RootQuery', pintoWriterCampaigns: { __typename?: 'PintoProductCampaignConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'PintoProductCampaignEdge', node: { __typename?: 'PintoProductCampaign', _id: string, title: string, status: PintoProductCampaignStatus, userType: PintoProductCampaignUserType, productTypes: Array<PintoProductCampaignProductType>, isActive: boolean, startedAt: any, endedAt: any, registrationStartedAt: any, registrationEndedAt: any, minimumDiscountRatio?: number | null, categoryIds?: Array<number> | null, exceptCategoryIds?: Array<number> | null, conditions?: Array<string> | null, tags?: Array<string> | null, bannerImageUrl: string, exampleProductPromoteImageUrl: string, templateOgImageUrl: string, createdAt: any, updatedAt: any } }> } };

export type PopupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PopupQuery = { __typename?: 'RootQuery', popup?: { __typename?: 'Popup', _id: string, pref: FeedPref, type: PopupType, updatedAt?: any | null, createdAt?: any | null, isActivated: boolean, itemsCount: { __typename?: 'PopupItemsCount', activeItems: number, totalItems: number }, items: Array<{ __typename?: 'PopupItem', _id: string, type: PopupItemType, note?: string | null, config: { __typename: 'PopupItemConfigBook', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigEbook', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigExploreBook', contentType: ContentType, completed?: boolean | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, popupImageUrl: string, sortByBook?: ExploreBookSortBy | null } | { __typename: 'PopupItemConfigExploreEbook', contentType: ContentType, categoryTagId?: string | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, popupImageUrl: string, sortByEbook?: ExploreEbookSortBy | null } | { __typename: 'PopupItemConfigFeed', slug: string, popupImageUrl: string } | { __typename: 'PopupItemConfigLink', url: string, popupImageUrl: string } | { __typename: 'PopupItemConfigProductSet', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigSearch', searchType: SearchType, contentType: ContentType, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, categoryTagId?: string | null, popupImageUrl: string } | { __typename: 'PopupItemConfigSection', _id: string, popupImageUrl: string } | { __typename: 'PopupItemConfigStatic', popupImageUrl: string }, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, startedAt?: any | null, endedAt?: any | null } | null> | null }>, unionItems: Array<{ __typename: 'Book', bookId?: string | null } | { __typename: 'Ebook', ebookId: string } | { __typename: 'EbookBundle' } | { __typename: 'Explore' } | { __typename: 'Feed', _id?: string | null } | { __typename: 'Link' } | { __typename: 'ProductSet' } | { __typename: 'SearchLink' } | { __typename: 'Section', _id?: string | null, title?: string | null, note?: string | null, isNCContent?: boolean | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null } | { __typename: 'Static' }> } | null };

export type PopupsQueryVariables = Exact<{
  filter?: InputMaybe<PopupsFilter>;
}>;


export type PopupsQuery = { __typename?: 'RootQuery', popups: { __typename?: 'PopupConnection', edges: Array<{ __typename?: 'PopupEdge', node: { __typename?: 'Popup', _id: string, pref: FeedPref, type: PopupType, updatedAt?: any | null, createdAt?: any | null, isActivated: boolean, itemsCount: { __typename?: 'PopupItemsCount', activeItems: number, totalItems: number } } }> } };

export type PreviewSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PreviewSectionQuery = { __typename?: 'RootQuery', previewSection: { __typename?: 'SectionV3', _id: string, camelCaseLayoutId?: SectionLayoutId | null, title?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, note?: string | null, isNCContent?: boolean | null, isActivated?: boolean | null, unionItems: Array<{ __typename: 'Book', title?: string | null, viewsCount?: number | null, coverImage?: string | null, completed?: boolean | null, placeholderBackgroundColor?: string | null, authorName?: string | null, translatorName?: string | null, bookId?: string | null, categoryTag?: { __typename?: 'Tag', _id: string, name: string } | null, contentRating?: { __typename?: 'ContentRating', _id?: string | null, name?: string | null } | null, sectionItemUser?: { __typename?: 'User', displayName?: string | null } | null } | { __typename: 'Ebook', _id: string, coverImage?: string | null, title?: string | null, placeholderBackgroundColor?: string | null, authorName?: string | null, translatorName?: string | null, discountPriceTierDetail?: any | null, categoryTag?: { __typename?: 'Tag', name: string } | null, contentRating?: { __typename?: 'ContentRating', _id?: string | null, name?: string | null } | null, user: { __typename?: 'User', displayName?: string | null } } | { __typename: 'EbookBundle' } | { __typename: 'Explore' } | { __typename: 'Feed' } | { __typename: 'Link' } | { __typename: 'ProductSet' } | { __typename: 'SearchLink' } | { __typename: 'Section' } | { __typename: 'Static' }>, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, startedAt?: any | null, endedAt?: any | null } | null> | null, target?: { __typename: 'Explore', exploreType?: ExploreType | null, completed?: boolean | null, sortBy?: string | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null, contentRatingIds?: Array<string> | null } | { __typename: 'ExploreProductSet', sortBy?: string | null, sortType?: SortType | null, categoryId?: string | null } | { __typename: 'Feed', feedId?: string | null } | { __typename: 'Link', url?: string | null } | { __typename: 'SearchLink', searchType?: SearchType | null, searchText?: string | null, completed?: boolean | null, contentRatingIds?: Array<string> | null, isFree?: boolean | null, contentType?: ContentType | null, categoryTagId?: string | null } | { __typename: 'SectionTargetExploreEbookBundle' } | { __typename: 'SectionTargetExploreEbookRecommendation' } | { __typename: 'SectionTargetProductSet', sectionTargetProductSetId?: string | null } | { __typename: 'SectionTargetSection', sectionTargetSectionId?: string | null } | { __typename: 'User', userId?: string | null } | null } };

export type RequestedEbookFilesQueryVariables = Exact<{
  filter?: InputMaybe<EditEbookFilter>;
}>;


export type RequestedEbookFilesQuery = { __typename?: 'RootQuery', requestedEbookFiles?: { __typename?: 'EditEbookConnection', totalCount?: number | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null } | null, edges?: Array<{ __typename?: 'EditEbookEdge', node?: { __typename?: 'EditEbook', _id: string, ebookId?: string | null, status?: EditEbookStatus | null, categoryId?: number | null, userNote?: string | null, rejectNotes?: Array<string | null> | null, activatedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, correctionEbookFiles: Array<{ __typename?: 'EditEbookFile', type: EbookFileType, sampleFilename?: string | null, sampleFileUrl?: string | null, mainFilename?: string | null, mainFileUrl?: string | null, requestedFileUrl?: string | null, requestedFileName?: string | null, requestedFileType?: string | null, status?: CorrectionEbookFileStatus | null, requestedSampleFileType?: CorrectionEbookRequestedSampleFileType | null, lastSampleChapterNumber?: number | null, lastSampleChapterName?: string | null, isAutoGenerateSampleFile?: boolean | null }>, ebook?: { __typename?: 'Ebook', _id: string, title?: string | null, coverImageUrl?: string | null, status: EbookStatus, user: { __typename?: 'User', _id?: string | null, username?: string | null } } | null } | null } | null> | null } | null };

export type SearchTagsQueryVariables = Exact<{
  filter?: InputMaybe<SearchTagsFilter>;
  q?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchTagsQuery = { __typename?: 'RootQuery', searchTags: { __typename?: 'TagConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename?: 'TagEdge', node: { __typename?: 'Tag', _id: string, name: string, productsCount: number, searchesCount: number } }> } };

export type SearchUsersQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchUsersFilter>;
}>;


export type SearchUsersQuery = { __typename?: 'RootQuery', searchUsers: { __typename?: 'UserConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', _id?: string | null, username?: string | null, email?: string | null, displayName?: string | null, profileImage?: string | null, type: UserType, isPremium: boolean } }> } };

export type SectionPaginationQueryVariables = Exact<{
  filter?: InputMaybe<SectionsFilterV2>;
}>;


export type SectionPaginationQuery = { __typename?: 'RootQuery', sectionPagination?: { __typename?: 'SectionConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, edges: Array<{ __typename?: 'SectionEdge', cursor: string, node: { __typename?: 'SectionV3', _id: string, camelCaseLayoutId?: SectionLayoutId | null, title?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, note?: string | null, isNCContent?: boolean | null, isActivated?: boolean | null, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, startedAt?: any | null, endedAt?: any | null } | null> | null } }> } | null };

export type TemplateByQueryQueryVariables = Exact<{
  filter?: InputMaybe<TemplateFilter>;
}>;


export type TemplateByQueryQuery = { __typename?: 'RootQuery', templateByQuery?: { __typename?: 'Template', _id: string, contentType?: ContentType | null, isActivated: boolean, placement: TemplatePlacement, pref?: FeedPref | null, slug?: string | null, productType?: ProductType | null, updatedAt: any, categoryTag?: { __typename?: 'Tag', _id: string, name: string } | null, meta?: { __typename?: 'TemplateMeta', ogImage?: string | null, ogTitle?: string | null, ogDescription?: string | null } | null, sections: Array<{ __typename?: 'SectionV3', _id: string, camelCaseLayoutId?: SectionLayoutId | null, title?: string | null, pref?: FeedPref | null, productType?: ProductType | null, contentType?: ContentType | null, note?: string | null, isNCContent?: boolean | null, isActivated?: boolean | null, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, startedAt?: any | null, endedAt?: any | null } | null> | null }> } | null };

export type TemplatesQueryVariables = Exact<{
  filter?: InputMaybe<TemplatesFilter>;
}>;


export type TemplatesQuery = { __typename?: 'RootQuery', templates: { __typename?: 'TemplateConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename?: 'TemplateEdge', cursor: string, node: { __typename?: 'Template', _id: string, contentType?: ContentType | null, isActivated: boolean, placement: TemplatePlacement, pref?: FeedPref | null, productType?: ProductType | null, updatedAt: any, categoryTag?: { __typename?: 'Tag', _id: string, name: string } | null } }> } };

export type UserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserQuery = { __typename?: 'RootQuery', user?: { __typename?: 'User', _id?: string | null, username?: string | null, email?: string | null, displayName?: string | null, profileImage?: string | null, type: UserType, isPremium: boolean } | null };
